
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dv1ov", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $3wZF4 = parcelRequire("3wZF4");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");


var $hDUYn = parcelRequire("hDUYn");



var $fR7EZ = parcelRequire("fR7EZ");


var $bDWrn = parcelRequire("bDWrn");

const $fa20c6cebfd0e652$export$3aaf902e00a8e4ba = (0, $bHHWv.inMemoryCache)();
const $fa20c6cebfd0e652$export$69a3209f1a06c04d = $fa20c6cebfd0e652$export$3aaf902e00a8e4ba;
const $fa20c6cebfd0e652$export$a4f9b7f788f9e71f = (variables, originalQuery)=>{
    /**
   * Results once fetched will be used for upto 15 minutes from an in memory cache.
   * 1. Generate key based on query, entities, filters
   * 2. Serve from cache if present without resetting the expiration, evict if results are expired
   * 3. If not present or expired then invoke the api
   * 4. If API is invoked then store response in the cache with expiration and return back the response
   */ const keyObj = {
        query: variables.query,
        entities: variables.entities,
        commonFilters: variables.commonFilters,
        confluenceFilters: variables.confluenceFilters,
        jiraFilters: variables.jiraFilters,
        mercuryFilters: variables.mercuryFilters,
        compassFilters: variables.compassFilters,
        assetsFilters: variables.assetsFilters,
        thirdPartyFilters: variables.thirdPartyFilters,
        loomFilters: 'loomFilters' in variables ? variables.loomFilters : undefined,
        cloudIdARI: variables.cloudIdARI,
        sortField: variables.sort.at(0)?.field ?? '',
        sortOrder: variables.sort.at(0)?.order ?? '',
        after: variables.after,
        originalQuery: originalQuery,
        ...'skipJiraHydration' in variables && variables.skipJiraHydration ? {
            skipJiraHydration: true
        } : {}
    };
    return (0, $bZF61.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or edges are empty
const $fa20c6cebfd0e652$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || !data.search || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $fa20c6cebfd0e652$var$searchQuery = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, useCache: useCache, operationName: operationName, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks })=>{
    // Default experience is search-page
    variables.experience = variables.experience || 'search-page';
    // Default skip3pEntityHydration is false
    variables.skip3pEntityHydration = variables.skip3pEntityHydration || variables.skipFieldsFor3pInQuickFind || false;
    // Disable GitHub hydration when skip3pEntityHydration is false to avoid duplication
    variables.includeGithubEntityHydration = !variables.skip3pEntityHydration ? false : variables.includeGithubEntityHydration || false;
    variables.includeLoomVideoMetadata = variables.includeLoomVideoMetadata || false;
    variables.includeSpaceSubtype = variables.includeSpaceSubtype || false;
    variables.skipFieldsFor3pInQuickFind = variables.skipFieldsFor3pInQuickFind || false;
    variables.includeDatasourceId = typeof variables.includeDatasourceId === 'boolean' ? variables.includeDatasourceId : (0, $iDrrr.fg)('rovo_search_enable_datasource_id_analytics');
    // Since the default experience is search-page, default experience is to include social signals
    variables.includeSocialSignals = variables.includeSocialSignals === undefined ? true : variables.includeSocialSignals;
    variables.includeJiraIssueType = variables.includeJiraIssueType || false;
    variables.includeJiraBoardContainer = variables.includeJiraBoardContainer || false; // Used to include the container field
    // rovo_qf_jira_fast_hydration: gates the lighter value-field Jira issue hydration via
    // @include/@skip in the query. Defaults off so the query is unchanged unless a caller opts in.
    variables.includeFastJiraHydration = variables.includeFastJiraHydration || false;
    // Option to hydrate the confluenceEntity field
    variables.includeConfluenceEntity = typeof variables.includeConfluenceEntity === 'boolean' ? variables.includeConfluenceEntity : true;
    variables.includeAutocompleteSuggestions = variables.includeAutocompleteSuggestions || false;
    const graphQuery = (0, $bDWrn.queryGenerator)(operationName, serveUserShardUI);
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    if (useCache) return $fa20c6cebfd0e652$export$3aaf902e00a8e4ba.inMemoryDecorator($fa20c6cebfd0e652$export$a4f9b7f788f9e71f(variables, originalQuery), (0, $hDUYn.withNetworkCallback)(()=>(0, $b0Mpu.fetchAgg)({
            variables: requestVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks), $fa20c6cebfd0e652$var$expireWhen);
    else return (0, $hDUYn.withNetworkCallback)(()=>(0, $b0Mpu.fetchAgg)({
            variables: requestVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks)();
};
const $fa20c6cebfd0e652$export$8d55189398f4cde7 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers })=>{
    return $fa20c6cebfd0e652$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: true,
        operationName: (0, $bDWrn.SEARCH_PAGE_OPERATION_NAME),
        serveUserShardUI: serveUserShardUI,
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$b62744f7ecc07873 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks, operationName: operationName = (0, $bDWrn.SEARCH_DIALOG_OPERATION_NAME) })=>{
    return $fa20c6cebfd0e652$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: false,
        operationName: // Bypassing cache to match previous Quick Find behavior
        operationName,
        serveUserShardUI: serveUserShardUI,
        headers: headers,
        networkCallbacks: networkCallbacks
    });
};
const $fa20c6cebfd0e652$export$3dbd5bda6e5269b6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, headers: headers })=>{
    const graphQuery = (0, $bDWrn.resultsCountQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return $fa20c6cebfd0e652$export$3aaf902e00a8e4ba.inMemoryDecorator('count' + $fa20c6cebfd0e652$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $b0Mpu.fetchAgg)({
            variables: requestVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: (0, $bDWrn.resultsCountOperationName),
            headers: headers
        }));
};
const $fa20c6cebfd0e652$export$c9f4828c7e4e077e = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $fR7EZ.dcSpaceFilterOptionsQueryGenerator)((0, $bDWrn.jiraDcProjectFilterOptionsOperationName));
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.jiraDcProjectFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$e261ee95abda868c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.spaceARIEntitiesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.spaceARIEntitiesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$d18b1cb9e3a2ff17 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.confluenceDcContentFilterOptionsQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcContentFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$900adb6f362c0bd3 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.documentARIEntitiesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.documentARIEntitiesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$b2301b91ba090677 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.confluenceDcPagesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcPagesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$a4620a3105d92aba = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $fR7EZ.dcSpaceFilterOptionsQueryGenerator)((0, $bDWrn.confluenceDcSpaceFilterOptionsOperationName));
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)({
        ...variables,
        integration: 'ari:cloud:platform::integration/confluence-dc'
    });
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcSpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$2e5009be45de0b79 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.thirdPartySpaceFilterOptionsQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.thirdPartySpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$54fa597426a1b0bc = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.thirdPartyRepositoryFilterOptionsQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.thirdPartyRepositoryFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$3a1184d0405594d4 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.searchLinkedSiteQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.searchLinkedSitesOperationName),
        headers: headers
    });
};
module.exports["searchPageQueryCache"] = $fa20c6cebfd0e652$export$3aaf902e00a8e4ba;
module.exports["searchDialogQuery"] = $fa20c6cebfd0e652$export$b62744f7ecc07873;
module.exports["jiraDcProjectFilterOptionsQuery"] = $fa20c6cebfd0e652$export$c9f4828c7e4e077e;
module.exports["spaceARIEntitiesQuery"] = $fa20c6cebfd0e652$export$e261ee95abda868c;
module.exports["confluenceDcContentFilterOptionsQuery"] = $fa20c6cebfd0e652$export$d18b1cb9e3a2ff17;
module.exports["documentARIEntitiesQuery"] = $fa20c6cebfd0e652$export$900adb6f362c0bd3;
module.exports["confluenceDcPagesQuery"] = $fa20c6cebfd0e652$export$b2301b91ba090677;
module.exports["confluenceDcSpaceFilterOptionsQuery"] = $fa20c6cebfd0e652$export$a4620a3105d92aba;
module.exports["thirdPartySpaceFilterOptionsQuery"] = $fa20c6cebfd0e652$export$2e5009be45de0b79;
module.exports["thirdPartyRepositoryFilterOptionsQuery"] = $fa20c6cebfd0e652$export$54fa597426a1b0bc;
module.exports["searchLinkedSitesQuery"] = $fa20c6cebfd0e652$export$3a1184d0405594d4;

});

parcelRegister("b0Mpu", function(module, exports) {

var $fExfj = parcelRequire("fExfj");

const $f4fcc0c6cc332c57$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Copies the gateway tracing headers from the HTTP response (`x-trace-id`, `atl-request-id`)
 * onto the parsed GraphQL result. AGG no longer returns these in the JSON body, so attaching
 * them here lets callers read the trace and request IDs the gateway actually returned.
 */ const $f4fcc0c6cc332c57$var$attachGatewayTracingHeaders = (response, tracingHeaders)=>{
    if (!response || Object.keys(tracingHeaders).length === 0) return response;
    return {
        ...response,
        gatewayTracingHeaders: {
            ...response.gatewayTracingHeaders,
            ...tracingHeaders
        }
    };
};
async function $f4fcc0c6cc332c57$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f4fcc0c6cc332c57$var$DEFAULT_GRAPHQL_ENDPOINT, headers: headers }) {
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        },
        // Reported before the response status is inspected, so this also captures the trace
        // for responses that carry GraphQL errors.
        reportTracingHeaders: (tracingHeaders)=>{
            Object.assign(capturedTracingHeaders, tracingHeaders);
        }
    };
    const response = await (0, $fExfj.utils).requestService({
        url: url
    }, options);
    return $f4fcc0c6cc332c57$var$attachGatewayTracingHeaders(response, capturedTracingHeaders);
}
module.exports["fetchAgg"] = $f4fcc0c6cc332c57$export$f49dad89491f6bf2;

});

parcelRegister("3wZF4", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $34fe334faeb6141a$export$ce814d34248d279c = 'search_interactive_propagate_use_case_id';
const $34fe334faeb6141a$export$e34ccfc04a7d0a07 = (useCaseId)=>(0, $iDrrr.fg)($34fe334faeb6141a$export$ce814d34248d279c) ? useCaseId : undefined;
const $34fe334faeb6141a$export$e1ee3d13bd8983ac = (variables)=>{
    const { useCaseId: useCaseId, ...rest } = variables;
    const requestUseCaseId = $34fe334faeb6141a$export$e34ccfc04a7d0a07(useCaseId);
    return requestUseCaseId === undefined ? rest : {
        ...rest,
        useCaseId: requestUseCaseId
    };
};
module.exports["getSearchUseCaseIdForRequest"] = $34fe334faeb6141a$export$e34ccfc04a7d0a07;
module.exports["toSearchUseCaseIdWireVariables"] = $34fe334faeb6141a$export$e1ee3d13bd8983ac;

});

parcelRegister("bHHWv", function(module, exports) {

var $7jITD = parcelRequire("7jITD");

const $9f86570151027da1$export$26b8d9fa10eeb703 = (args)=>{
    const cacheInstance = (0, $7jITD.getInstance)(args);
    const get = (key)=>key.length ? cacheInstance.get(key) : undefined;
    const set = (key, result)=>{
        if (key.length) cacheInstance.set(key, result);
    };
    const has = (key)=>cacheInstance.has(key);
    const clear = (key)=>cacheInstance.clear(key);
    const inMemoryDecorator = (key, supplier, expireWhen)=>{
        // Check if the key is already in the cache
        const cached = get(key);
        // If the key is in the cache, return the cached value
        if (cached) return cached;
        // If the key is not in the cache, call the supplier function
        const result = supplier();
        set(key, result);
        // If the promise is rejected, clear the cache
        result.catch(()=>{
            // If the promise is rejected, clear the cache
            cacheInstance.clear(key);
        });
        // Return the result
        // If the result should be expired, clear the cache
        return result.then((value)=>{
            if (expireWhen && expireWhen(value)) cacheInstance.clear(key);
            return value;
        });
    };
    return {
        get: get,
        set: set,
        has: has,
        clear: clear,
        inMemoryDecorator: inMemoryDecorator
    };
};
module.exports["inMemoryCache"] = $9f86570151027da1$export$26b8d9fa10eeb703;

});

parcelRegister("hDUYn", function(module, exports) {

var $8N8EQ = parcelRequire("8N8EQ");

const $8d0d0c6c05359dda$export$6f045830bd67248c = (fn, callbacks)=>{
    if (!callbacks) return fn;
    return async ()=>{
        callbacks.onStart();
        try {
            const result = await fn();
            const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(result);
            callbacks.onSuccess(traceInfo);
            return result;
        } catch (error) {
            const errorName = error?.name || 'UnknownError';
            const errorMessage = error?.message || 'An unknown error occurred';
            callbacks.onError(errorName, errorMessage);
            throw error;
        }
    };
};
module.exports["withNetworkCallback"] = $8d0d0c6c05359dda$export$6f045830bd67248c;

});

parcelRegister("kQgL7", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $5oT59 = parcelRequire("5oT59");


var $9C63M = parcelRequire("9C63M");


var $efIUz = parcelRequire("efIUz");


var $JJWfD = parcelRequire("JJWfD");

const $07e5cce08214ddb3$export$4d8c59e1d2af415b = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
const $07e5cce08214ddb3$export$520f811efd7d75bb = (0, $5oT59.SEARCH_COMBINED_CONFIG_BARE_CACHE_KEY);
// Adapter-backed cache (host StorageManager → account-namespaced key
// `atlassian.<accountId>.frontend.search-combined-config`, mirrored into
// getRemoteLocalStorage for SSR).
//
// Used by the UNTOUCHED legacy FG-off path (`updateCombinedConfigCacheEntry`,
// `getCombinedSearchConfig` legacy branch) and by the SSR-fill
// (`seedCombinedConfigCacheEntry` via `fillSsrCombinedConfigCache`), which both
// rely on the AAID-scoped key.
const { refreshOnAccessDecorator: $07e5cce08214ddb3$var$refreshOnAccessDecoratorCombined, update: $07e5cce08214ddb3$var$updateCombinedCache, seed: $07e5cce08214ddb3$var$seedCombinedCache, get: $07e5cce08214ddb3$var$getCombinedCache } = (0, $fyjce.promiseCache)({
    name: $07e5cce08214ddb3$export$4d8c59e1d2af415b,
    shouldUseStorageAdapter: true
});
// Bare-key runtime cache (client-only, NOT account-namespaced, NOT SSR-visible).
// Writes the literal `frontend.search-combined-config` localStorage key (distinct
// from the account-namespaced adapter key above).
//
// Used ONLY by the FG-on (`rovo_fps_use_rovo_config`) `useRovoConfig` runtime
// writers — `getCombinedSearchConfig` (FG-on branch), `seedBase…`, `updateBase…`.
const { refreshOnAccessDecorator: $07e5cce08214ddb3$var$refreshOnAccessDecoratorBaseRuntime, update: $07e5cce08214ddb3$var$updateBaseRuntimeCache, seed: $07e5cce08214ddb3$var$seedBaseRuntimeCache } = (0, $fyjce.promiseCache)({
    name: $07e5cce08214ddb3$export$520f811efd7d75bb,
    shouldUseStorageAdapter: false
});
const $07e5cce08214ddb3$export$c066f72d16c9afa5 = (userId, cloudId, updater)=>{
    const key = (0, $efIUz.generateCombinedConfigHash)(userId, cloudId);
    return $07e5cce08214ddb3$var$updateCombinedCache(key.toString(), updater);
};
const $07e5cce08214ddb3$export$34fe4a744c051b23 = ({ userId: userId, cloudId: cloudId, config: config, expiration: expiration })=>{
    const key = (0, $efIUz.generateCombinedConfigHash)(userId || '', cloudId);
    return $07e5cce08214ddb3$var$seedCombinedCache(key.toString(), config, expiration);
};
/**
 * The inner cache key for the **base** combined-config runtime entry used by
 * `useRovoConfig`. Keyed on a hash of the `cloudId` only — no `userId` — so the
 * entry is per-site but not per-account (the localStorage key prefix already
 * scopes per-account).
 */ const $07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey = (cloudId)=>(0, $bZF61.generateHash)(cloudId).toString();
/**
 * Resolve the runtime combined-config cache key, gated by the
 * `rovo_fps_use_rovo_config` feature gate.
 *
 * - **FG ON** (the canonical `useRovoConfig` path): a hash of the `cloudId`
 *   only — no `userId` in the inner key.
 * - **FG OFF** (the legacy `useFetchConfigLegacy` path): the historical
 *   `getCombinedConfigHash(userId, cloudId)` inner key, preserving the
 *   pre-RAOC cache behaviour byte-for-byte.
 */ const $07e5cce08214ddb3$var$resolveRuntimeCombinedConfigCacheKey = (userId, cloudId)=>(0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? $07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId || '') : (0, $efIUz.generateCombinedConfigHash)(userId || '', cloudId || '').toString();
const $07e5cce08214ddb3$export$707f15bd9a09224d = (cloudId, updater)=>$07e5cce08214ddb3$var$updateBaseRuntimeCache($07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId), updater);
const $07e5cce08214ddb3$export$5f90db2f52f87370 = ({ cloudId: cloudId, config: config, expiration: expiration })=>$07e5cce08214ddb3$var$seedBaseRuntimeCache($07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId), config, expiration);
const $07e5cce08214ddb3$export$d6a374b1da3ff3ff = async ({ accountId: accountId, cloudId: cloudId, config: config, expiration: expiration })=>{
    if (!accountId) return false;
    // Skip the redundant seed/write when the AAID-scoped entry is already
    // present and unexpired.
    const key = (0, $efIUz.generateCombinedConfigHash)(accountId, cloudId).toString();
    const { storedValue: storedValue, isExpired: isExpired } = $07e5cce08214ddb3$var$getCombinedCache(key, true);
    if (storedValue && !isExpired) return false;
    await $07e5cce08214ddb3$export$34fe4a744c051b23({
        userId: accountId,
        cloudId: cloudId,
        config: config,
        expiration: expiration
    });
    return true;
};
const $07e5cce08214ddb3$export$8993626c2cc6d711 = async ({ cloudId: cloudId, userId: userId, aggAbsoluteUrl: aggAbsoluteUrl, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired, networkCallbacks: networkCallbacks, headers: headers })=>{
    // FG-on (`useRovoConfig`): bare-key runtime cache (client-only, no AAID).
    // FG-off (legacy): the original adapter-backed cache — untouched.
    const refreshOnAccess = (0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? $07e5cce08214ddb3$var$refreshOnAccessDecoratorBaseRuntime : $07e5cce08214ddb3$var$refreshOnAccessDecoratorCombined;
    return refreshOnAccess({
        key: $07e5cce08214ddb3$var$resolveRuntimeCombinedConfigCacheKey(userId, cloudId),
        supplier: ()=>{
            const combinedConfigPromise = (0, $b0Mpu.fetchAgg)({
                graphQuery: (0, $JJWfD.getSearchConfigQuery)(),
                variables: {
                    cloudId: cloudId
                },
                operationName: (0, $JJWfD.GQL_OPERATION_NAME),
                aggAbsoluteUrl: aggAbsoluteUrl,
                headers: headers
            }).then((response)=>{
                const hasErrors = response.errors?.some((error)=>error);
                if (hasErrors) {
                    const errorsAsString = response.errors?.map((error)=>error.message).join(', ');
                    throw new Error(`Search combined config response had errors: ${errorsAsString}`);
                }
                const configuration = response.data?.search?.configuration;
                if (!configuration) throw new Error('Search combined config response missing configuration.');
                return configuration;
            });
            const degrader = new (0, $9C63M.DegradablePromise)(combinedConfigPromise, degradationCallback);
            return degrader.promise();
        },
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true
    });
};
module.exports["SEARCH_COMBINED_CONFIG"] = $07e5cce08214ddb3$export$4d8c59e1d2af415b;
module.exports["updateCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$c066f72d16c9afa5;
module.exports["seedCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$34fe4a744c051b23;
module.exports["updateBaseCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$707f15bd9a09224d;
module.exports["seedBaseCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$5f90db2f52f87370;
module.exports["fillSsrCombinedConfigCache"] = $07e5cce08214ddb3$export$d6a374b1da3ff3ff;
module.exports["getCombinedSearchConfig"] = $07e5cce08214ddb3$export$8993626c2cc6d711;

});

parcelRegister("efIUz", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $b4b673b384c075fe$export$4f967acd0a387888 = (userId, cloudId)=>(0, $bZF61.generateHash)(`${userId}${cloudId}`);
module.exports["generateCombinedConfigHash"] = $b4b673b384c075fe$export$4f967acd0a387888;

});

parcelRegister("JJWfD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6s56R = parcelRequire("6s56R");


var $9hMB7 = parcelRequire("9hMB7");

const $ee61ee208b79c577$export$c5dfc39e7764783c = 'searchCombinedConfig';
const $ee61ee208b79c577$export$1693aa41d49ec148 = ()=>`
query ${$ee61ee208b79c577$export$c5dfc39e7764783c}($cloudId: ID!) {
  search {
      configuration(cloudId: $cloudId) {
        firstPartyProducts {
          name
        }
        thirdPartyProducts {
          name
          outboundAuthUrl
          isUserOAuthed
          hasAuthUpgrade
          providerId
          integrationARI
          workspaceName
          workspaceUrl
          datasourceId
          connectionId
          connectorSyncType
          isImpersonationAuthEnabled
          authResolutionMode
          connectorCreatedAt
          ${(0, $6s56R.isUsingRovoConfigStoreExperiment)() ? 'connectedAt' : ''}
          lightIcon
          entityTypes
          environmentType
        }
        intercomHmac
        siteMetadata {
          isRovoEnabled
          isJiraIssueIndexed
          applicationMode
          siteName
          orgId
          productEdition
          productInfo {
            name
            dataRegion
          }
        }
        ${(0, $iDrrr.fg)('rovo_fps_unit_metadata') ? 'unitMetadata { id siteName url firstPartyProducts { name } }' : ''}
    }
  }
}`;
module.exports["GQL_OPERATION_NAME"] = $ee61ee208b79c577$export$c5dfc39e7764783c;
module.exports["getSearchConfigQuery"] = $ee61ee208b79c577$export$1693aa41d49ec148;

});

parcelRegister("9hMB7", function(module, exports) {

var $efIUz = parcelRequire("efIUz");

const $39ddd39f96f7c2e0$export$4f967acd0a387888 = (userId, cloudId)=>(0, $efIUz.generateCombinedConfigHash)(userId, cloudId);
module.exports["generateCombinedConfigHash"] = $39ddd39f96f7c2e0$export$4f967acd0a387888;

});

parcelRegister("fR7EZ", function(module, exports) {
const $86ce0b8e897249c4$export$5fcc1d1055e1b5a6 = (operationName)=>{
    const graphQuery = `
		query ${operationName} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$containerTypes: [String!]
			$useCaseId: String
			) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					containerTypes : $containerTypes,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
					subtypes:[]
					}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
					...on SearchResultGraphDocument {
						entity {
							...on ExternalSpace {
									id
									key
									displayName
									icon {
										height
										isDefault
										url
										width
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
module.exports["dcSpaceFilterOptionsQueryGenerator"] = $86ce0b8e897249c4$export$5fcc1d1055e1b5a6;

});

parcelRegister("bDWrn", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $3TZZX = parcelRequire("3TZZX");


const $6f6e40eb51d8920a$export$3f23d3d88b2b0734 = `
description
iconUrl
id
title
type
url
__typename
`;
const $6f6e40eb51d8920a$export$ba7243e49f8daaa4 = 'SearchPageQuery';
const $6f6e40eb51d8920a$export$87e857ecc7765700 = 'SearchDialogQuery';
const $6f6e40eb51d8920a$var$includeUserSignalsParam = (serveUserShardUI = false)=>{
    if (serveUserShardUI) return '\n		$includeUserSignals: Boolean!';
    else return '';
};
const $6f6e40eb51d8920a$export$bcad4d0714f0772f = (operationName, serveUserShardUI = false)=>{
    const partials = (0, $3TZZX.getSupportedPartials)(serveUserShardUI);
    const graphQuery = `
	query ${operationName}(
		$query: String!
		$cloudIdARI: [String!]!
		$tenantId: ID!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$sessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $iDrrr.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $iDrrr.fg)('loom-rovo-search') ? '$loomFilters: SearchLoomFilters' : ''}
		${(0, $iDrrr.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$after: String
		$disableQueryReplacement: Boolean
		$experience: String!
		$useCaseId: String
		$enableHighlighting: Boolean
		$skip3pEntityHydration: Boolean!
		$includeGithubEntityHydration: Boolean! = false
		$includeLoomVideoMetadata: Boolean! = false
		$includeJiraIssueType: Boolean!
		$includeJiraBoardContainer: Boolean!
		$includeFastJiraHydration: Boolean! = false
		$skipJiraHydration: Boolean! = false
		$includeSocialSignals: Boolean!${$6f6e40eb51d8920a$var$includeUserSignalsParam(serveUserShardUI)}
		$fanoutExperimentCohort: String
		$includeSpaceSubtype: Boolean!
		$includeConfluenceEntity: Boolean!
		$skipFieldsFor3pInQuickFind: Boolean!
		$includeDatasourceId: Boolean! = false
		$includeAutocompleteSuggestions: Boolean = false
	) {
		search {
			results: search(
				experience: $experience
				useCaseId: $useCaseId
				enableHighlighting: $enableHighlighting
				fanoutExperimentCohort: $fanoutExperimentCohort
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: $cloudIdARI
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					${(0, $iDrrr.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
					mercuryFilters: $mercuryFilters
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $iDrrr.fg)('loom-rovo-search') ? 'loomFilters: $loomFilters' : ''}
					${(0, $iDrrr.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
				}
				analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sessionId: $sessionId
					sourceProduct: $sourceProduct
				}
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
			) {
				edges {
					node {
						${$6f6e40eb51d8920a$export$3f23d3d88b2b0734}
						${partials}
					}
				}
				queryInfo {
					originalQuery
					replacementQuery
					suggestedQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
        pageInfo {
          endCursor
        }
				autocompleteSuggestions @include(if: $includeAutocompleteSuggestions)
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$59ff8b98cf7da770 = 'ResultsCountQuery';
const $6f6e40eb51d8920a$export$35addfdbe1c7b563 = ()=>{
    const graphQuery = `
	query ${$6f6e40eb51d8920a$export$59ff8b98cf7da770}(
		$query: String!
		$cloudIdARI: String!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $iDrrr.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $iDrrr.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$disableQueryReplacement: Boolean
		$useCaseId: String
	) {
		search {
			results: search(
				experience: "search-page"
				useCaseId: $useCaseId
				query: $query
				first: $limit
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					mercuryFilters: $mercuryFilters
					${(0, $iDrrr.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $iDrrr.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {

				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$fa19606e35da8d6d = 'jiraDcProjectFilterOptionsQuery';
const $6f6e40eb51d8920a$export$56917484085c839f = 'confluenceDcSpaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$7fed2443afa81b26 = 'thirdPartySpaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$5fce5a96ced87ae4 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$7fed2443afa81b26} (
			$query: String!
			$cloudIdARI: [String!]!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: $cloudIdARI
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalSpace {
									id
									displayName
									icon {
										url
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$8535d2c38a35eb6f = 'teamsWorkspaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$baa4ec00dd3889d8 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$8535d2c38a35eb6f} (
			$query: String!
			$cloudIdARI: [String!]!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: $cloudIdARI
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalConversation {
									workspace
									id
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$c768638eb8676119 = 'thirdPartyRepositoryFilterOptionsQuery';
const $6f6e40eb51d8920a$export$3057eb5718aa2977 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$c768638eb8676119} (
			$query: String!
			$cloudIdARI: [String!]!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: $cloudIdARI
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalRepository {
									id
									name
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$4cc1a613b784cede = 'spaceIdFilterOptionsQuery';
const $6f6e40eb51d8920a$export$402074cb9d99809d = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$4cc1a613b784cede} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				space {
					id
					displayName
					icon {
						url
					}
				}
			}
		}`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$fd96e79bbd846735 = 'documentIdFilterOptionsQuery';
const $6f6e40eb51d8920a$export$36d0a57a2adc8939 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$fd96e79bbd846735} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				document {
					id
					displayName
					container @optIn(to: "ExternalDataDepotQueryV2") {
                        ... on ExternalSpace {
                            id
                        }
                    }
				}
			}
		}`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$11124ad4475d739f = 'confluenceDcContentFilterOptionsQuery';
const $6f6e40eb51d8920a$export$80a2987504e5746a = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$11124ad4475d739f} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				locations: [$cloudIdARI],
				thirdPartyFilters: {
					thirdPartyProducts:[
						{
							product: $product,
							integrationId:"ari:cloud:platform::integration/confluence-dc",
							subtypes:[]
						}
					]
				}
			}
			analytics: {searchSessionId: "graphql"}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
					id
					title
					description
					... on SearchResultGraphDocument {
							entity {
								...on ExternalDocument {
									type {
										category
									}
									parentId
									container @optIn(to: "ExternalDataDepotQueryV2") {
										...on ExternalSpace {
											id
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$b12a4e91aeaa7036 = 'confluenceDcPagesQuery';
const $6f6e40eb51d8920a$export$feafc9cb648273dc = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$b12a4e91aeaa7036} (
			$ancestorIds: [ID!]!
		) {
			external_entities(ids: $ancestorIds) @optIn(to: "ExternalDataDepotQueryV2") {
				document {
					id
					displayName
				}
			}
		}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$b6579c18b8ca60cd = 'CollabContextWorkspaceIsConnectedToWorkspaceQuery';
const $6f6e40eb51d8920a$export$4d33288c2a5c7de0 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$b6579c18b8ca60cd}($id: ID!) {
			collabContext_workspaceIsConnectedToWorkspace(id: $id) {
				edges {
					node {
						id
					}
					cursor
				}
				pageInfo {
					endCursor
					hasNextPage
					hasPreviousPage
					startCursor
				}
			}
		}
	`;
    return graphQuery;
};
module.exports["SEARCH_PAGE_OPERATION_NAME"] = $6f6e40eb51d8920a$export$ba7243e49f8daaa4;
module.exports["SEARCH_DIALOG_OPERATION_NAME"] = $6f6e40eb51d8920a$export$87e857ecc7765700;
module.exports["queryGenerator"] = $6f6e40eb51d8920a$export$bcad4d0714f0772f;
module.exports["resultsCountOperationName"] = $6f6e40eb51d8920a$export$59ff8b98cf7da770;
module.exports["resultsCountQueryGenerator"] = $6f6e40eb51d8920a$export$35addfdbe1c7b563;
module.exports["jiraDcProjectFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$fa19606e35da8d6d;
module.exports["confluenceDcSpaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$56917484085c839f;
module.exports["thirdPartySpaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$7fed2443afa81b26;
module.exports["thirdPartySpaceFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$5fce5a96ced87ae4;
module.exports["teamsWorkspaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$8535d2c38a35eb6f;
module.exports["teamsWorkspaceFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$baa4ec00dd3889d8;
module.exports["thirdPartyRepositoryFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$c768638eb8676119;
module.exports["thirdPartyRepositoryFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$3057eb5718aa2977;
module.exports["spaceARIEntitiesOperationName"] = $6f6e40eb51d8920a$export$4cc1a613b784cede;
module.exports["spaceARIEntitiesQueryGenerator"] = $6f6e40eb51d8920a$export$402074cb9d99809d;
module.exports["documentARIEntitiesOperationName"] = $6f6e40eb51d8920a$export$fd96e79bbd846735;
module.exports["documentARIEntitiesQueryGenerator"] = $6f6e40eb51d8920a$export$36d0a57a2adc8939;
module.exports["confluenceDcContentFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$11124ad4475d739f;
module.exports["confluenceDcContentFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$80a2987504e5746a;
module.exports["confluenceDcPagesOperationName"] = $6f6e40eb51d8920a$export$b12a4e91aeaa7036;
module.exports["confluenceDcPagesQueryGenerator"] = $6f6e40eb51d8920a$export$feafc9cb648273dc;
module.exports["searchLinkedSitesOperationName"] = $6f6e40eb51d8920a$export$b6579c18b8ca60cd;
module.exports["searchLinkedSiteQueryGenerator"] = $6f6e40eb51d8920a$export$4d33288c2a5c7de0;

});

parcelRegister("3TZZX", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $bfn6U = parcelRequire("bfn6U");


var $lwDzf = parcelRequire("lwDzf");


var $51pfw = parcelRequire("51pfw");


var $cz1Yi = parcelRequire("cz1Yi");


var $imUxN = parcelRequire("imUxN");


var $h95RB = parcelRequire("h95RB");


var $dZRvm = parcelRequire("dZRvm");


var $axZZ7 = parcelRequire("axZZ7");


var $lqtzf = parcelRequire("lqtzf");


var $hABTJ = parcelRequire("hABTJ");


var $5Styu = parcelRequire("5Styu");


var $lwXsc = parcelRequire("lwXsc");

const $baa794815d2b0101$export$9f64d624a5905b0b = (serveUserShardUI = false)=>{
    return `
		${(0, $cz1Yi.getConfluencePartials)(serveUserShardUI)}
		${(0, $imUxN.getJiraPartials)()}
		${(0, $lwXsc.getTrelloPartials)()}
		${(0, $lwDzf.getAtlasPartials)()}
		${(0, $51pfw.getCompassPartials)()}
		${(0, $axZZ7.getMercuryPartials)()}
		${(0, $iDrrr.fg)('loom-rovo-search') ? (0, $h95RB.getLoomEntityPartials)() : ''}
		${(0, $iDrrr.fg)('loom-rovo-search') ? (0, $dZRvm.getLoomVideoPartials)() : ''}
		${(0, $5Styu.getGraphPartials)()}
		${(0, $hABTJ.getFederatedPartials)()}
		${(0, $iDrrr.fg)('assets_rovo_search_all') ? (0, $bfn6U.getAssetsPartials)() : ''}
		${(0, $iDrrr.fg)('talent_global_search') ? (0, $lqtzf.getTalentPartials)() : ''}
	`;
};
module.exports["getSupportedPartials"] = $baa794815d2b0101$export$9f64d624a5905b0b;

});

parcelRegister("bfn6U", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $ddc9a35e5ba235cd$export$6cb3c23f8cc6b5c8 = `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		links {
			web
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$6d6066e039c821f2 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectSchema';
};
const $ddc9a35e5ba235cd$export$f160c48c1d037f87 = ()=>{
    return `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		${(0, $iDrrr.fg)('cdm_ga') ? 'name displayName' : ''}
		links {
			web
		}
	}
}
	`;
};
const $ddc9a35e5ba235cd$export$6ff43818aa330e52 = `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		icon {
			url48
		}
		links {
			web
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$477919e939be033d = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectType';
};
const $ddc9a35e5ba235cd$export$f11c57703f5bd591 = ()=>{
    return `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
		links {
			web
		}
	}
	objectTypeEntity {
		${(0, $iDrrr.fg)('cdm_ga') ? 'name displayName' : ''}
		icon {
			url48
		}
		links {
			web
		}
	}
}
	`;
};
const $ddc9a35e5ba235cd$export$e3c6dbbf952d90ed = `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name

	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$6cfcb9e6160b8854 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObject';
};
const $ddc9a35e5ba235cd$export$48a3d1cc8f03ffb9 = ()=>{
    return `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name
	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
	`;
};
const $ddc9a35e5ba235cd$export$b66206b66084d78d = (partial)=>{
    return $ddc9a35e5ba235cd$export$6d6066e039c821f2(partial) || $ddc9a35e5ba235cd$export$477919e939be033d(partial) || $ddc9a35e5ba235cd$export$6cfcb9e6160b8854(partial);
};
const $ddc9a35e5ba235cd$export$d49a85cc2b961760 = ()=>{
    return `
		${$ddc9a35e5ba235cd$export$f160c48c1d037f87()}
		${$ddc9a35e5ba235cd$export$f11c57703f5bd591()}
		${$ddc9a35e5ba235cd$export$48a3d1cc8f03ffb9()}
	`;
};
module.exports["isSearchResultAssetsObjectSchema"] = $ddc9a35e5ba235cd$export$6d6066e039c821f2;
module.exports["isSearchResultAssetsObjectType"] = $ddc9a35e5ba235cd$export$477919e939be033d;
module.exports["isSearchResultAssetsObject"] = $ddc9a35e5ba235cd$export$6cfcb9e6160b8854;
module.exports["isSearchAssetsPartial"] = $ddc9a35e5ba235cd$export$b66206b66084d78d;
module.exports["getAssetsPartials"] = $ddc9a35e5ba235cd$export$d49a85cc2b961760;

});

parcelRegister("lwDzf", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $3a362426d95a08c8$var$SearchDefaultResultAtlas = ``;
// oxlint-disable-next-line eslint/no-redeclare
const $3a362426d95a08c8$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
    isPrivate
  }
}
`;
// oxlint-disable-next-line eslint/no-redeclare
const $3a362426d95a08c8$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
      value
      score
    }
    targetDate {
      label
    }
  }
}
`;
const $3a362426d95a08c8$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $3a362426d95a08c8$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $3a362426d95a08c8$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $3a362426d95a08c8$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $3a362426d95a08c8$export$750af6f011d7ee10 = (partial)=>{
    return $3a362426d95a08c8$export$1d556a3125797ca6(partial) || $3a362426d95a08c8$export$1724df33341798e0(partial) || $3a362426d95a08c8$export$bff995b1cea89df3(partial) || $3a362426d95a08c8$export$aa63de26c950cf0f(partial);
};
const $3a362426d95a08c8$export$272c689528faac47 = ()=>{
    return `
		${$3a362426d95a08c8$var$SearchResultAtlasGoal}
		${$3a362426d95a08c8$var$SearchResultAtlasProject}
		${$3a362426d95a08c8$var$SearchDefaultResultAtlas}
	`;
};
module.exports["isSearchResultAtlasProjectPartial"] = $3a362426d95a08c8$export$1724df33341798e0;
module.exports["isSearchResultAtlasGoalPartial"] = $3a362426d95a08c8$export$1d556a3125797ca6;
module.exports["isSearchAtlasPartial"] = $3a362426d95a08c8$export$750af6f011d7ee10;
module.exports["getAtlasPartials"] = $3a362426d95a08c8$export$272c689528faac47;

});

parcelRegister("51pfw", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $e1374cb7dd251364$var$SearchResultCompassComponent = `
... on SearchResultCompassComponent {
	lastModifiedDate
	ownerId
	tier
	component {
		description
		state
	}
}
`;
const $e1374cb7dd251364$export$72cf2e1294c50ff4 = ()=>{
    return $e1374cb7dd251364$var$SearchResultCompassComponent;
};
const $e1374cb7dd251364$export$b8968ce5f9785283 = (partial)=>{
    return partial.__typename === 'SearchResultCompassComponent';
};
module.exports["getCompassPartials"] = $e1374cb7dd251364$export$72cf2e1294c50ff4;
module.exports["isSearchCompassPartial"] = $e1374cb7dd251364$export$b8968ce5f9785283;

});

parcelRegister("cz1Yi", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $abaed1578237b609$var$SearchConfluencePageBlogAttachment = (serveUserShardUI)=>`
... on SearchConfluencePageBlogAttachment {
	lastModified
	${serveUserShardUI ? `
	latestUserAction @include(if: $includeUserSignals)
	latestUserActionTs @include(if: $includeUserSignals)
	` : ''}
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity @include(if: $includeConfluenceEntity) {
		... on ConfluencePage {
			subtype
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
	}
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
	linkedResults {
		id
		datasourceId @include(if: $includeDatasourceId)
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $abaed1578237b609$export$c89c057fd480d10c = (partial)=>{
    return partial.__typename === 'SearchConfluencePageBlogAttachment';
};
// oxlint-disable-next-line eslint/no-redeclare
const $abaed1578237b609$var$SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;
const $abaed1578237b609$export$4619f000f23ee8d1 = (partial)=>{
    return partial.__typename === 'SearchConfluenceSpace';
};
const $abaed1578237b609$export$e4e5a86cb4c1e3e4 = (partial)=>{
    return $abaed1578237b609$export$c89c057fd480d10c(partial) || $abaed1578237b609$export$4619f000f23ee8d1(partial);
};
const $abaed1578237b609$export$d1ddb94b35ac2d77 = (serveUserShardUI = false)=>{
    return `
		${$abaed1578237b609$var$SearchConfluencePageBlogAttachment(serveUserShardUI)}
		${$abaed1578237b609$var$SearchConfluenceSpace}
	`;
};
module.exports["isSearchConfluencePageBlogAttachment"] = $abaed1578237b609$export$c89c057fd480d10c;
module.exports["isSearchConfluenceSpace"] = $abaed1578237b609$export$4619f000f23ee8d1;
module.exports["isSearchConfluencePartial"] = $abaed1578237b609$export$e4e5a86cb4c1e3e4;
module.exports["getConfluencePartials"] = $abaed1578237b609$export$d1ddb94b35ac2d77;

});

parcelRegister("imUxN", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 

/**
 * Hydrating the project avatar field causes additional latency so it is removed in this GraphQL Query
 * Investigation: https://hello.atlassian.net/wiki/x/iKKu8w
 */ const $fe7aae6ee50f421f$var$getSearchResultJiraProject = ()=>`
... on SearchResultJiraProject {
  projectId
  projectKey
  projectType
  lastModifiedDate
  project @skip(if: $skipJiraHydration) {
    webUrl
  }
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}`;
const $fe7aae6ee50f421f$export$aab3eed7c97209f8 = (partial)=>{
    return partial.__typename === 'SearchResultJiraProject';
};
const $fe7aae6ee50f421f$export$1f4b5d2e43f14510 = `
... on SearchResultJiraIssue {
  id
  title
  type
  description
  url
  iconUrl
  lastModifiedDate
  issueTypeId
  issueKey @include(if: $skipJiraHydration)
  projectName @include(if: $skipJiraHydration)
  status {
    id
    name
  }
  issue @skip(if: $skipJiraHydration) {
    webUrl
		key
		assigneeField @skip(if: $includeFastJiraHydration) {
			user {
				name
				picture
			}
		}
		fieldsById(ids: ["project"]) @skip(if: $includeFastJiraHydration) {
			edges {
				node {
					__typename
					name
					... on JiraProjectField {
						project {
							id
							name
							projectType
						}
					}
				}
			}
		}
		issueTypeAvatarUrl @skip(if: $includeFastJiraHydration)
		issueTypeField @include(if: $includeJiraIssueType) @skip(if: $includeFastJiraHydration) {
			id
			issueType {
				id
				name
			}
		}
		issueType @include(if: $includeFastJiraHydration) {
			name
			avatar {
				medium
			}
		}
		project @include(if: $includeFastJiraHydration) {
			id
			name
			projectType
		}
  }
  socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
	    signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
	    }
  }
	linkedResults {
		id
		datasourceId @include(if: $includeDatasourceId)
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
  __typename
}
`;
const $fe7aae6ee50f421f$export$65f412f3857c35e0 = (partial)=>{
    return {
        ...partial,
        url: partial.issue?.webUrl || partial.url
    };
};
const $fe7aae6ee50f421f$export$85182d219d5a304f = (partial)=>({
        ...partial,
        url: partial.project?.webUrl || partial.url
    });
const $fe7aae6ee50f421f$export$e221e36ba6e9f139 = (partial)=>{
    return partial.__typename === 'SearchResultJiraIssue';
};
const $fe7aae6ee50f421f$export$9c283c2de8ddb8fb = (partial)=>{
    return partial.__typename === 'JiraProjectField' && partial.name === 'Project';
};
const $fe7aae6ee50f421f$export$832b8ae8473ed171 = ``;
const $fe7aae6ee50f421f$export$e0968d23c481cf04 = (partial)=>{
    return partial.__typename === 'SearchResultJiraFilter';
};
const $fe7aae6ee50f421f$export$7860041bfeffea77 = ``;
const $fe7aae6ee50f421f$export$3e9a71746a0d5ef1 = (partial)=>{
    return partial.__typename === 'SearchResultJiraDashboard';
};
const $fe7aae6ee50f421f$export$f2ae751487c16c56 = `
... on SearchResultJiraBoard {
  boardId
  container @include(if: $includeJiraBoardContainer) {
		__typename
		... on SearchResultJiraBoardProjectContainer {
			__typename
			projectName
		}
		... on SearchResultJiraBoardUserContainer {
			__typename
			userName
		}
	}
	board @skip(if: $skipJiraHydration) {
		boardFrontendUrl
		iconUrl
	}
  product
}
`;
const $fe7aae6ee50f421f$export$98e434e98950249c = (partial)=>{
    return partial.__typename === 'SearchResultJiraBoard';
};
const $fe7aae6ee50f421f$export$56752b3c89cc8a9e = (partial)=>{
    return partial.__typename === 'SearchResultJiraPlan';
};
const $fe7aae6ee50f421f$export$5a36738ca5faa27f = (partial)=>{
    return $fe7aae6ee50f421f$export$aab3eed7c97209f8(partial) || $fe7aae6ee50f421f$export$e221e36ba6e9f139(partial) || $fe7aae6ee50f421f$export$e0968d23c481cf04(partial) || $fe7aae6ee50f421f$export$3e9a71746a0d5ef1(partial) || $fe7aae6ee50f421f$export$98e434e98950249c(partial) || $fe7aae6ee50f421f$export$56752b3c89cc8a9e(partial);
};
const $fe7aae6ee50f421f$export$d1f9da0e5c74ebcb = ()=>{
    return `
		${$fe7aae6ee50f421f$var$getSearchResultJiraProject()}
		${$fe7aae6ee50f421f$export$1f4b5d2e43f14510}
		${$fe7aae6ee50f421f$export$832b8ae8473ed171}
		${$fe7aae6ee50f421f$export$7860041bfeffea77}
		${$fe7aae6ee50f421f$export$f2ae751487c16c56}
	`;
};
module.exports["isSearchResultJiraProject"] = $fe7aae6ee50f421f$export$aab3eed7c97209f8;
module.exports["isSearchResultJiraIssue"] = $fe7aae6ee50f421f$export$e221e36ba6e9f139;
module.exports["isJiraProjectField"] = $fe7aae6ee50f421f$export$9c283c2de8ddb8fb;
module.exports["isSearchResultJiraFilter"] = $fe7aae6ee50f421f$export$e0968d23c481cf04;
module.exports["isSearchResultJiraDashboard"] = $fe7aae6ee50f421f$export$3e9a71746a0d5ef1;
module.exports["isSearchResultJiraBoard"] = $fe7aae6ee50f421f$export$98e434e98950249c;
module.exports["isSearchJiraPartial"] = $fe7aae6ee50f421f$export$5a36738ca5faa27f;
module.exports["getJiraPartials"] = $fe7aae6ee50f421f$export$d1f9da0e5c74ebcb;

});

parcelRegister("h95RB", function(module, exports) {
const $fa9b9c9604a4c638$var$SearchResultLoomEntityPartial = `
... on SearchResultLoomFolder {
	lastModifiedDate
	loomId
	totalNestedVideos
	loomSpace: space {
		ari
		id
		name
	}
}
... on SearchResultLoomPlaylist {
	createdAt
	creatorAaid
	creatorName
	lastModifiedDate
	loomId
	thumbnailUrl
}
... on SearchResultLoomSpace {
	lastModifiedDate
	loomId
}
... on SearchResultLoomTag {
	count
	lastModifiedDate
}
`;
const $fa9b9c9604a4c638$export$f9c78999b2120d6f = (partial)=>partial.__typename === 'SearchResultLoomFolder';
const $fa9b9c9604a4c638$export$1ba2a2ad410b8810 = (partial)=>partial.__typename === 'SearchResultLoomPlaylist';
const $fa9b9c9604a4c638$export$ab6388c626bd9f27 = (partial)=>partial.__typename === 'SearchResultLoomSpace';
const $fa9b9c9604a4c638$export$6d627bdf574de5d1 = (partial)=>partial.__typename === 'SearchResultLoomTag';
const $fa9b9c9604a4c638$export$6611322a43c66104 = (partial)=>$fa9b9c9604a4c638$export$f9c78999b2120d6f(partial) || $fa9b9c9604a4c638$export$1ba2a2ad410b8810(partial) || $fa9b9c9604a4c638$export$ab6388c626bd9f27(partial) || $fa9b9c9604a4c638$export$6d627bdf574de5d1(partial);
const $fa9b9c9604a4c638$export$a5e45741cb168a66 = ()=>$fa9b9c9604a4c638$var$SearchResultLoomEntityPartial;
module.exports["isSearchResultLoomFolder"] = $fa9b9c9604a4c638$export$f9c78999b2120d6f;
module.exports["isSearchResultLoomPlaylist"] = $fa9b9c9604a4c638$export$1ba2a2ad410b8810;
module.exports["isSearchResultLoomSpace"] = $fa9b9c9604a4c638$export$ab6388c626bd9f27;
module.exports["isSearchResultLoomTag"] = $fa9b9c9604a4c638$export$6d627bdf574de5d1;
module.exports["isSearchResultLoomEntity"] = $fa9b9c9604a4c638$export$6611322a43c66104;
module.exports["getLoomEntityPartials"] = $fa9b9c9604a4c638$export$a5e45741cb168a66;

});

parcelRegister("dZRvm", function(module, exports) {
const $b8d77628657a901e$var$SearchResultLoomVideoPartial = `
... on SearchResultLoomVideo {
	createdAt
	creatorAaid
	creatorName
	durationSeconds
	lastModifiedDate
	thumbnailUrl
	videoType
}
`;
const $b8d77628657a901e$export$d489304e03a4956 = (partial)=>partial.__typename === 'SearchResultLoomVideo';
const $b8d77628657a901e$export$6f82c25cf14e47d5 = ()=>$b8d77628657a901e$var$SearchResultLoomVideoPartial;
module.exports["isSearchResultLoomVideo"] = $b8d77628657a901e$export$d489304e03a4956;
module.exports["getLoomVideoPartials"] = $b8d77628657a901e$export$6f82c25cf14e47d5;

});

parcelRegister("axZZ7", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

// oxlint-disable-next-line eslint/no-redeclare
const $67028c881db0fef3$var$SearchResultMercuryFocusArea = `
... on SearchResultMercuryFocusArea {
	lastModifiedDate
	focusArea {
		id
		uuid
		name
		focusAreaType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		health {
			key
			color
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
// oxlint-disable-next-line eslint/no-redeclare
const $67028c881db0fef3$var$SearchResultMercuryFocusAreaStatusUpdate = `
... on SearchResultMercuryFocusAreaStatusUpdate {
	lastModifiedDate
	focusArea {
		name
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryOrganization = `
... on SearchResultMercuryOrganization {
	lastModifiedDate
	organization @optIn(to: "Mercury") {
		id
		name
		organizationType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryOrganizationStatusUpdate = `
... on SearchResultMercuryOrganizationStatusUpdate {
	lastModifiedDate
}
`;
const $67028c881db0fef3$var$SearchResultSpfAskPartial = `
... on SearchResultSpfAsk {
	lastModifiedDate
	ask @optIn(to: "Spf") {
		id
		name
		status
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryRiskPartial = `
... on SearchResultMercuryRisk {
	lastModifiedDate
	risk @optIn(to: "Mercury") {
		id
		name
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
// `SearchResultMercuryAsk` exposes a nested `ask` object (hydrated live from Mercury via
// `mercury_asksByIds`), mirroring SPF Ask (`ask @optIn(to: "Spf")`) and Mercury Risk
// (`risk @optIn(to: "Mercury")`). We read status/target date from that object so the data
// is sourced from Mercury directly rather than the search index. The `ask` field is in the
// EXPERIMENTAL lifecycle stage, hence `@optIn(to: "Mercury")`. `id`/`title`/`url` come from
// the shared node selection in `query-generator.tsx`.
const $67028c881db0fef3$var$SearchResultMercuryAskPartial = `
... on SearchResultMercuryAsk {
	lastModifiedDate
	mercuryAsk: ask @optIn(to: "Mercury") {
		askStatus
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $67028c881db0fef3$export$8b0a4c9077b7d09b = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusArea';
};
const $67028c881db0fef3$export$c43349f9a39b01bd = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusAreaStatusUpdate';
};
const $67028c881db0fef3$export$d3264e7771e87974 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganization';
};
const $67028c881db0fef3$export$aa29d4d3bbbb9e32 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganizationStatusUpdate';
};
const $67028c881db0fef3$export$68b5e30200895184 = (partial)=>{
    return partial?.id?.includes('passionfruit') && partial.__typename === 'SearchResultSpfAsk';
};
const $67028c881db0fef3$export$180dc91590735353 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryRisk';
};
const $67028c881db0fef3$export$c0d805c5b7dc3ab9 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryAsk';
};
const $67028c881db0fef3$export$bbfb216d33463101 = (partial)=>{
    return $67028c881db0fef3$export$8b0a4c9077b7d09b(partial) || $67028c881db0fef3$export$c43349f9a39b01bd(partial) || $67028c881db0fef3$export$68b5e30200895184(partial) || $67028c881db0fef3$export$c0d805c5b7dc3ab9(partial) || $67028c881db0fef3$export$180dc91590735353(partial) || $67028c881db0fef3$export$d3264e7771e87974(partial) || $67028c881db0fef3$export$aa29d4d3bbbb9e32(partial);
};
const $67028c881db0fef3$export$fabaf03f9e1d6e25 = ()=>{
    return `
		${$67028c881db0fef3$var$SearchResultMercuryFocusArea}
		${$67028c881db0fef3$var$SearchResultMercuryFocusAreaStatusUpdate}
		${// The Ask UI migration flag takes precedence over the legacy Passionfruit flag so
    // that only one `ask` selection is ever composed into the query. When both flags are
    // on, requesting both partials would produce two conflicting `ask` fields and the
    // aggregator would reject the operation.
    (0, $iDrrr.fg)('platform_mercury_ask_search_ui_enabled') ? $67028c881db0fef3$var$SearchResultMercuryAskPartial : (0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultSpfAskPartial : ''}
		${(0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled') ? $67028c881db0fef3$var$SearchResultMercuryRiskPartial : ''}
		${(0, $iDrrr.fg)('platform_organization_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultMercuryOrganization : ''}
		${(0, $iDrrr.fg)('platform_organization_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultMercuryOrganizationStatusUpdate : ''}
	`;
};
module.exports["isSearchResultMercuryFocusAreaPartial"] = $67028c881db0fef3$export$8b0a4c9077b7d09b;
module.exports["isSearchResultMercuryFocusAreaStatusUpdatePartial"] = $67028c881db0fef3$export$c43349f9a39b01bd;
module.exports["isSearchResultMercuryOrganizationPartial"] = $67028c881db0fef3$export$d3264e7771e87974;
module.exports["isSearchResultMercuryOrganizationStatusUpdatePartial"] = $67028c881db0fef3$export$aa29d4d3bbbb9e32;
module.exports["isSearchResultSpfAskPartial"] = $67028c881db0fef3$export$68b5e30200895184;
module.exports["isSearchResultMercuryRiskPartial"] = $67028c881db0fef3$export$180dc91590735353;
module.exports["isSearchResultMercuryAskPartial"] = $67028c881db0fef3$export$c0d805c5b7dc3ab9;
module.exports["isSearchMercuryPartial"] = $67028c881db0fef3$export$bbfb216d33463101;
module.exports["getMercuryPartials"] = $67028c881db0fef3$export$fabaf03f9e1d6e25;

});

parcelRegister("lqtzf", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $0e127d1d0d2dd836$var$SearchResultTalentPosition = `
... on SearchResultTalentPosition {
	__typename
	lastModifiedDate
	position {
		__typename
		worker {
			preferredName
			user {
				picture
			}
		}
		fieldValues(
			fieldIdIsIn: [
				"positionId",
				"positionStatus",
				"positionJobTitle",
				"positionPositionTitle",
				"positionKey",
				"positionExternalPositionKey",
				"positionWorker"
			]
		) {
			fieldId
			fieldValue {
				__typename
				... on RadarStringFieldValue {
					__typename
					stringValue: value
				}
			}
		}
	}
}
`;
const $0e127d1d0d2dd836$export$81d91ad826853e38 = (partial)=>{
    return partial?.id?.includes('radar') && partial.__typename === 'SearchResultTalentPosition';
};
const $0e127d1d0d2dd836$export$4f87e53676ad17f4 = (partial)=>{
    return $0e127d1d0d2dd836$export$81d91ad826853e38(partial);
};
const $0e127d1d0d2dd836$export$f39ac0d11d2a4da = ()=>{
    return `
		${$0e127d1d0d2dd836$var$SearchResultTalentPosition}
	`;
};
module.exports["isSearchTalentPartial"] = $0e127d1d0d2dd836$export$4f87e53676ad17f4;
module.exports["getTalentPartials"] = $0e127d1d0d2dd836$export$f39ac0d11d2a4da;

});

parcelRegister("hABTJ", function(module, exports) {

var $99V2N = parcelRequire("99V2N");


var $2HOu2 = parcelRequire("2HOu2");

const $8ff5965b7e47a02e$var$SearchResultFederatedPartial = `
... on SearchResultFederated @skip(if: $skipFieldsFor3pInQuickFind) {
	lastModifiedDate
	entity {
		${(0, $2HOu2.FederatedEmailPartial)}
	}
}
`;
var $8ff5965b7e47a02e$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["EMAIL"] = "email";
    return ResourceType;
}($8ff5965b7e47a02e$var$ResourceType || {});
const $8ff5965b7e47a02e$export$68ef445facedc0d5 = ()=>{
    return $8ff5965b7e47a02e$var$SearchResultFederatedPartial;
};
const $8ff5965b7e47a02e$export$4fafa9bf7ad5438a = (partial)=>partial.__typename === 'SearchResultFederated';
const $8ff5965b7e47a02e$export$c0c573cc3dff9ad6 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "email";
};
module.exports["getFederatedPartials"] = $8ff5965b7e47a02e$export$68ef445facedc0d5;

});

parcelRegister("2HOu2", function(module, exports) {
const $28ebfbddd242fc9e$export$7c3d5c670817fb18 = `
... on SearchFederatedEmailEntity {
	sender {
		email
		name
	}
}
`;
module.exports["FederatedEmailPartial"] = $28ebfbddd242fc9e$export$7c3d5c670817fb18;

});

parcelRegister("5Styu", function(module, exports) {

var $99V2N = parcelRequire("99V2N");


var $coUcA = parcelRequire("coUcA");


var $1qzQx = parcelRequire("1qzQx");


var $H9Wft = parcelRequire("H9Wft");


var $idD0I = parcelRequire("idD0I");


var $j325C = parcelRequire("j325C");


var $3UgcO = parcelRequire("3UgcO");


var $dR4Df = parcelRequire("dR4Df");


var $kg3OO = parcelRequire("kg3OO");


var $9GHVW = parcelRequire("9GHVW");


var $3e9cd = parcelRequire("3e9cd");


var $op8eC = parcelRequire("op8eC");


var $d7k9v = parcelRequire("d7k9v");


var $abc4G = parcelRequire("abc4G");


var $9kmby = parcelRequire("9kmby");


var $j8hui = parcelRequire("j8hui");


var $hV1Vq = parcelRequire("hV1Vq");


var $9GAIA = parcelRequire("9GAIA");


var $8UHlo = parcelRequire("8UHlo");


var $9dBo7 = parcelRequire("9dBo7");


var $lUvMj = parcelRequire("lUvMj");


var $8fx85 = parcelRequire("8fx85");


var $h0zJb = parcelRequire("h0zJb");


var $byWMV = parcelRequire("byWMV");

const $7cea49c1b7fc8fb2$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $7cea49c1b7fc8fb2$var$SearchThirdPartyGraphDocumentPartial = `
... on SearchResultGraphDocument {
	datasourceId @include(if: $includeDatasourceId)
	excerpt @skip(if: $skipFieldsFor3pInQuickFind)
	permissionLevel @skip(if: $skipFieldsFor3pInQuickFind)
	initialContributors @skip(if: $skipFieldsFor3pInQuickFind) {
		name
		id
		externalId
	}
	subtype
	integrationId
	providerId
	connectorType
	lastModifiedDate
	linkedEntities @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		datasourceId @include(if: $includeDatasourceId)
		excerpt,
		permissionLevel,
		subtype
		integrationId
		lastModifiedDate
		entity @skip(if: $skip3pEntityHydration) {
			${(0, $9GAIA.ExternalMessagePartial)}
		}
		initialContributors {
			name
			id
			externalId
		}
		containerName @optIn(to: "SearchPerformanceImprovementChanges")
		allContributors @optIn(to: "SearchPerformanceImprovementChanges") {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
	}
	entity @skip(if: $skip3pEntityHydration) {
		${(0, $1qzQx.ExternalBranchPartial)}
		${(0, $H9Wft.ExternalCalendarEventPartial)}
		${(0, $idD0I.ExternalCampaignPartial)}
		${(0, $j325C.ExternalCasePartial)}
		${(0, $hV1Vq.ExternalLeadPartial)}
		${(0, $abc4G.ExternalDealPartial)}
		${(0, $3e9cd.ExternalCustomerOrgPartial)}
		${(0, $kg3OO.ExternalCommitPartial)}
		${(0, $9GHVW.ExternalConversationPartial)}
		${(0, $9kmby.ExternalDesignPartial)}
		${(0, $op8eC.ExternalDashboardPartial)}
		${(0, $d7k9v.ExternalDataTablePartial)}
		${(0, $j8hui.ExternalDocumentPartial)}
		${(0, $9GAIA.ExternalMessagePartial)}
		${(0, $8UHlo.ExternalProjectPartial)}
		${(0, $9dBo7.ExternalPullRequestPartial)}
		${(0, $8fx85.ExternalRepositoryPartial)}
		${(0, $h0zJb.ExternalVideoPartial)}
		${(0, $byWMV.ExternalWorkItemPartial)}
		${(0, $dR4Df.ExternalCommentPartial)}
		${(0, $lUvMj.ExternalRemoteLinkPartial)}
	}
	entity @include(if: $includeGithubEntityHydration) {
		${(0, $9dBo7.ExternalPullRequestPartial)}
		${(0, $8fx85.ExternalRepositoryPartial)}
		${(0, $byWMV.ExternalWorkItemPartial)}
	}
	entity @include(if: $includeLoomVideoMetadata) {
		... on ExternalVideo {
			durationInSeconds
			createdBy {
				thirdPartyUser {
					name
				}
				user {
					name
				}
			}
		}
	}
	containerName @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind)
	allContributors @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		accountId
		externalId
		name
		nickname
		email
		picture
		extendedProfile {
			jobTitle
			department
			organization
		}
	}
	linkedResults @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
var $7cea49c1b7fc8fb2$var$AccountStatus = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus[AccountStatus["active"] = 0] = "active";
    AccountStatus[AccountStatus["inactive"] = 1] = "inactive";
    AccountStatus[AccountStatus["closed"] = 2] = "closed";
    return AccountStatus;
}($7cea49c1b7fc8fb2$var$AccountStatus || {});
var $7cea49c1b7fc8fb2$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory[ExternalDocumentCategory["ARCHIVE"] = 0] = "ARCHIVE";
    ExternalDocumentCategory[ExternalDocumentCategory["AUDIO"] = 1] = "AUDIO";
    ExternalDocumentCategory[ExternalDocumentCategory["CODE"] = 2] = "CODE";
    ExternalDocumentCategory[ExternalDocumentCategory["DOCUMENT"] = 3] = "DOCUMENT";
    ExternalDocumentCategory[ExternalDocumentCategory["FOLDER"] = 4] = "FOLDER";
    ExternalDocumentCategory[ExternalDocumentCategory["FORM"] = 5] = "FORM";
    ExternalDocumentCategory[ExternalDocumentCategory["IMAGE"] = 6] = "IMAGE";
    ExternalDocumentCategory[ExternalDocumentCategory["OTHER"] = 7] = "OTHER";
    ExternalDocumentCategory[ExternalDocumentCategory["PDF"] = 8] = "PDF";
    ExternalDocumentCategory[ExternalDocumentCategory["PRESENTATION"] = 9] = "PRESENTATION";
    ExternalDocumentCategory[ExternalDocumentCategory["SHORTCUT"] = 10] = "SHORTCUT";
    ExternalDocumentCategory[ExternalDocumentCategory["SPREADSHEET"] = 11] = "SPREADSHEET";
    ExternalDocumentCategory[ExternalDocumentCategory["VIDEO"] = 12] = "VIDEO";
    ExternalDocumentCategory[ExternalDocumentCategory["WEB_PAGE"] = 13] = "WEB_PAGE";
    return ExternalDocumentCategory;
}($7cea49c1b7fc8fb2$var$ExternalDocumentCategory || {});
var $7cea49c1b7fc8fb2$var$ExternalEventType = /*#__PURE__*/ function(ExternalEventType) {
    ExternalEventType["APPOINTMENT"] = "appointment";
    ExternalEventType["BIRTHDAY"] = "birthday";
    ExternalEventType["DEFAULT"] = "default";
    ExternalEventType["EVENT"] = "event";
    ExternalEventType["FOCUS_TIME"] = "focus_time";
    ExternalEventType["OUT_OF_OFFICE"] = "out_of_office";
    ExternalEventType["REMINDER"] = "reminder";
    ExternalEventType["TASK"] = "task";
    ExternalEventType["WORKING_LOCATION"] = "working_location";
    return ExternalEventType;
}($7cea49c1b7fc8fb2$var$ExternalEventType || {});
var $7cea49c1b7fc8fb2$var$ExternalAttendeeRsvpStatus = /*#__PURE__*/ function(ExternalAttendeeRsvpStatus) {
    ExternalAttendeeRsvpStatus["ACCEPTED"] = "accepted";
    ExternalAttendeeRsvpStatus["DECLINED"] = "declined";
    ExternalAttendeeRsvpStatus["NOT_RESPONDED"] = "not_responded";
    ExternalAttendeeRsvpStatus["OTHER"] = "other";
    ExternalAttendeeRsvpStatus["TENATIVELY_ACCEPTED"] = "tenatively_accepted";
    return ExternalAttendeeRsvpStatus;
}($7cea49c1b7fc8fb2$var$ExternalAttendeeRsvpStatus || {});
var $7cea49c1b7fc8fb2$var$ExternalWorkItemType = /*#__PURE__*/ function(ExternalWorkItemType) {
    ExternalWorkItemType["TASK"] = "task";
    ExternalWorkItemType["DEFAULT_TASK"] = "default_task";
    ExternalWorkItemType["WORK_ITEM"] = "work_item";
    ExternalWorkItemType["EPIC"] = "epic";
    ExternalWorkItemType["BUG"] = "bug";
    ExternalWorkItemType["STORY"] = "story";
    ExternalWorkItemType["MILESTONE"] = "milestone";
    ExternalWorkItemType["SECTION"] = "section";
    ExternalWorkItemType["APPROVAL"] = "approval";
    ExternalWorkItemType["PROBLEM"] = "problem";
    ExternalWorkItemType["INCIDENT"] = "incident";
    ExternalWorkItemType["QUESTION"] = "question";
    ExternalWorkItemType["ISSUE"] = "issue";
    ExternalWorkItemType["TICKET"] = "ticket";
    ExternalWorkItemType["REQUESTED_ITEM"] = "requested_item";
    ExternalWorkItemType["CATALOG_ITEM"] = "catalog_item";
    ExternalWorkItemType["OTHER"] = "other";
    return ExternalWorkItemType;
}($7cea49c1b7fc8fb2$var$ExternalWorkItemType || {});
var $7cea49c1b7fc8fb2$var$ExternalMembershipType = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["PRIVATE"] = "PRIVATE";
    ExternalMembershipType["PUBLIC"] = "PUBLIC";
    ExternalMembershipType["SHARED"] = "SHARED";
    return ExternalMembershipType;
}($7cea49c1b7fc8fb2$var$ExternalMembershipType || {});
var $7cea49c1b7fc8fb2$var$ExternalConversationType = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["CHANNEL"] = "CHANNEL";
    ExternalConversationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    ExternalConversationType["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}($7cea49c1b7fc8fb2$var$ExternalConversationType || {});
var $7cea49c1b7fc8fb2$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["BRANCH"] = "branch";
    ResourceType["CALENDAR_EVENT"] = "calendar-event";
    ResourceType["CAMPAIGN"] = "campaign";
    ResourceType["CASE"] = "case";
    ResourceType["LEAD"] = "lead";
    ResourceType["DEAL"] = "deal";
    ResourceType["CUSTOMER_ORG"] = "customer-org";
    ResourceType["CUSTOMER_CONTACT"] = "customer-contact";
    ResourceType["COMMENT"] = "comment";
    ResourceType["COMMIT"] = "commit";
    ResourceType["CONVERSATION"] = "conversation";
    ResourceType["DESIGN"] = "design";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["MESSAGE"] = "message";
    ResourceType["PROJECT"] = "project";
    ResourceType["PULL_REQUEST"] = "pull-request";
    ResourceType["REPOSITORY"] = "repository";
    ResourceType["VIDEO"] = "video";
    ResourceType["WORK_ITEM"] = "work-item";
    ResourceType["SPACE"] = "space";
    ResourceType["REMOTE_LINK"] = "remote-link";
    ResourceType["DASHBOARD"] = "dashboard";
    ResourceType["DATA_TABLE"] = "data-table";
    return ResourceType;
}({});
const $7cea49c1b7fc8fb2$export$e169b729a14ad5f8 = ()=>{
    // One inline fragment per top-level 3P SearchResult subtype. Code results are a
    // distinct GraphQL type (SearchResultGraphCode); all other 3P documents share
    // SearchResultGraphDocument and discriminate via `entity { ... on ExternalX }`.
    // SearchResultGraphCode is gated to limit blast radius until the experiment ships.
    const partials = [
        $7cea49c1b7fc8fb2$var$SearchThirdPartyGraphDocumentPartial
    ];
    // Quick Find code search will be removed until latency is drastsically improved.
    // Crrently it is just here for testing.
    if ((0, $coUcA.isLegacyCodeSearchEnabled)()) partials.push((0, $3UgcO.ExternalCodePartial));
    return partials.join('\n');
};
const $7cea49c1b7fc8fb2$export$7dd4baba91338caa = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $7cea49c1b7fc8fb2$export$6c20afe8743cb761 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "conversation";
};
const $7cea49c1b7fc8fb2$export$8dc9be81b5b6266b = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "design";
};
const $7cea49c1b7fc8fb2$export$33e8c1bbf9148b0e = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "message";
};
const $7cea49c1b7fc8fb2$export$9cfcc6ca7fb6e839 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "video";
};
const $7cea49c1b7fc8fb2$export$9a3959a38fa67fd0 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "branch";
};
const $7cea49c1b7fc8fb2$export$ece3e91c16809748 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "commit";
};
const $7cea49c1b7fc8fb2$export$5bdc07901b0022c6 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "comment";
};
const $7cea49c1b7fc8fb2$export$5ba84cc314040e0c = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "pull-request";
};
const $7cea49c1b7fc8fb2$export$9c4afe4ccb574692 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "repository";
};
const $7cea49c1b7fc8fb2$export$32c06ee7e0e9b79e = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "document";
};
const $7cea49c1b7fc8fb2$export$791f1b4852e2a184 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "project";
};
const $7cea49c1b7fc8fb2$export$92306a022e0703e0 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "calendar-event";
};
const $7cea49c1b7fc8fb2$export$e23befac5f018c0b = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "deal";
};
const $7cea49c1b7fc8fb2$export$8d26baa8fb7886c4 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "case";
};
const $7cea49c1b7fc8fb2$export$92e7f2bf63e191a = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "lead";
};
const $7cea49c1b7fc8fb2$export$4b4ac5f6534c6ce2 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "campaign";
};
const $7cea49c1b7fc8fb2$export$1aff0f2a91c0ea03 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "customer-org";
};
const $7cea49c1b7fc8fb2$export$40f90006d8fc8dee = (partial)=>$7cea49c1b7fc8fb2$export$33e8c1bbf9148b0e(partial) && partial.integrationId === $7cea49c1b7fc8fb2$var$TEAMS_INTEGRATION_ARI;
const $7cea49c1b7fc8fb2$export$162dad7a1238d377 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "work-item";
};
const $7cea49c1b7fc8fb2$export$b10c98faa2e0b99a = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "dashboard";
};
const $7cea49c1b7fc8fb2$export$a24b6b49e5e27b50 = (partial)=>partial.__typename === 'SearchResultGraphCode';
const $7cea49c1b7fc8fb2$export$c9efee8db4eaf865 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "data-table";
};
module.exports["ResourceType"] = $7cea49c1b7fc8fb2$export$c6f9da6f70cfc2eb;
module.exports["getGraphPartials"] = $7cea49c1b7fc8fb2$export$e169b729a14ad5f8;
module.exports["isSearchResultGraphEntity"] = $7cea49c1b7fc8fb2$export$7dd4baba91338caa;
module.exports["isVideoEntity"] = $7cea49c1b7fc8fb2$export$9cfcc6ca7fb6e839;
module.exports["isPullRequestEntity"] = $7cea49c1b7fc8fb2$export$5ba84cc314040e0c;
module.exports["isDocumentEntity"] = $7cea49c1b7fc8fb2$export$32c06ee7e0e9b79e;
module.exports["isWorkItemEntity"] = $7cea49c1b7fc8fb2$export$162dad7a1238d377;
module.exports["isCodeResult"] = $7cea49c1b7fc8fb2$export$a24b6b49e5e27b50;

});

parcelRegister("1qzQx", function(module, exports) {
const $43438089e0bb18a5$export$5b6173385ccfaeaa = `
... on ExternalBranch {
    name
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalBranchPartial"] = $43438089e0bb18a5$export$5b6173385ccfaeaa;

});

parcelRegister("H9Wft", function(module, exports) {
const $5426fa20c232f2c4$export$253480f0254db4f8 = `
... on ExternalCalendarEvent {
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	attendees {
		isOptional
		rsvpStatus
		user {
			thirdPartyUser {
				id
				email
				name
			}
			user {
				name
			}
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			externalId
			name
			picture
		}
		user {
			name
		}
	}
	eventEndTime
	eventStartTime
	eventType
	location {
		address
		coordinates
		name
		url
	}
	recurringEventId
	videoMeetingUrl
}
`;
module.exports["ExternalCalendarEventPartial"] = $5426fa20c232f2c4$export$253480f0254db4f8;

});

parcelRegister("idD0I", function(module, exports) {
const $9fab2a79457ea924$export$e6966bd80a36700a = `
... on ExternalCampaign {
	status
	startDate
	endDate
	lastUpdated
	owners {
		thirdPartyUser {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
}
`;
module.exports["ExternalCampaignPartial"] = $9fab2a79457ea924$export$e6966bd80a36700a;

});

parcelRegister("j325C", function(module, exports) {
const $148eecc81654df3e$export$86a2488e87c72bef = `
... on ExternalCase {
	displayNumber
	status
	isClosed
	lastUpdated
	owners {
		thirdPartyUser {
			accountId
			externalId
			name
			email
			id
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalCustomerOrg {
			id
			displayName
		}
	}
}
`;
module.exports["ExternalCasePartial"] = $148eecc81654df3e$export$86a2488e87c72bef;

});

parcelRegister("3UgcO", function(module, exports) {
const $b757b8ad21357e78$export$f68956972379b38e = `
... on SearchResultGraphCode {
    path
    repository {
        name
    }
}
`;
module.exports["ExternalCodePartial"] = $b757b8ad21357e78$export$f68956972379b38e;

});

parcelRegister("dR4Df", function(module, exports) {
const $2694d7ba17518777$export$fd6f695cd68738d3 = `
... on ExternalComment {
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalCommentPartial"] = $2694d7ba17518777$export$fd6f695cd68738d3;

});

parcelRegister("kg3OO", function(module, exports) {
const $78cf6920f86363d6$export$3dcd3e619ad10a8c = `
... on ExternalCommit {
    author {
        user {
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository{
            name
        }
    }
}
`;
module.exports["ExternalCommitPartial"] = $78cf6920f86363d6$export$3dcd3e619ad10a8c;

});

parcelRegister("9GHVW", function(module, exports) {
const $9d113d470662ea74$export$4597d51c3a28368e = `
... on ExternalConversation {
    id
    memberCount
    displayName
    membershipType
    workspace
    topic
    members {
        thirdPartyUser {
            id
            name
        }
        user {
            id
            name
        }
    }
}
`;
module.exports["ExternalConversationPartial"] = $9d113d470662ea74$export$4597d51c3a28368e;

});

parcelRegister("3e9cd", function(module, exports) {
const $294804153487137a$export$7a4547f8268cefd4 = `
... on ExternalCustomerOrg {
	country
	accountType
	thirdPartyId
	websiteUrl
	industry
	displayName
	contributors {
		thirdPartyUser {
			id
			name
		}
	}
	contacts {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2"){
		...on ExternalCustomerOrg {
			id
			displayName
		}
	}
	customerOrgLastActivity {
		lastActivityAt
		event
	}
	lifeTimeValue {
		value
		currencyCode
	}
}
`;
module.exports["ExternalCustomerOrgPartial"] = $294804153487137a$export$7a4547f8268cefd4;

});

parcelRegister("op8eC", function(module, exports) {
const $b70b8e66fb8813f5$export$7192c9d070d6e5d6 = `
... on ExternalDashboard {
	id
	url
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	elements {
		name
		innerComponents
	}
	pages {
		name
	}
}
`;
module.exports["ExternalDashboardPartial"] = $b70b8e66fb8813f5$export$7192c9d070d6e5d6;

});

parcelRegister("d7k9v", function(module, exports) {
const $537c1e2032e51776$export$9f456561562ee774 = `
... on ExternalDataTable {
	id
	url
	dataTableType: type
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	columns {
		name
		columnType
		description
		isRequired
	}
}
`;
module.exports["ExternalDataTablePartial"] = $537c1e2032e51776$export$9f456561562ee774;

});

parcelRegister("abc4G", function(module, exports) {
const $1c3d305843ceb449$export$d80c383820958dae = `
... on ExternalDeal {
	stage
	accountName
	dealClosedAt
	isClosed
	thirdPartyId
	parentId
	lastActivity {
		lastActivityAt
		event
	}
	opportunityAmount {
		value
		currencyCode
	}
	contributors {
		user {
			thirdPartyUser {
				id
				name
			}
		}
	}
	contact {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalCustomerOrg {
          id
          displayName
        }
    }
}
`;
module.exports["ExternalDealPartial"] = $1c3d305843ceb449$export$d80c383820958dae;

});

parcelRegister("9kmby", function(module, exports) {
const $262146a3ee752664$export$5eda2cda79f28143 = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;
module.exports["ExternalDesignPartial"] = $262146a3ee752664$export$5eda2cda79f28143;

});

parcelRegister("j8hui", function(module, exports) {
const $f5f5770abca4ed75$export$6193eef58692a804 = `
... on ExternalDocument {
    type {
        iconUrl
    }
    thirdPartyId
    parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalDocument {
            displayName
            url
        }
    }
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
            displayName
            url
		}
	}
    reactions {
        reactionType
        total
    }
}
`;
module.exports["ExternalDocumentPartial"] = $f5f5770abca4ed75$export$6193eef58692a804;

});

parcelRegister("hV1Vq", function(module, exports) {
const $88d795ef5725e089$export$4396a1e234d5b991 = `
... on ExternalLead {
	status
	lastUpdated
	owners {
		thirdPartyUser {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
}
`;
module.exports["ExternalLeadPartial"] = $88d795ef5725e089$export$4396a1e234d5b991;

});

parcelRegister("9GAIA", function(module, exports) {
const $748b839adcbb907e$export$3b9ed83b2b731ba0 = `
... on ExternalMessage {
    lastUpdated
    lastActive
    description
    reactionCount
    attachments {
	    title
        mimeType
        thumbnailUrl
        url
    }
    createdBy {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            nickname
            email
			picture
            extendedProfile {
                jobTitle
                department
                organization
            }
        }
        user {
            id
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalConversation {
            id
            displayName
            memberCount
            membershipType
            type
            members {
                thirdPartyUser {
                    id
                    name
                    nickname
                    email
                    extendedProfile {
                        jobTitle
                        department
                        organization
                    }
                }
            }
        }
    }
    associatedWith {
        edges {
            node {
                id
                createdBy {
                    thirdPartyUser {
                        id
                        accountId
                        externalId
                        name
                        email
                    }
                }
                entity {
					__typename
					... on ExternalConversation {
						id
						displayName
						channelId:externalId
					}
					... on ThirdPartyUser {
                        id
                        email
						externalId
                        name
                        nickname
                        picture
                        extendedProfile {
                            jobTitle
                            department
                            organization
                        }
                    }
                }
            }
        }
    }
}
`;
module.exports["ExternalMessagePartial"] = $748b839adcbb907e$export$3b9ed83b2b731ba0;

});

parcelRegister("8UHlo", function(module, exports) {
const $ed95a68ae80492ce$export$f35cf9a497ba81f2 = `
... on ExternalProject {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	key
	status
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalProjectPartial"] = $ed95a68ae80492ce$export$f35cf9a497ba81f2;

});

parcelRegister("9dBo7", function(module, exports) {
const $732513b7ebdc37d6$export$fa7eefb2a03609fe = `
... on ExternalPullRequest {
    title
    lastUpdate
	pullRequestId
	pullRequestStatus: status
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalPullRequestPartial"] = $732513b7ebdc37d6$export$fa7eefb2a03609fe;

});

parcelRegister("lUvMj", function(module, exports) {
const $a0269cbba7ec258c$export$2d22922c940459cd = `
... on ExternalRemoteLink {
  thumbnail {
    externalUrl
  }
}
`;
module.exports["ExternalRemoteLinkPartial"] = $a0269cbba7ec258c$export$2d22922c940459cd;

});

parcelRegister("8fx85", function(module, exports) {
const $b845bd70571620dd$export$82972f33e243e789 = `
... on ExternalRepository {
    name
}
`;
module.exports["ExternalRepositoryPartial"] = $b845bd70571620dd$export$82972f33e243e789;

});

parcelRegister("h0zJb", function(module, exports) {
const $dbd577a8d8c9a91d$export$d872aa2b0db5eb10 = `
... on ExternalVideo {
    durationInSeconds
    embedUrl
    thumbnailUrl
    entityExtendedValues {
        fieldId
        fieldValue
        fieldDisplayName {
            displayName
        }
        isDisplayed
        dataType
    }
    chapters {
        title
        startTimeInSeconds
    }
    createdBy {
        thirdPartyUser {
            id
            email
            name
        }
        user {
            name
        }
    }
}
`;
module.exports["ExternalVideoPartial"] = $dbd577a8d8c9a91d$export$d872aa2b0db5eb10;

});

parcelRegister("byWMV", function(module, exports) {
const $f9239d79f74c5c38$export$a50a1db4dd4e2aa3 = `
... on ExternalWorkItem {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	collaborators {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	exceedsMaxCollaborators
	workItemProject {
		id
		name
	}
	status
	subtype
	team
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalWorkItemPartial"] = $f9239d79f74c5c38$export$a50a1db4dd4e2aa3;

});

parcelRegister("lwXsc", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $c0671df377997fec$var$SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;
const $c0671df377997fec$export$d40aaa445b6f7858 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloBoard';
};
// oxlint-disable-next-line eslint/no-redeclare
const $c0671df377997fec$var$SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
	linkedResults {
		id
		datasourceId @include(if: $includeDatasourceId)
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $c0671df377997fec$export$980cabf11d827509 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloCard';
};
const $c0671df377997fec$export$6ed59678949b7701 = (partial)=>{
    return $c0671df377997fec$export$d40aaa445b6f7858(partial) || $c0671df377997fec$export$980cabf11d827509(partial);
};
const $c0671df377997fec$export$73993ded7a48a460 = ()=>{
    return `
		${$c0671df377997fec$var$SearchResultTrelloBoard}
		${$c0671df377997fec$var$SearchResultTrelloCard}
	`;
};
module.exports["isSearchTrelloPartial"] = $c0671df377997fec$export$6ed59678949b7701;
module.exports["getTrelloPartials"] = $c0671df377997fec$export$73993ded7a48a460;

});

parcelRegister("aqAfG", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 

const $04ba0efeefc046b8$export$a0110d095394669e = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    CustomerServiceManagement: 'jira-customer-service',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    Talent: 'radar'
};
const $04ba0efeefc046b8$export$deaa7a6e1403419a = Object.values($04ba0efeefc046b8$export$a0110d095394669e);
const $04ba0efeefc046b8$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $04ba0efeefc046b8$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($04ba0efeefc046b8$export$a93cddd79e3ea530).includes(key);
};
module.exports["ProductKeys1P"] = $04ba0efeefc046b8$export$a0110d095394669e;
module.exports["ARI_EXTRACTED_1P_KEYS"] = $04ba0efeefc046b8$export$deaa7a6e1403419a;
module.exports["NounKeys"] = $04ba0efeefc046b8$export$a93cddd79e3ea530;

});

parcelRegister("aoy1P", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 
var $3L2aM = parcelRequire("3L2aM");

const $b2c70616c23e337b$export$e88fb694deeca21a = 'smartlinks-connector';
const $b2c70616c23e337b$export$83921c8e433ffcd9 = 'lite-connector-';
const $b2c70616c23e337b$export$7ad7a95070d8bb93 = (0, $3L2aM.ConnectorSources).Federated;
const $b2c70616c23e337b$export$e3a0662f044cd99b = (0, $3L2aM.ConnectorSources).Lite;
const $b2c70616c23e337b$export$c14e5e3fa6d8b46 = (0, $3L2aM.ConnectorSources).Smartlinks;
const $b2c70616c23e337b$export$aa06c0b5cc41ad9a = (0, $3L2aM.ConnectorSources).Full;
const $b2c70616c23e337b$export$37e0ed5b7fa94503 = (0, $3L2aM.ConnectorSources).Backfill;
const $b2c70616c23e337b$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $3L2aM.ConnectorSources)).includes(value);
};
const $b2c70616c23e337b$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $b2c70616c23e337b$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($b2c70616c23e337b$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $b2c70616c23e337b$var$forgeConnectorIconsRegistry = new Map();
const $b2c70616c23e337b$export$4e96e986802512bd = (productKey, icon)=>{
    $b2c70616c23e337b$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $b2c70616c23e337b$export$2f2bd8960b497856 = (productKey)=>{
    return $b2c70616c23e337b$var$forgeConnectorIconsRegistry.get(productKey);
};
const $b2c70616c23e337b$export$2768da79a2599ca3 = ()=>{
    $b2c70616c23e337b$var$forgeConnectorIconsRegistry.clear();
};
module.exports["SMARTLINKS_RESOURCE_TYPE_PREFIX"] = $b2c70616c23e337b$export$e88fb694deeca21a;
module.exports["LITE_CONNECTOR_SOURCE_PREFIX"] = $b2c70616c23e337b$export$83921c8e433ffcd9;
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$aa06c0b5cc41ad9a;
module.exports["FORGE_CONNECTOR_PREFIX"] = $b2c70616c23e337b$export$9a0cf6dd1d986cc2;
module.exports["isForgeConnectorProductKey"] = $b2c70616c23e337b$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $b2c70616c23e337b$export$4e96e986802512bd;
module.exports["getForgeConnectorIcon"] = $b2c70616c23e337b$export$2f2bd8960b497856;

});

parcelRegister("3L2aM", function(module, exports) {
const $c439ce144d84d7bc$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $c439ce144d84d7bc$export$499e9a6668a55181;

});

parcelRegister("eSwze", function(module, exports) {

var $aoy1P = parcelRequire("aoy1P");


var $i52Hf = parcelRequire("i52Hf");


var $5PPrc = parcelRequire("5PPrc");

const $2c98e8bd8cbf6213$export$70bfed163de04616 = (forgeConnector, onForgeConnectorTypeMapping)=>{
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $i52Hf.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $i52Hf.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    (0, $aoy1P.registerForgeConnectorIcon)(productKey, icon);
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $5PPrc.mapAtisToTypeFilterConfig)(forgeConnector.entityTypes) : new Map();
    if (onForgeConnectorTypeMapping) onForgeConnectorTypeMapping(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        // `forgeConnector.integrationId` is a `string` (the wire shape).
        // `PlatformIntegrationAri` is a branded nominal type. The value at
        // this site is already an integration ARI (built server-side by the
        // platform integration registry), so the cast is structurally safe;
        // the `unknown` hop exists only because TS rejects direct
        // `string`-to-branded assignment. Same pattern is used in
        // `adapter.ts`. RAOC-22 follow-up: tighten in search-client by
        // exposing a constructor for branded ARIs.
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        iconUrl: forgeConnector.lightIcon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $aoy1P.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
module.exports["mapForgeConnectorToThirdPartyConfig"] = $2c98e8bd8cbf6213$export$70bfed163de04616;

});

parcelRegister("7pCWA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $4o0zT = parcelRequire("4o0zT");


var $iJrDI = parcelRequire("iJrDI");


var $RMIZY = parcelRequire("RMIZY");

const $46a1ea770063856a$var$LS_KEY = 'rovo-connectors-metadata';
const $46a1ea770063856a$var$getPersistedMetadata = ()=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = localStorage.getItem($46a1ea770063856a$var$LS_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object') return {
                lastUsedAt: parsed.lastUsedAt ?? {}
            };
        }
    } catch  {
    // localStorage may be unavailable or corrupted
    }
    return {
        lastUsedAt: {}
    };
};
const $46a1ea770063856a$var$persistMetadata = (connectors)=>{
    try {
        const metadata = {
            lastUsedAt: {}
        };
        for (const [source, connector] of Object.entries(connectors))if (connector.lastUsedAt) metadata.lastUsedAt[source] = connector.lastUsedAt;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem($46a1ea770063856a$var$LS_KEY, JSON.stringify(metadata));
    } catch  {
    // localStorage may be unavailable
    }
};
const $46a1ea770063856a$var$initialState = {
    connectors: {},
    isFetching: false,
    error: null,
    lastFetchedAt: null,
    hasFetchAttempted: false
};
const $46a1ea770063856a$export$a7a6b0f2cd14ebd2 = (0, $8s9DV.createStore)({
    name: 'connectorsStore',
    initialState: $46a1ea770063856a$var$initialState,
    actions: {
        setKnowledgeSources: (response)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors;
                const persisted = $46a1ea770063856a$var$getPersistedMetadata();
                const now = Date.now();
                const connectors = {};
                response.knowledgeSources.forEach((source)=>{
                    const prev = existing[source.source];
                    connectors[source.source] = {
                        ...source,
                        lastUsedAt: prev?.lastUsedAt ?? persisted.lastUsedAt[source.source]
                    };
                });
                const nextState = {
                    connectors: connectors,
                    isFetching: false,
                    error: null,
                    lastFetchedAt: now,
                    hasFetchAttempted: true
                };
                setState(nextState);
            },
        setError: (error)=>({ setState: setState })=>{
                setState({
                    error: error,
                    isFetching: false
                });
            },
        markUserConnected: (source)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors[source];
                if (!existing) return;
                const nextState = {
                    ...getState(),
                    connectors: {
                        ...getState().connectors,
                        [source]: {
                            ...existing,
                            isUserOAuthed: true
                        }
                    }
                };
                setState(nextState);
                $46a1ea770063856a$var$persistMetadata(nextState.connectors);
            },
        markLastUsed: (source)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors[source];
                if (!existing) return;
                const nextState = {
                    ...getState(),
                    connectors: {
                        ...getState().connectors,
                        [source]: {
                            ...existing,
                            lastUsedAt: Date.now()
                        }
                    }
                };
                setState(nextState);
                $46a1ea770063856a$var$persistMetadata(nextState.connectors);
            },
        fetchIfEmpty: (fetcher, _siteId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { isFetching: isFetching, lastFetchedAt: lastFetchedAt, hasFetchAttempted: hasFetchAttempted } = getState();
                if (isFetching || lastFetchedAt !== null || hasFetchAttempted) return;
                setState({
                    isFetching: true,
                    hasFetchAttempted: true
                });
                try {
                    const response = await fetcher();
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setKnowledgeSources(response));
                } catch (error) {
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setError(error instanceof Error ? error : new Error(String(error))));
                }
            },
        prefetchIfEmpty: (fetcher, _siteId, callbacks)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { isFetching: isFetching, lastFetchedAt: lastFetchedAt, hasFetchAttempted: hasFetchAttempted } = getState();
                if (isFetching || lastFetchedAt !== null || hasFetchAttempted) return;
                callbacks?.onStart?.();
                setState({
                    isFetching: true
                });
                try {
                    const response = await fetcher();
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setKnowledgeSources(response));
                    callbacks?.onSuccess?.();
                } catch (error) {
                    const normalizedError = error instanceof Error ? error : new Error(String(error));
                    setState({
                        error: normalizedError,
                        isFetching: false,
                        hasFetchAttempted: false
                    });
                    callbacks?.onError?.(normalizedError);
                }
            }
    }
});
const $46a1ea770063856a$export$7937e7630f0056f6 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$898eb43e6b581728 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useKnowledgeSourcesStoreFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$7937e7630f0056f6(...args);
const $46a1ea770063856a$export$2747a5ab28531a82 = (0, $kBr4q.createActionsHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$84d5e4e34c83f341 = ()=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useKnowledgeSourcesActionsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$2747a5ab28531a82(); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$c04fb020edc7a7e1 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.connectors
});
const $46a1ea770063856a$export$16923bfe907be002 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$c04fb020edc7a7e1(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$f556525c4fd00510 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>Object.values(state.connectors)
});
const $46a1ea770063856a$var$isOAuthOptionalSource = ({ resourceType: resourceType })=>resourceType === 'google-drive-connector' || resourceType === 'github-connector';
const $46a1ea770063856a$export$dde4871ee2244748 = (...args)=>{
    const [sources, actions] = (0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useEnabledKnowledgeSourcesFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$f556525c4fd00510(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
    const isOAuthOptional = sources.some($46a1ea770063856a$var$isOAuthOptionalSource) && (0, $4o0zT.isExperimentEnabled)('ai_3p_3lo-removed-chat-filters');
    // This controls source availability. Explicit selections remain in the chat mode store.
    const enabledSources = (0, $cozmU.useMemo)(()=>isOAuthOptional ? sources.map((source)=>$46a1ea770063856a$var$isOAuthOptionalSource(source) ? {
                ...source,
                isUserOAuthed: true
            } : source) : sources, [
        isOAuthOptional,
        sources
    ]);
    return [
        enabledSources,
        actions
    ];
};
const $46a1ea770063856a$export$e19a704921e382b = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.isFetching
});
const $46a1ea770063856a$export$b0cd8ed831d57493 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsIsFetchingFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$e19a704921e382b(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$274cdd492c0627f7 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.hasFetchAttempted && !state.isFetching
});
const $46a1ea770063856a$export$616b42d985fb1595 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsDataReadyFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$274cdd492c0627f7(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$aed048705043d019 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.error
});
const $46a1ea770063856a$export$7033e54b5ffa8997 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsErrorFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$aed048705043d019(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
// ---------------------------------------------------------------------------
// isNewlyEnabledApp + useNewlyEnabledConnectors
// ---------------------------------------------------------------------------
const $46a1ea770063856a$var$NEW_APP_WINDOW_MS = 2592000000; // 30 days
const $46a1ea770063856a$export$721bae997d4403d0 = (connector)=>{
    if (connector.isUserOAuthed) return false;
    if (!connector.connectorCreatedAt) return false;
    const enabledAt = new Date(connector.connectorCreatedAt).getTime();
    if (isNaN(enabledAt)) return false;
    return Date.now() - enabledAt <= $46a1ea770063856a$var$NEW_APP_WINDOW_MS;
};
const $46a1ea770063856a$var$newlyEnabledConnectorsSelector = (0, $fjHkB.createSelector)((state)=>state.connectors, (connectors)=>Object.values(connectors).filter($46a1ea770063856a$export$721bae997d4403d0));
const $46a1ea770063856a$export$c843a631d8e0397 = (0, $kBr4q.createStateHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: $46a1ea770063856a$var$newlyEnabledConnectorsSelector
});
const $46a1ea770063856a$export$863e0dc987bff04b = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useNewlyEnabledConnectorsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$c843a631d8e0397(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$94f5eea2ae699a7b = (0, $kBr4q.createActionsHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$6c25604552e40c1b = ()=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorNudgeActionsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$94f5eea2ae699a7b(); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
module.exports["useKnowledgeSourcesStore"] = $46a1ea770063856a$export$898eb43e6b581728;
module.exports["useKnowledgeSourcesActions"] = $46a1ea770063856a$export$84d5e4e34c83f341;
module.exports["useConnectors"] = $46a1ea770063856a$export$16923bfe907be002;
module.exports["useEnabledKnowledgeSources"] = $46a1ea770063856a$export$dde4871ee2244748;
module.exports["useConnectorsIsFetching"] = $46a1ea770063856a$export$b0cd8ed831d57493;
module.exports["useConnectorsDataReady"] = $46a1ea770063856a$export$616b42d985fb1595;
module.exports["useConnectorsError"] = $46a1ea770063856a$export$7033e54b5ffa8997;
module.exports["isNewlyEnabledApp"] = $46a1ea770063856a$export$721bae997d4403d0;
module.exports["useNewlyEnabledConnectors"] = $46a1ea770063856a$export$863e0dc987bff04b;

});

parcelRegister("iJrDI", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $330c78dbc9702cc6$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $330c78dbc9702cc6$export$aa9f97d4dfccb6ff;

});

parcelRegister("RMIZY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $6nvQY = parcelRequire("6nvQY");


var $7pCWA = parcelRequire("7pCWA");


var $f4zze = parcelRequire("f4zze");

const $5a56dcf5e04d6ce9$var$warnNoop = (name)=>(...args)=>{
        // eslint-disable-next-line no-console
        console.warn(`[RAOC-23] No-op stub called: ${name}. Under rovo_cas_use_rovo_config FG, connectors-store actions are not yet wired.`, ...args);
    };
/**
 * No-op action stubs for the connectors-store *writes* that are not yet wired
 * on the rovo-config path.
 *
 * TODO RAOC-23: implement the remaining real actions backed by
 *               `useRovoConfigStore` (setKnowledgeSources, setError,
 *               markLastUsed)
 */ const $5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS = {
    setKnowledgeSources: $5a56dcf5e04d6ce9$var$warnNoop('setKnowledgeSources'),
    setError: $5a56dcf5e04d6ce9$var$warnNoop('setError'),
    markLastUsed: $5a56dcf5e04d6ce9$var$warnNoop('markLastUsed')
};
/**
 * Single co-located controller for the rovo-config FG path.
 *
 * Consolidates:
 *
 *   1. the captured tenant (`siteId` === cloudId) read back from
 *      {@link useRovoConfigSiteId};
 *   2. the connector read-state, fetched declaratively by
 *      `useRovoConfigStore({ cloudId })`; and
 *   3. the bound actions object (tenant-capturing `fetchIfEmpty` /
 *      `prefetchIfEmpty`, the real `markUserConnected`, and the remaining
 *      no-op writes).
 *
 * Every `*FromRovoConfig` selector hook delegates here and then projects the
 * slice of state it needs.
 */ const $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(16);
    const captureSiteId = (0, $f4zze.useCaptureRovoConfigSiteId)();
    const siteId = (0, $f4zze.useRovoConfigSiteId)();
    let t0;
    if ($[0] !== siteId) {
        t0 = {
            cloudId: siteId
        };
        $[0] = siteId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = (0, $6nvQY.useRovoConfigStore)(t0);
    let markUserConnected;
    let state;
    if ($[2] !== t1) {
        ({ markUserConnected: markUserConnected, ...state } = t1);
        $[2] = t1;
        $[3] = markUserConnected;
        $[4] = state;
    } else {
        markUserConnected = $[3];
        state = $[4];
    }
    let t2;
    if ($[5] !== captureSiteId) {
        t2 = async (_fetcher, siteId_0)=>{
            captureSiteId(siteId_0);
        };
        $[5] = captureSiteId;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = t2;
    let t4;
    if ($[7] !== captureSiteId) {
        t4 = async (_fetcher_0, siteId_1, callbacks)=>{
            callbacks?.onStart?.();
            captureSiteId(siteId_1);
        };
        $[7] = captureSiteId;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = t4;
    let t6;
    if ($[9] !== markUserConnected || $[10] !== t3 || $[11] !== t5) {
        t6 = {
            ...$5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS,
            markUserConnected: markUserConnected,
            fetchIfEmpty: t3,
            prefetchIfEmpty: t5
        };
        $[9] = markUserConnected;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actions = t6;
    const t7 = state;
    let t8;
    if ($[13] !== actions || $[14] !== t7) {
        t8 = [
            t7,
            actions
        ];
        $[13] = actions;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ()=>{
    const captureSiteId = (0, $f4zze.useCaptureRovoConfigSiteId)();
    const siteId = (0, $f4zze.useRovoConfigSiteId)();
    const { markUserConnected: markUserConnected, ...state } = (0, $6nvQY.useRovoConfigStore)({
        cloudId: siteId
    });
    const actions = (0, $cozmU.useMemo)(()=>({
            ...$5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS,
            markUserConnected: markUserConnected,
            fetchIfEmpty: async (_fetcher, siteId_0)=>{
                // Capture the tenant so this controller can drive
                // `useRovoConfigStore({ cloudId: siteId })`.
                captureSiteId(siteId_0);
            },
            prefetchIfEmpty: async (_fetcher_0, siteId_1, callbacks)=>{
                callbacks?.onStart?.();
                // Capture the tenant so this controller can drive
                // `useRovoConfigStore({ cloudId: siteId })`. The actual fetch
                // lifecycle (success/error) is owned by the declarative
                // `useRovoConfig` fetch, not by this stub.
                captureSiteId(siteId_1);
            }
        }), [
        captureSiteId,
        markUserConnected
    ]);
    return [
        state,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$1db0f214e585aaa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
} : ()=>$5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
const $5a56dcf5e04d6ce9$export$f6d78c12502aa095 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const [, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return actions;
} : ()=>{
    const [, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return actions;
};
const $5a56dcf5e04d6ce9$export$b3cad934ca5ab31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const t0 = state.connectors;
    let t1;
    if ($[0] !== actions || $[1] !== t0) {
        t1 = [
            t0,
            actions
        ];
        $[0] = actions;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.connectors,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6ffb976747141e7e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== state.connectors) {
        t0 = Object.values(state.connectors);
        $[0] = state.connectors;
        $[1] = t0;
    } else t0 = $[1];
    const sources = t0;
    let t1;
    if ($[2] !== sources || $[3] !== state.connectors) {
        t1 = (0, $iDrrr.fg)("platform_ai_mate_connector_injected_prompts") ? sources : Object.values(state.connectors);
        $[2] = sources;
        $[3] = state.connectors;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== actions || $[6] !== t1) {
        t2 = [
            t1,
            actions
        ];
        $[5] = actions;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const sources = (0, $cozmU.useMemo)(()=>Object.values(state.connectors), [
        state.connectors
    ]);
    return [
        (0, $iDrrr.fg)('platform_ai_mate_connector_injected_prompts') ? sources : Object.values(state.connectors),
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6fcdc8da0119c3fa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== actions || $[1] !== state.isFetching) {
        t0 = [
            state.isFetching,
            actions
        ];
        $[0] = actions;
        $[1] = state.isFetching;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.isFetching,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6346a2c706329c22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const t0 = state.hasFetchAttempted && !state.isFetching;
    let t1;
    if ($[0] !== actions || $[1] !== t0) {
        t1 = [
            t0,
            actions
        ];
        $[0] = actions;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.hasFetchAttempted && !state.isFetching,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$7114ed60de31baea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== actions || $[1] !== state.error) {
        t0 = [
            state.error,
            actions
        ];
        $[0] = actions;
        $[1] = state.error;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.error,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$b8e06e7766358e10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [state] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== state.connectors) {
        t0 = Object.values(state.connectors).filter((0, $7pCWA.isNewlyEnabledApp));
        $[0] = state.connectors;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [state] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return Object.values(state.connectors).filter((0, $7pCWA.isNewlyEnabledApp));
};
const $5a56dcf5e04d6ce9$export$4239da95f29be831 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [, t0] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const { markUserConnected: markUserConnected } = t0;
    let t1;
    if ($[0] !== markUserConnected) {
        t1 = {
            markUserConnected: markUserConnected
        };
        $[0] = markUserConnected;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const [, { markUserConnected: markUserConnected }] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return (0, $cozmU.useMemo)(()=>({
            markUserConnected: markUserConnected
        }), [
        markUserConnected
    ]);
};
module.exports["useKnowledgeSourcesStoreFromRovoConfig"] = $5a56dcf5e04d6ce9$export$1db0f214e585aaa;
module.exports["useKnowledgeSourcesActionsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$f6d78c12502aa095;
module.exports["useConnectorsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$b3cad934ca5ab31;
module.exports["useEnabledKnowledgeSourcesFromRovoConfig"] = $5a56dcf5e04d6ce9$export$6ffb976747141e7e;
module.exports["useConnectorsIsFetchingFromRovoConfig"] = $5a56dcf5e04d6ce9$export$6fcdc8da0119c3fa;
module.exports["useConnectorsDataReadyFromRovoConfig"] = $5a56dcf5e04d6ce9$export$6346a2c706329c22;
module.exports["useConnectorsErrorFromRovoConfig"] = $5a56dcf5e04d6ce9$export$7114ed60de31baea;
module.exports["useNewlyEnabledConnectorsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$b8e06e7766358e10;
module.exports["useConnectorNudgeActionsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$4239da95f29be831;

});

parcelRegister("6nvQY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $aoy1P = parcelRequire("aoy1P");


var $7DX5g = parcelRequire("7DX5g");


var $bli0p = parcelRequire("bli0p");


var $4D8Cc = parcelRequire("4D8Cc");


var $euapJ = parcelRequire("euapJ");


var $hleKH = parcelRequire("hleKH");


var $eIiZ2 = parcelRequire("eIiZ2");


var $3S9ut = parcelRequire("3S9ut");


var $esPYZ = parcelRequire("esPYZ");


var $6n4bK = parcelRequire("6n4bK");


var $hCtla = parcelRequire("hCtla");

const $9008ed4cacfbe41b$export$a031966c0660bfc9 = (props = {})=>{
    const { accessibleProducts: accessibleProducts, thirdPartyConfigs: thirdPartyConfigs, isConfigLoaded: isConfigLoaded, onOAuthSuccess: onOAuthSuccess } = (0, $hCtla.useRovoConfig)({
        cloudId: props.cloudId,
        // Intentionally not surfaced on UseRovoConfigStoreProps — see the
        // type-level comment on that interface for rationale.
        aggAbsoluteUrl: undefined,
        multiSiteSearchInRovo: undefined,
        preloadDataProvider: undefined,
        shouldBypassPreloadProvider: undefined,
        onForgeConnectorTypeMapping: undefined
    });
    // When `cloudId` is absent `useRovoConfig` short-circuits its fetch
    // effect, so `isConfigLoaded` would stay `false` forever and chat
    // consumers would spin indefinitely with no indication that no
    // request was ever in flight. Surface an "idle" store instead:
    // not fetching, not yet attempted, empty connectors.
    // TODO RAOC-23: tighten this — `cloudId` should be a *required* prop
    // on `UseRovoConfigStoreProps` once every chat call site can supply
    // it. Removing this branch will let TypeScript catch missing tenants
    // at the call site rather than papering over them at runtime.
    const isIdle = !props.cloudId;
    // Keep a live ref to the latest `thirdPartyConfigs` so `markUserConnected`
    // resolves the `source` against the *current* config rather than the
    // render-snapshot it closed over. `useRovoConfig`'s `onOAuthSuccess` mutates
    // via its own internal ref synchronously, so reading the snapshot here would
    // resolve against stale config if `markUserConnected` is called again before
    // the resulting re-render. Mirroring the ref keeps resolution and mutation
    // consistent.
    const thirdPartyConfigsRef = (0, $cozmU.useRef)(thirdPartyConfigs);
    thirdPartyConfigsRef.current = thirdPartyConfigs;
    // `markUserConnected(source)` — part of the store's public API (the OAuth
    // write counterpart to the connectors read-state above). The actual
    // chat-`source` → config-namespace product/datasource translation lives in
    // {@link resolveOAuthTargetForSource} to keep this hook a thin wiring layer.
    // No-op while idle, and no-op for sources with no matching 3P config.
    const markUserConnected = (0, $cozmU.useCallback)((source)=>{
        if (isIdle) return;
        const target = (0, $3S9ut.resolveOAuthTargetForSource)(thirdPartyConfigsRef.current, source);
        if (!target) return;
        onOAuthSuccess(target);
    }, [
        isIdle,
        onOAuthSuccess
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (isIdle) return {
            connectors: {},
            isFetching: false,
            error: null,
            lastFetchedAt: null,
            hasFetchAttempted: false,
            markUserConnected: markUserConnected
        };
        // Connectors are accumulated here, then sorted by friendlyName when
        // building the final record (see `sortConnectorsByFriendlyName`).
        const connectorEntries = [];
        // Source keys already produced, so 1P synthesis doesn't duplicate a
        // 3P connector.
        const seenKeys = new Set();
        // 3P keys with a null config — skip them in 1P synthesis below so they
        // aren't misclassified as authed 1P products.
        const skipped3pKeys = new Set();
        // 3P (and Forge) connectors — rich metadata from the config endpoint.
        // TODO: here we will need to async import/bind the 3P configs into the list from the endpoint (powers url, names, etc)
        if (thirdPartyConfigs) for (const [productKey, config] of Object.entries(thirdPartyConfigs)){
            // Some 3P connectors are returned by the config endpoint but are
            // not yet supported on the chat surface (e.g. `jsm-dc`), so skip
            // anything we do not yet support. This is the 3P counterpart to
            // the 1P allow-list guard below. See
            // {@link isSupportedThirdPartyConnector}.
            //
            // Mark the raw product key's chat form as handled so that, if the
            // unsupported key also appears in `accessibleProducts`, the 1P
            // loop below does not synthesise a phantom authed 1P entry for it
            // — the same reason the null-config and post-projection guards
            // populate `skipped3pKeys`.
            if (!(0, $eIiZ2.isSupportedThirdPartyConnector)(productKey)) {
                skipped3pKeys.add((0, $6n4bK.toChatSourceKey)(productKey));
                continue;
            }
            // Remap the config-namespace identifier to the chat-namespace
            // `source` so downstream chat selectors find the connector
            // regardless of the `rovo_cas_use_rovo_config` gate. 3P is keyed
            // on the unambiguous `resourceType` (connector key); when the
            // config is null we have no resourceType, so fall back to the
            // product-key remap. See {@link resolveChatSource}.
            const sourceKey = (0, $6n4bK.resolveChatSource)(productKey, config?.resourceType);
            if (!config) {
                skipped3pKeys.add(sourceKey);
                continue;
            }
            seenKeys.add(sourceKey);
            const hasAdminImportedUserLink = Boolean(config.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) && config.datasources?.some((datasource)=>datasource.authResolutionMode === 'ADMIN_IMPORTED_USER_LINK') && (0, $iDrrr.fg)('ai_3p_cds_auth_resolution_mode_flock'));
            connectorEntries.push({
                source: sourceKey,
                iconUrl: config.iconUrl ?? (0, $euapJ.getIconUrlForSource)(sourceKey),
                friendlyName: (0, $4D8Cc.coerceFriendlyName)(config.displayName, config.workspaceName, productKey),
                // `userNeedsOAuth === false` => user has authed; treat unknown as authed
                // to avoid hiding connectors that don't participate in OAuth.
                isUserOAuthed: config.userNeedsOAuth !== true,
                authResolutionMode: hasAdminImportedUserLink ? 'ADMIN_IMPORTED_USER_LINK' : undefined,
                outboundAuthUrl: config.outboundAuthUrl ?? '',
                connectorCreatedAt: config.connectorCreatedAt ?? null,
                connectedAt: config.connectedAt ?? null,
                resourceType: config.resourceType ?? null,
                providerId: config.providerId ?? null,
                datasourceId: config.datasourceId ?? null,
                connectorSyncType: config.connectorSyncType ?? null,
                connectorSources: config.connectorSources
            });
            // The 3P entry was written under the (possibly remapped) chat
            // `sourceKey`, but `accessibleProducts` references the raw product
            // key. Mark the raw product key's chat form as handled so the 1P
            // loop below does not synthesise a phantom authed 1P entry under
            // the original product key alongside the correctly-remapped 3P
            // entry (e.g. a remapped `drive` → `google_drive` would otherwise
            // also produce a stray `drive` 1P entry).
            skipped3pKeys.add((0, $6n4bK.toChatSourceKey)(productKey));
        }
        // 1P products — synthesised stub entries so the shape is complete.
        // `accessibleProducts` is the union of 1P + already-OAuthed 3P, so we
        // skip (a) any key already covered by `thirdPartyConfigs` above, and
        // (b) any key we *intentionally* skipped from `thirdPartyConfigs`
        // because its config was null — those are still 3P, just unconfigured.
        if (accessibleProducts) for (const productKey_0 of accessibleProducts){
            // `accessibleProducts` includes combined-only sub-product keys
            // (e.g. `jira-core`, `jira-software`) and accessible products
            // that are not chat connectors (e.g. `avp`, `devai`). The FG-off
            // knowledge endpoint never surfaced those as connectors, and they
            // have no friendly name or resolvable icon, so skip anything we do
            // not explicitly recognise. See {@link isRecognisedFirstPartyConnector}.
            if (!(0, $hleKH.isRecognisedFirstPartyConnector)(productKey_0)) continue;
            // 1P / noun products have no `resourceType`, so they are remapped
            // by product key. Done before the collision checks so a remapped
            // key (e.g. `jira-servicedesk` → `jsm`) is compared against the
            // same namespace used for the 3P entries and `skipped3pKeys`
            // above. See {@link toChatSourceKey}.
            const sourceKey_0 = (0, $6n4bK.toChatSourceKey)(productKey_0);
            if (seenKeys.has(sourceKey_0) || skipped3pKeys.has(sourceKey_0)) continue;
            seenKeys.add(sourceKey_0);
            connectorEntries.push({
                source: sourceKey_0,
                iconUrl: (0, $euapJ.getIconUrlForSource)(sourceKey_0),
                friendlyName: (0, $bli0p.coerceFirstPartyFriendlyName)(productKey_0),
                isUserOAuthed: true,
                // 1P is implicitly authed.
                outboundAuthUrl: '',
                connectorCreatedAt: null,
                connectedAt: null,
                resourceType: null,
                providerId: null,
                datasourceId: null,
                connectorSyncType: null
            });
        }
        // Always-present synthetic connector for the help/support docs
        // aggregator, added once config has loaded. It is authoritative for its
        // key: any real connector already produced with the same `source` is
        // replaced rather than duplicated.
        if (isConfigLoaded) {
            const helpAggregator = (0, $7DX5g.buildHelpAggregatorConnector)();
            if (seenKeys.has(helpAggregator.source)) {
                const existingIndex = connectorEntries.findIndex((entry)=>entry.source === helpAggregator.source);
                connectorEntries.splice(existingIndex, 1);
            }
            connectorEntries.push(helpAggregator);
        }
        return {
            connectors: (0, $esPYZ.sortConnectorsByFriendlyName)(connectorEntries),
            isFetching: !isConfigLoaded,
            error: null,
            lastFetchedAt: null,
            hasFetchAttempted: isConfigLoaded,
            markUserConnected: markUserConnected
        };
    }, [
        isIdle,
        accessibleProducts,
        thirdPartyConfigs,
        isConfigLoaded,
        markUserConnected
    ]);
};
module.exports["useRovoConfigStore"] = $9008ed4cacfbe41b$export$a031966c0660bfc9;

});

parcelRegister("7DX5g", function(module, exports) {

var $euapJ = parcelRequire("euapJ");

const $2f811c19de96991c$export$1edd7fd2422503b1 = 'help_aggregator';
const $2f811c19de96991c$export$dc7637393f87560d = 'Atlassian Support Docs';
const $2f811c19de96991c$export$967ac09376bd9e = ()=>({
        source: $2f811c19de96991c$export$1edd7fd2422503b1,
        iconUrl: (0, $euapJ.getIconUrlForSource)($2f811c19de96991c$export$1edd7fd2422503b1),
        friendlyName: $2f811c19de96991c$export$dc7637393f87560d,
        // The knowledge endpoint returns this connector as already user-OAuthed; it
        // is an always-present first-party source that does not require a connect
        // flow.
        isUserOAuthed: true,
        outboundAuthUrl: '',
        connectorCreatedAt: null,
        connectedAt: null,
        resourceType: null,
        providerId: null,
        datasourceId: null,
        connectorSyncType: null
    });
module.exports["buildHelpAggregatorConnector"] = $2f811c19de96991c$export$967ac09376bd9e;

});

parcelRegister("euapJ", function(module, exports) {
/**
 * Base path for the Rovo assist "resources" icon endpoint. The endpoint
 * resolves a connector `source` slug to a hosted icon image, e.g.
 * `/gateway/api/assist/rovo/v1/resources/icon/microsoft_onedrive`.
 */ const $c5b0757f6a449752$var$ASSIST_RESOURCES_ICON_BASE = '/gateway/api/assist/rovo/v1/resources/icon';
const $c5b0757f6a449752$export$70e383dd9d60be1d = (source)=>source ? `${$c5b0757f6a449752$var$ASSIST_RESOURCES_ICON_BASE}/${source}` : '';
module.exports["getIconUrlForSource"] = $c5b0757f6a449752$export$70e383dd9d60be1d;

});

parcelRegister("bli0p", function(module, exports) {

var $8ICvC = parcelRequire("8ICvC");

/**
 * @internal Only for use by `coerceFirstPartyFriendlyName`.
 *
 * Name-only fallbacks for first-party products that have **no** entry in
 * {@link FirstPartyConfigs} (which is keyed by {@link ProductKeys1P}).
 *
 * TODO RAOC23: Migrate these into FirstPartyConfigs
 * TODO RAOC23: improve downstream code sites so these can be i18n (goals, projects should be translated). conversation-assistant-store does not implement i18n today for these, so there is no new regression from this code
 */ const $e4cc11cbb0be5538$var$FIRST_PARTY_FRIENDLY_NAME_FALLBACKS = {
    loom: 'Loom',
    goal: 'Goals',
    project: 'Projects'
};
const $e4cc11cbb0be5538$export$5d806d5746dae5e5 = (productKey)=>{
    const config = (0, $8ICvC.FirstPartyConfigs)[productKey];
    if (config?.displayName) return config.displayName;
    return $e4cc11cbb0be5538$var$FIRST_PARTY_FRIENDLY_NAME_FALLBACKS[productKey] ?? '';
};
module.exports["coerceFirstPartyFriendlyName"] = $e4cc11cbb0be5538$export$5d806d5746dae5e5;

});

parcelRegister("8ICvC", function(module, exports) {

var $6vPLm = parcelRequire("6vPLm");

var $fxqZn = parcelRequire("fxqZn");

var $hZx6a = parcelRequire("hZx6a");

var $5lkNm = parcelRequire("5lkNm");

var $ffVxZ = parcelRequire("ffVxZ");

var $dL3KD = parcelRequire("dL3KD");

var $ldJ1U = parcelRequire("ldJ1U");

var $33FWk = parcelRequire("33FWk");

var $1SyEw = parcelRequire("1SyEw");

var $hupj2 = parcelRequire("hupj2");

var $8JGXU = parcelRequire("8JGXU");


var $NlHoa = parcelRequire("NlHoa");


var $aqAfG = parcelRequire("aqAfG");


var $eFOGZ = parcelRequire("eFOGZ");


var $allOa = parcelRequire("allOa");


var $a286M = parcelRequire("a286M");


var $29ZRN = parcelRequire("29ZRN");


var $fSxZ1 = parcelRequire("fSxZ1");


var $hZyh4 = parcelRequire("hZyh4");


var $jnxSu = parcelRequire("jnxSu");


var $b3k9s = parcelRequire("b3k9s");


var $6MWD7 = parcelRequire("6MWD7");


var $i52Hf = parcelRequire("i52Hf");


var $g0yva = parcelRequire("g0yva");


var $3h5an = parcelRequire("3h5an");


var $aIhxJ = parcelRequire("aIhxJ");

const $8ce35fa7bd4698cd$export$3e4929b42b34f3a8 = {
    [(0, $aqAfG.ProductKeys1P).Confluence]: {
        displayName: 'Confluence',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $5lkNm.ConfluenceIcon), 'Confluence'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.ConfluenceSearchResultIcon), 'Confluence', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Atlas]: {
        displayName: 'Home',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $NlHoa.AtlassianIcon), 'Home'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.AtlasSearchResultIcon), 'Home', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Jira]: {
        displayName: 'Jira',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $ldJ1U.JiraIcon), 'Jira'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $3h5an.JiraSearchResultIcon), 'Jira', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $33FWk.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.JiraProductDiscoverySearchResultIcon), 'Jira Product Discovery', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $1SyEw.JiraServiceManagementIcon), 'Jira Service Management'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $aIhxJ.JiraServiceManagementSearchResultIcon), 'Jira Service Management', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).CustomerServiceManagement]: {
        displayName: 'Customer Service Management',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $ffVxZ.CustomerServiceManagementIcon), 'Customer Service Management'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $ffVxZ.CustomerServiceManagementIcon), 'Customer Service Management')
    },
    [(0, $aqAfG.ProductKeys1P).Bitbucket]: {
        displayName: 'Bitbucket',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $fxqZn.BitbucketIcon), 'Bitbucket'),
        // Bitbucket uses the same icon for search results
        searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $fxqZn.BitbucketIcon), 'Bitbucket')
    },
    [(0, $aqAfG.ProductKeys1P).Trello]: {
        displayName: 'Trello',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $8JGXU.TrelloIcon), 'Trello'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.TrelloSearchResultIcon), 'Trello', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Compass]: {
        displayName: 'Compass',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $hZx6a.CompassIcon), 'Compass'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.CompassSearchResultIcon), 'Compass', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Focus]: {
        displayName: 'Focus',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $dL3KD.FocusIcon), 'Focus'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.FocusSearchResultIcon), 'Focus', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Assets]: {
        displayName: 'Assets',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $6vPLm.AssetsIcon), 'Assets'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.AssetsSearchResultIcon), 'Assets', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Talent]: {
        displayName: 'Talent',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $hupj2.TalentIcon), 'Talent'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.TalentSearchResultIcon), 'Talent', 'large')
    }
};
const $8ce35fa7bd4698cd$export$88aff1c9a685343e = [
    (0, $aqAfG.ProductKeys1P).Confluence,
    (0, $aqAfG.ProductKeys1P).Jira,
    (0, $aqAfG.ProductKeys1P).JiraProductDiscovery,
    (0, $aqAfG.ProductKeys1P).JiraServiceManagement,
    (0, $aqAfG.ProductKeys1P).CustomerServiceManagement,
    (0, $aqAfG.ProductKeys1P).Atlas,
    (0, $aqAfG.ProductKeys1P).Trello,
    (0, $aqAfG.ProductKeys1P).Bitbucket,
    (0, $aqAfG.ProductKeys1P).Compass,
    (0, $aqAfG.ProductKeys1P).Focus,
    (0, $aqAfG.ProductKeys1P).Assets,
    (0, $aqAfG.ProductKeys1P).Talent
];
const $8ce35fa7bd4698cd$export$633a31c0b66df80f = (productKey)=>{
    return $8ce35fa7bd4698cd$export$3e4929b42b34f3a8[productKey];
};
const $8ce35fa7bd4698cd$export$6351cb1baf5bc02f = new Map([
    [
        (0, $aqAfG.ProductKeys1P).Confluence,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Confluence],
            entities: (0, $fSxZ1.DEFAULT_CONFLUENCE_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Jira,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Jira],
            entities: (0, $jnxSu.DEFAULT_JIRA_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Atlas,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Atlas],
            entities: (0, $allOa.DEFAULT_ATLAS_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Compass,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Compass],
            entities: (0, $29ZRN.DEFAULT_COMPASS_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Trello,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Trello],
            entities: (0, $6MWD7.DEFAULT_TRELLO_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Bitbucket,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Bitbucket],
            entities: (0, $a286M.DEFAULT_BITBUCKET_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Assets,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Assets],
            entities: (0, $eFOGZ.DEFAULT_ASSETS_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Talent,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Talent],
            entities: (0, $b3k9s.DEFAULT_TALENT_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Focus,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Focus],
            entities: (0, $hZyh4.DEFAULT_FOCUS_ENTITY_ATI)
        }
    ]
]);
module.exports["FirstPartyConfigs"] = $8ce35fa7bd4698cd$export$3e4929b42b34f3a8;
module.exports["ProductsOrder1P"] = $8ce35fa7bd4698cd$export$88aff1c9a685343e;

});

parcelRegister("eFOGZ", function(module, exports) {
/**
 * Default entity ATIs for Assets/CMDB (1P).
 */ const $5a926523d3fc04b7$export$9303a82ed1def835 = [
    'ati:cloud:cmdb:object',
    'ati:cloud:cmdb:schema',
    'ati:cloud:cmdb:type'
];
module.exports["DEFAULT_ASSETS_ENTITY_ATI"] = $5a926523d3fc04b7$export$9303a82ed1def835;

});

parcelRegister("allOa", function(module, exports) {
/**
 * Default entity ATIs for Atlas/Townsquare (1P).
 */ const $fe65860a61b90dcd$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag',
    'ati:cloud:townsquare:question',
    'ati:cloud:townsquare:learning'
];
module.exports["DEFAULT_ATLAS_ENTITY_ATI"] = $fe65860a61b90dcd$export$c87d62ed9387fa60;

});

parcelRegister("a286M", function(module, exports) {
/**
 * Default entity ATIs for Bitbucket (1P).
 * Combines devinfo pull request and repository ATIs.
 */ 
var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");

const $75d61be85073872e$export$bbc68bbdfb2251e1 = [
    ...(0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI)
];
module.exports["DEFAULT_BITBUCKET_ENTITY_ATI"] = $75d61be85073872e$export$bbc68bbdfb2251e1;

});

parcelRegister("29ZRN", function(module, exports) {
/**
 * Default entity ATIs for Compass (1P).
 */ const $ebead1a1e45f84e3$export$7e1741905a27fa1c = [
    'ati:cloud:compass:component'
];
module.exports["DEFAULT_COMPASS_ENTITY_ATI"] = $ebead1a1e45f84e3$export$7e1741905a27fa1c;

});

parcelRegister("fSxZ1", function(module, exports) {
/**
 * Default entity ATIs for Confluence (1P).
 *
 * Intentionally excludes:
 * - `calendar` / `space-calendar` — handled via team-calendars plugin ATIs separately
 * - Legacy plugin ATIs (confluence.com.atlassian.confluence.extra.team-calendars:*, confluence.ac:*) — handled separately
 */ const $c28750505456c170$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder',
    'ati:cloud:confluence:slide',
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:answer',
    'ati:cloud:confluence:question'
];
module.exports["DEFAULT_CONFLUENCE_ENTITY_ATI"] = $c28750505456c170$export$c07a1c127052b557;

});

parcelRegister("hZyh4", function(module, exports) {
/**
 * Default entity ATIs for Focus/Mercury (1P).
 */ const $1aa4ef4643cfac70$export$e45b6700dc30d17 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
module.exports["DEFAULT_FOCUS_ENTITY_ATI"] = $1aa4ef4643cfac70$export$e45b6700dc30d17;

});

parcelRegister("jnxSu", function(module, exports) {
/**
 * Default entity ATIs for Jira (1P).
 */ const $20f7d1cf01c86447$export$b4a7e1c18385196d = [
    'ati:cloud:jira:project',
    'ati:cloud:jira:issue',
    'ati:cloud:jira:filter',
    'ati:cloud:jira:dashboard',
    'ati:cloud:jira:board',
    'ati:cloud:jira:plan'
];
module.exports["DEFAULT_JIRA_ENTITY_ATI"] = $20f7d1cf01c86447$export$b4a7e1c18385196d;

});

parcelRegister("b3k9s", function(module, exports) {
/**
 * Default entity ATIs for Talent/Radar (1P).
 */ const $00dded7f28999ba2$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];
module.exports["DEFAULT_TALENT_ENTITY_ATI"] = $00dded7f28999ba2$export$368c06447ee18b39;

});

parcelRegister("6MWD7", function(module, exports) {
/**
 * Default entity ATIs for Trello (1P).
 */ const $ecce451ed89c40dc$export$9f88fe41a620c75d = [
    'ati:cloud:trello:board',
    'ati:cloud:trello:card'
];
module.exports["DEFAULT_TRELLO_ENTITY_ATI"] = $ecce451ed89c40dc$export$9f88fe41a620c75d;

});

parcelRegister("g0yva", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0ab7327346d1509d$export$93ca83db1787dea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "27.5092",
            height: "26.3",
            fill: "white",
            transform: "translate(6.45831 6.875)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));
const $0ab7327346d1509d$export$b0a52366c3fb9b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "28.9104",
            height: "28.8583",
            fill: "white",
            transform: "translate(5.83331 3.33337)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));
const $0ab7327346d1509d$export$1afe31d4b2891d7a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "27.2333",
            height: "27.2333",
            fill: "white",
            transform: "translate(6.25 7.08334)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));
const $0ab7327346d1509d$export$7221b4e3b691d1b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$4b1b9db11d699ccb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$4d0238652f4b6bc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$24d355ce80de5803 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            height: "100%",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--tile-color,#ffc716)",
            d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            fillRule: "evenodd",
            d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
            clipRule: "evenodd"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));
const $0ab7327346d1509d$export$5427c633f31d110f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "#FB9700"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
            fill: "#101214"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "33",
            viewBox: "0 0 32 33",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "white"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));
module.exports["ConfluenceSearchResultIcon"] = $0ab7327346d1509d$export$93ca83db1787dea;
module.exports["AtlasSearchResultIcon"] = $0ab7327346d1509d$export$b0a52366c3fb9b;
module.exports["JiraProductDiscoverySearchResultIcon"] = $0ab7327346d1509d$export$1afe31d4b2891d7a;
module.exports["TrelloSearchResultIcon"] = $0ab7327346d1509d$export$7221b4e3b691d1b3;
module.exports["CompassSearchResultIcon"] = $0ab7327346d1509d$export$4b1b9db11d699ccb;
module.exports["FocusSearchResultIcon"] = $0ab7327346d1509d$export$4d0238652f4b6bc4;
module.exports["AssetsSearchResultIcon"] = $0ab7327346d1509d$export$24d355ce80de5803;
module.exports["TalentSearchResultIcon"] = $0ab7327346d1509d$export$5427c633f31d110f;

});

parcelRegister("4D8Cc", function(module, exports) {

var $fd0l2 = parcelRequire("fd0l2");


var $fR63l = parcelRequire("fR63l");

/**
 * @internal Only for use by `coerceFriendlyName`.
 *
 * Hard-coded English fallbacks for connectors whose static
 * {@link ThirdPartyConfigsSync} `displayName` is a non-string `React.ReactNode`
 * (e.g. a `<FormattedMessage />`), which we cannot resolve to a string
 * synchronously here.
 *
 * KNOWN EDGE CASE (RAOC-23 — to review): `atlassian-web-crawler` declares its
 * display name as a translatable `<FormattedMessage />`, so it cannot be
 * resolved to a string synchronously and falls back to this fixed English
 * string ("Web Pages"). This is the connector's canonical chat-side label: it
 * is intentionally NOT given `workspaceName` precedence (unlike the DC
 * connectors) because the chat path collapses all crawler instances into one
 * connector. We deliberately do NOT solve full i18n here — that is a larger
 * piece of the iterative migration.
 *
 * Downstreams of conversation-assistant-store do not implement i18n today, so there is no new regression from this code
 *
 * TODO RAOC-23: Improve downstream code sites to accept `string | React.ReactNode` for display names, allowing i18n names, and removing this fallback
 */ const $cb5204a5ed3b0894$var$REACT_NODE_DISPLAY_NAME_FALLBACKS = {
    [(0, $fR63l.ProductKeys3P).AtlassianWebCrawler]: 'Web Pages'
};
/**
 * @internal Only for use by `coerceFriendlyName`.
 *
 * Connectors for which the per-instance `workspaceName` from the combined-config
 * response should take precedence over the generic static catalogue name.
 *
 * `workspaceName` is opt-in (rather than applied to every connector) because its
 * meaning varies by connector type:
 *
 * TODO RAOC-23: Move this to be a variable in the config objects, and also support this in search downstream, which has its own specical logic handling this.
 */ const $cb5204a5ed3b0894$var$WORKSPACE_NAME_PRECEDENCE_KEYS = new Set([
    // NOTE: `atlassian-web-crawler` is deliberately NOT in this allowlist.
    // In Search the crawler is fanned out into one row per indexed site, each
    // labelled with its `workspaceName` (see `displayWorkspaceNameAsProductName`
    // / `fanOutConnectorSources` on the web-crawler config). On the chat path,
    // however, every crawler instance collapses into a single
    // `atlassian-web-crawler` connector, so taking one instance's
    // `workspaceName` would surface an arbitrary site name (e.g. "Atlassian
    // Community") and sort it under that name rather than the connector's own
    // identity. The crawler must instead resolve to its catalogue/fallback name
    // "Web Pages" (see `REACT_NODE_DISPLAY_NAME_FALLBACKS` below) so it sorts and
    // displays consistently. See RAOC-23.
    //
    // FC Connectors: used to distinguish from cloud products (Cloud: Confluence, DC: Bullhorn, etc.)
    (0, $fR63l.ProductKeys3P).JiraDC,
    (0, $fR63l.ProductKeys3P).JsmDC,
    (0, $fR63l.ProductKeys3P).ConfluenceDC
]);
const $cb5204a5ed3b0894$export$3ed827f54fd11033 = (displayName, workspaceName, productKey)=>{
    if (productKey !== undefined && $cb5204a5ed3b0894$var$WORKSPACE_NAME_PRECEDENCE_KEYS.has(productKey) && typeof workspaceName === 'string' && workspaceName !== '') return workspaceName;
    if (typeof displayName === 'string' && displayName !== '') return displayName;
    if (productKey) {
        const staticDisplayName = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey)?.displayName;
        if (typeof staticDisplayName === 'string' && staticDisplayName !== '') return staticDisplayName;
        const fallback = $cb5204a5ed3b0894$var$REACT_NODE_DISPLAY_NAME_FALLBACKS[productKey];
        if (fallback) return fallback;
    }
    return '';
};
module.exports["coerceFriendlyName"] = $cb5204a5ed3b0894$export$3ed827f54fd11033;

});

parcelRegister("fd0l2", function(module, exports) {

var $au9jr = parcelRequire("au9jr");


var $hIDj1 = parcelRequire("hIDj1");


var $7WW80 = parcelRequire("7WW80");


var $52Drw = parcelRequire("52Drw");


var $juuLe = parcelRequire("juuLe");


var $4Be7r = parcelRequire("4Be7r");


var $jAKKt = parcelRequire("jAKKt");


var $9Om9G = parcelRequire("9Om9G");


var $4x6XK = parcelRequire("4x6XK");


var $fauGM = parcelRequire("fauGM");


var $fg2gb = parcelRequire("fg2gb");


var $5pWqV = parcelRequire("5pWqV");


var $8oQ7k = parcelRequire("8oQ7k");


var $kiNtZ = parcelRequire("kiNtZ");


var $k521G = parcelRequire("k521G");


var $8djpu = parcelRequire("8djpu");


var $2qza4 = parcelRequire("2qza4");


var $7dzhu = parcelRequire("7dzhu");


var $1RpaO = parcelRequire("1RpaO");


var $jENKA = parcelRequire("jENKA");


var $9JBuG = parcelRequire("9JBuG");


var $aHqTQ = parcelRequire("aHqTQ");


var $j34lg = parcelRequire("j34lg");


var $in2Pi = parcelRequire("in2Pi");


var $7vbr8 = parcelRequire("7vbr8");


var $k6vRK = parcelRequire("k6vRK");


var $aiL8h = parcelRequire("aiL8h");


var $cY0ZT = parcelRequire("cY0ZT");


var $9SYma = parcelRequire("9SYma");


var $ie06K = parcelRequire("ie06K");


var $h5NUz = parcelRequire("h5NUz");


var $9Y160 = parcelRequire("9Y160");


var $hdy05 = parcelRequire("hdy05");


var $djF8v = parcelRequire("djF8v");


var $dChew = parcelRequire("dChew");


var $TCovD = parcelRequire("TCovD");


var $feDPe = parcelRequire("feDPe");


var $klS4t = parcelRequire("klS4t");


var $hFdyH = parcelRequire("hFdyH");


var $e6TPF = parcelRequire("e6TPF");


var $7piBv = parcelRequire("7piBv");


var $3yXQ1 = parcelRequire("3yXQ1");


var $cmwLF = parcelRequire("cmwLF");


var $brRUk = parcelRequire("brRUk");


var $dwyZc = parcelRequire("dwyZc");


var $9sIt4 = parcelRequire("9sIt4");


var $7UyZr = parcelRequire("7UyZr");


var $2KPYZ = parcelRequire("2KPYZ");


var $3LgSg = parcelRequire("3LgSg");


var $bRkOn = parcelRequire("bRkOn");


var $eoGOF = parcelRequire("eoGOF");


var $jWqmd = parcelRequire("jWqmd");


var $34wuK = parcelRequire("34wuK");


var $g36Mb = parcelRequire("g36Mb");


var $eODbN = parcelRequire("eODbN");


var $2k3z5 = parcelRequire("2k3z5");


var $lHAGV = parcelRequire("lHAGV");


var $iPw5B = parcelRequire("iPw5B");


var $9lVxQ = parcelRequire("9lVxQ");


var $1HfnT = parcelRequire("1HfnT");


var $fA9zj = parcelRequire("fA9zj");


var $h8Js2 = parcelRequire("h8Js2");


var $aZX0c = parcelRequire("aZX0c");


var $382mb = parcelRequire("382mb");


var $52jas = parcelRequire("52jas");


var $bzVC8 = parcelRequire("bzVC8");


var $kFYBW = parcelRequire("kFYBW");


var $6eg6r = parcelRequire("6eg6r");


var $cdiu6 = parcelRequire("cdiu6");


var $79ijY = parcelRequire("79ijY");


var $e7BOf = parcelRequire("e7BOf");


var $3P9fk = parcelRequire("3P9fk");


var $lSeWC = parcelRequire("lSeWC");


var $43W2t = parcelRequire("43W2t");


var $6lsSn = parcelRequire("6lsSn");


var $6ThsT = parcelRequire("6ThsT");


var $diJOH = parcelRequire("diJOH");


var $kcCFv = parcelRequire("kcCFv");


var $4TRyZ = parcelRequire("4TRyZ");


var $ijAga = parcelRequire("ijAga");


var $dPp45 = parcelRequire("dPp45");


var $emznk = parcelRequire("emznk");


var $fMCQp = parcelRequire("fMCQp");


var $iTxTm = parcelRequire("iTxTm");


var $lPRuX = parcelRequire("lPRuX");


var $2zNcl = parcelRequire("2zNcl");


var $iN1Vs = parcelRequire("iN1Vs");


var $gOrBS = parcelRequire("gOrBS");


var $kDG5l = parcelRequire("kDG5l");


var $aaz0Y = parcelRequire("aaz0Y");


var $3juV6 = parcelRequire("3juV6");


var $6sCQO = parcelRequire("6sCQO");


var $dVIA3 = parcelRequire("dVIA3");


var $fR63l = parcelRequire("fR63l");


var $5bQLl = parcelRequire("5bQLl");


var $kmEEk = parcelRequire("kmEEk");


var $3VdqU = parcelRequire("3VdqU");


var $bj13p = parcelRequire("bj13p");

const $0b44d50a3ced5459$export$f26e5f55e570679c = new Map([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        (0, $jAKKt.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $7dzhu.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        (0, $aZX0c.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $kFYBW.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        (0, $gOrBS.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        (0, $lSeWC.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $4TRyZ.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        (0, $2qza4.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $kDG5l.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $6sCQO.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        (0, $6eg6r.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        (0, $52jas.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        (0, $ijAga.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        (0, $dPp45.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        (0, $4Be7r.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        (0, $kmEEk.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        (0, $52Drw.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        (0, $aaz0Y.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        (0, $kcCFv.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        (0, $6lsSn.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        (0, $k521G.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        (0, $43W2t.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        (0, $6ThsT.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        (0, $4x6XK.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        (0, $382mb.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $8oQ7k.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        (0, $79ijY.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        (0, $e7BOf.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        (0, $fg2gb.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        (0, $fauGM.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gong,
        (0, $bzVC8.gongConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        (0, $bj13p.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        (0, $3VdqU.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        (0, $iN1Vs.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        (0, $fA9zj.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        (0, $iTxTm.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        (0, $5pWqV.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        (0, $juuLe.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        (0, $3juV6.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        (0, $hIDj1.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        (0, $7WW80.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        (0, $au9jr.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        (0, $diJOH.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        (0, $5bQLl.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        (0, $dVIA3.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        (0, $emznk.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        (0, $fMCQp.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $cdiu6.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        (0, $8djpu.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        (0, $3P9fk.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        (0, $lPRuX.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        (0, $2zNcl.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        (0, $h8Js2.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        (0, $9Om9G.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        (0, $kiNtZ.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $1RpaO.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $jENKA.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $j34lg.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $in2Pi.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        (0, $7vbr8.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        (0, $k6vRK.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        (0, $aiL8h.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        (0, $cY0ZT.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        (0, $9SYma.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        (0, $ie06K.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $h5NUz.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $9Y160.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        (0, $hdy05.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        (0, $djF8v.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $dChew.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $TCovD.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        (0, $feDPe.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        (0, $klS4t.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $hFdyH.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $e6TPF.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        (0, $7piBv.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        (0, $3yXQ1.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        (0, $cmwLF.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        (0, $brRUk.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        (0, $dwyZc.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        (0, $9sIt4.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $7UyZr.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $2KPYZ.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $9lVxQ.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $1HfnT.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $9JBuG.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $aHqTQ.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $34wuK.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $g36Mb.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $eODbN.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $2k3z5.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $lHAGV.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $iPw5B.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $3LgSg.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $bRkOn.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $eoGOF.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $jWqmd.forgeUnitoBasecampConfig)
    ]
]);
module.exports["ThirdPartyConfigsSync"] = $0b44d50a3ced5459$export$f26e5f55e570679c;

});

parcelRegister("hleKH", function(module, exports) {

var $aqAfG = parcelRequire("aqAfG");

/**
 * @internal Implementation detail of `useRovoConfigStore`. Do **not** import
 * this from anywhere other than `src/services/hooks/useRovoConfigStore.tsx` —
 * it is intentionally not part of the package's public API.
 *
 * The set of first-party / noun product keys that are genuine chat connectors
 * and should be synthesised into the store as 1P entries.
 *
 * `accessibleProducts` (from combined-config) is broader than this: it also
 * includes combined-only **sub-product** keys (e.g. `jira-core`,
 * `jira-software`) and other accessible products that are not chat connectors
 * (e.g. `avp`, `devai`). The FG-off knowledge endpoint never surfaced those as
 * connectors, so emitting them here produces phantom rows with no friendly
 * name and an icon URL that does not resolve. We therefore only synthesise 1P
 * entries for keys we explicitly recognise.
 *
 * Derived from the package's canonical constants so it stays in sync as new
 * first-party products / nouns are added:
 * - every {@link ProductKeys1P} value (except the exclusions below), plus
 * - the {@link NounKeys} that chat surfaces (`goal`, `project`), plus
 * - `loom` (a first-party connector handled via the friendly-name fallback).
 *
 * TODO RAOC-23: these are genuine first-party products but the chat knowledge
 * backend has no corresponding `KnowledgeSourceType` for them yet, so they have
 * no chat `source` and their icon endpoint URLs do not resolve. They are
 * excluded here until the static-config icon lookup lands (see the icon TODO in
 * `getIconUrlForSource`). Re-include each one once it can render a resolvable
 * icon:
 * - `jira-product-discovery` (Jira Product Discovery)
 * - `cmdb` (Assets)
 * - `mercury` (Focus)
 * - `radar` (Talent)
 */ const $e919183eac44ae76$var$FIRST_PARTY_KEYS_PENDING_CHAT_SOURCE = new Set([
    (0, $aqAfG.ProductKeys1P).JiraProductDiscovery,
    (0, $aqAfG.ProductKeys1P).CustomerServiceManagement,
    (0, $aqAfG.ProductKeys1P).Assets,
    (0, $aqAfG.ProductKeys1P).Focus,
    (0, $aqAfG.ProductKeys1P).Talent
]);
/**
 * First-party product keys that are **permanently** excluded from the store —
 * they are not chat connectors and should never be synthesised, regardless of
 * any future chat-source / icon work.
 *
 * - `townsquare` (Atlas / Home) — Home is not a knowledge connector.
 */ const $e919183eac44ae76$var$FIRST_PARTY_KEYS_EXCLUDED = new Set([
    (0, $aqAfG.ProductKeys1P).Atlas
]);
const $e919183eac44ae76$var$RECOGNISED_FIRST_PARTY_KEYS = new Set([
    ...Object.values((0, $aqAfG.ProductKeys1P)),
    (0, $aqAfG.NounKeys).goal,
    (0, $aqAfG.NounKeys).project,
    'loom'
].filter((key)=>!$e919183eac44ae76$var$FIRST_PARTY_KEYS_PENDING_CHAT_SOURCE.has(key) && !$e919183eac44ae76$var$FIRST_PARTY_KEYS_EXCLUDED.has(key)));
const $e919183eac44ae76$export$e645f9e57bf8f7fc = (productKey)=>$e919183eac44ae76$var$RECOGNISED_FIRST_PARTY_KEYS.has(productKey);
module.exports["isRecognisedFirstPartyConnector"] = $e919183eac44ae76$export$e645f9e57bf8f7fc;

});

parcelRegister("eIiZ2", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

/**
 * @internal Implementation detail of `useRovoConfigStore`. Do **not** import
 * this from anywhere other than `src/services/hooks/useRovoConfigStore.tsx` —
 * it is intentionally not part of the package's public API.
 *
 * The set of third-party connector keys that the chat config endpoint can
 * surface in `thirdPartyConfigs` but which the chat surface does **not** yet
 * support, so they must not be projected into the store.
 *
 * This is the 3P counterpart to the 1P exclusion in
 * {@link isRecognisedFirstPartyConnector}: rather than allow-listing the keys
 * we recognise (as the 1P loop does, because `accessibleProducts` is broad and
 * noisy), the 3P config endpoint only ever returns genuine 3P connectors, so
 * we instead deny-list the specific keys that are not ready. Everything else
 * is supported by default — mirroring how `isRecognisedFirstPartyConnector`
 * stays in sync with new products via the canonical constants.
 *
 * TODO RAOC-23: `jsm-dc` (Jira Service Management Data Center) is a genuine 3P
 * connector but is not yet supported on the chat surface. Remove it from this
 * set once chat support lands.
 */ const $9c58d158feb51826$var$THIRD_PARTY_KEYS_PENDING_SUPPORT = new Set([
    (0, $fR63l.ProductKeys3P).JsmDC
]);
const $9c58d158feb51826$export$375228c3207db2cf = (productKey)=>!$9c58d158feb51826$var$THIRD_PARTY_KEYS_PENDING_SUPPORT.has(productKey);
module.exports["isSupportedThirdPartyConnector"] = $9c58d158feb51826$export$375228c3207db2cf;

});

parcelRegister("3S9ut", function(module, exports) {
/**
 * @file
 * RAOC-23: pure translation logic backing the `markUserConnected(source)` API
 * exposed by {@link useRovoConfigStore}.
 *
 * The chat connectors-store action `markUserConnected` is invoked with a
 * connector's chat-namespace `source` key (e.g. `'slack'`, `'google_drive'`).
 * `useRovoConfig`'s `onOAuthSuccess`, however, is keyed on the config-namespace
 * 3P **product key** (the `thirdPartyConfigs` key, e.g. `'slack'`,
 * `'google-drive'`) plus an optional `datasourceId`. This module owns the
 * translation so the hook can stay a thin wiring layer.
 *
 * Kept as a standalone pure function (rather than inline in the hook) so the
 * mapping can be unit-tested in isolation and so the hook body stays sane.
 */ 
var $6n4bK = parcelRequire("6n4bK");

const $6e29e52126d9ff5c$export$aa9890ea4e085182 = (thirdPartyConfigs, source)=>{
    if (!thirdPartyConfigs) return undefined;
    // TODO RAOC-23 add coverage for bidirectional mapping here (so that
    // smartlinks vs full connectors resolve correctly) (pending branch
    // rwasher/RAOC-23-drive-connector-collapse-fix merging will require a rebase)
    for (const [productKey, config] of Object.entries(thirdPartyConfigs)){
        if (!config) continue;
        if ((0, $6n4bK.resolveChatSource)(productKey, config.resourceType) !== source) continue;
        return {
            product: productKey
        };
    }
    return undefined;
};
module.exports["resolveOAuthTargetForSource"] = $6e29e52126d9ff5c$export$aa9890ea4e085182;

});

parcelRegister("6n4bK", function(module, exports) {
/**
 * @file Connector-identifier remapping for {@link useRovoConfigStore} and other
 * consumers that need to join config-namespace keys onto chat-namespace ones.
 *
 * Map a connector identifier from the **config namespace** (what `useRovoConfig`
 * emits — `ProductResourceTypes3P` connector keys for 3P connectors, and 1P
 * product / noun keys for first-party products) to the **chat / knowledge
 * namespace** that downstream `@atlassian/conversation-assistant-store`
 * selectors key off (the `source` field returned by the knowledge endpoint).
 *
 * Exposed as the `./chat-source-keys` subpath. Besides the store, it is consumed
 * by `@atlassian/rovo-settings-modal` to join Enterprise Gatekeeper connector
 * types (same strings as `ProductResourceTypes3P`) onto knowledge `source`
 * values, so the RAOC-23 cleanup below cannot simply delete these maps — the
 * external consumer has to be migrated with it.
 *
 * ---------------------------------------------------------------------------
 * RAOC-23 — Why this exists
 * ---------------------------------------------------------------------------
 * On each side of the `rovo_cas_use_rovo_config` feature gate the connector
 * lists come from a different backend, and those backends return **different
 * key strings for the same connector**:
 *   - FG off → the legacy knowledge endpoint (conversational-ai-platform),
 *     which returns chat-namespace `source` strings such as `google_drive`,
 *     `microsoft_sharepoint`, `jsm`, `google_drive_sl`.
 *   - FG on  → the combined-config endpoint (via `useRovoConfig`), which
 *     returns config-namespace keys: a kebab-case product key (`drive`) plus a
 *     connector `resourceType` (`google-drive-connector`).
 * We treat the FG-on (combined-config) backend as the source of truth and
 * remap its identifiers here so that consumers of `useRovoConfigStore` always
 * see the chat-namespace `source` they were built against, regardless of the
 * gate.
 *
 * ---------------------------------------------------------------------------
 * Why keying on `resourceType` (not the product key) for 3P
 * ---------------------------------------------------------------------------
 * The kebab product key alone is **ambiguous**: a single product (e.g. config
 * `drive`) can correspond to two different knowledge `source` values depending
 * on whether the connected datasource is the full connector (`google_drive`)
 * or the SmartLinks connector (`google_drive_sl`). The only field that
 * disambiguates is the connector key — which the config response carries as
 * `resourceType` (e.g. `google-drive-connector` vs `smartlinks-connector-gdrive`),
 * matching the BE `KnowledgeSourceType.thirdPartyConnectorKey` 1:1. So 3P
 * remapping is keyed on `resourceType`; only the 1P / noun entries (which have
 * no `resourceType`) are remapped by product key.
 *
 * ---------------------------------------------------------------------------
 * Provenance
 * ---------------------------------------------------------------------------
 * Both maps below are generated from the authoritative
 * `KnowledgeSourceType` enum in conversational-ai-platform
 * (`.../platform/base/knowledge/KnowledgeSourceType.kt`): the RHS is the enum
 * `value` (`@JsonValue` = the `source` the knowledge endpoint emits) and the
 * LHS is the enum `thirdPartyConnectorKey` (3P) / config `product` (1P/noun).
 * The FG-off store keys connectors verbatim by this `source`
 * (`connectors[source.source] = ...` in
 * `conversation-assistant-store/.../connectors-store`), so it is the only
 * source of truth for the key strings.
 *
 * TODO RAOC-23: once the chat selector hooks are fully migrated and the chat
 * backend converges on the config-namespace keys, these remaps can be deleted.
 * Alternatively: converge to this version for search as well.
 */ /**
 * Maps a connector `resourceType` (config-namespace connector key, equal to
 * `ProductResourceTypes3P` values and the BE `thirdPartyConnectorKey`) to the
 * chat-namespace `source` value.
 *
 * Generated from `KnowledgeSourceType` (conversational-ai-platform). Covers
 * every 3P knowledge source, including the SmartLinks (`*_sl`) variants which
 * share a product key with their full-connector sibling but have a distinct
 * `resourceType` and a distinct `source`.
 *
 * NOTE: `forge-connector` intentionally omitted. The backend reuses the
 * generic `forge-connector` key for multiple Forge-hosted integrations, so
 * it cannot be mapped to a single `source` unambiguously. Until the backend
 * disambiguates it, Forge connectors fall through to the product-key remap
 * (and otherwise pass through unchanged) rather than silently resolving to
 * the wrong source.
 *
 * TODO RAOC-23: Move this constant into the 3P static configs per connector
 */ const $985791042dd30882$export$f3ac85cf46d74e63 = {
    'adobe-sign-connector': 'adobe_sign',
    'adobexd-connector': 'adobe_xd',
    'aha-connector': 'aha',
    'airtable-connector': 'airtable',
    'asana-connector': 'asana',
    'aws-connector': 'aws',
    'azure-connector': 'azure',
    'azure-devops-connector': 'azure_devops',
    'bitbucket-connector': 'bitbucket',
    'box-connector': 'box',
    'canva-connector': 'canva',
    'clickup-connector': 'clickup',
    'confluence-dc-connector': 'confluence-dc',
    'confluent-connector': 'confluent',
    'databricks-connector': 'databricks',
    'datadog-connector': 'datadog',
    'docker-connector': 'docker',
    'docusign-connector': 'docusign',
    'dovetail-connector': 'dovetail',
    'dropbox-connector': 'dropbox',
    'entra-id-connector': 'entra',
    'figma-connector': 'figma',
    'freshservice-connector': 'freshservice',
    'github-connector': 'github',
    'gitlab-connector': 'gitlab',
    'gmail-connector': 'gmail',
    'google-calendar-connector': 'google_calendar',
    'google-cloud-platform-connector': 'gcp',
    'google-drive-connector': 'google_drive',
    'hubspot-connector': 'hubspot',
    'jenkins-connector': 'jenkins',
    'jira-dc-connector': 'jira_dc',
    'launchdarkly-connector': 'launchdarkly',
    'loom-connector': 'loom',
    'lucid-connector': 'lucid',
    'microsoft-connector': 'microsoft',
    'microsoft-teams-connector': 'teams',
    'miro-connector': 'miro',
    'monday-connector': 'monday',
    'mural-connector': 'mural',
    'notion-connector': 'notion',
    'onedrive-connector': 'microsoft_onedrive',
    'outlook-calendar-connector': 'microsoft_outlook_calendar',
    'outlook-mail-connector': 'microsoft_outlook_mail',
    'pagerduty-connector': 'pagerduty',
    'pipedrive-connector': 'pipedrive',
    'salesforce-connector': 'salesforce',
    'sentry-connector': 'sentry',
    'servicenow-connector': 'servicenow',
    'sharepoint-connector': 'microsoft_sharepoint',
    'slack-connector': 'slack',
    'smartlinks-connector-adobexd': 'adobe_xd_sl',
    'smartlinks-connector-airtable': 'airtable_sl',
    'smartlinks-connector-amplitude': 'amplitude',
    'smartlinks-connector-asana': 'asana_sl',
    'smartlinks-connector-box': 'box_sl',
    'smartlinks-connector-clickup': 'clickup_sl',
    'smartlinks-connector-docusign': 'docusign_sl',
    'smartlinks-connector-dovetail': 'dovetail_sl',
    'smartlinks-connector-dropbox': 'dropbox_sl',
    'smartlinks-connector-figma': 'figma_sl',
    'smartlinks-connector-gdrive': 'google_drive_sl',
    'smartlinks-connector-gitlab': 'gitlab_sl',
    'smartlinks-connector-hubspot': 'hubspot_sl',
    'smartlinks-connector-launchdarkly': 'launchdarkly_sl',
    'smartlinks-connector-lucid': 'lucid_sl',
    'smartlinks-connector-miro': 'miro_sl',
    'smartlinks-connector-mural': 'mural_sl',
    'smartlinks-connector-notion': 'notion_sl',
    'smartlinks-connector-onedrive': 'microsoft_onedrive_sl',
    'smartlinks-connector-pagerduty': 'pagerduty_sl',
    'smartlinks-connector-pipedrive': 'pipedrive_sl',
    'smartlinks-connector-power-bi': 'microsoft_power_bi',
    'smartlinks-connector-salesforce': 'salesforce_sl',
    'smartlinks-connector-sentry': 'sentry_sl',
    'smartlinks-connector-sharepoint': 'microsoft_sharepoint_sl',
    'smartlinks-connector-slack': 'slack_sl',
    'smartlinks-connector-smartsheet': 'smartsheet_sl',
    'smartlinks-connector-stripe': 'stripe_sl',
    'smartlinks-connector-teams': 'microsoft_teams_sl',
    'smartlinks-connector-todoist': 'todoist',
    'smartlinks-connector-webex': 'cisco_webex',
    'smartlinks-connector-zeplin': 'zeplin',
    'smartsheet-connector': 'smartsheet',
    'splunk-connector': 'splunk',
    'stripe-connector': 'stripe',
    'webcrawler-connector': 'atlassian-web-crawler',
    'zendesk-connector': 'zendesk'
};
const $985791042dd30882$export$89fdcff8d9dee79d = {
    // 1P / noun entries
    'jira-servicedesk': 'jsm',
    goal: 'atlas_goal',
    project: 'atlas_project',
    // 3P connectors with an unambiguous product key.
    'adobe-sign': 'adobe_sign',
    'azure-devops': 'azure_devops',
    'entra-id': 'entra',
    'google-calendar': 'google_calendar',
    'google-cloud-platform': 'gcp',
    'jira-dc': 'jira_dc',
    'outlook-calendar': 'microsoft_outlook_calendar',
    'power-bi': 'microsoft_power_bi',
    webex: 'cisco_webex'
};
const $985791042dd30882$export$7620cdb993bdcefe = (resourceType)=>resourceType ? $985791042dd30882$export$f3ac85cf46d74e63[resourceType] : undefined;
const $985791042dd30882$export$a8bdef839b443283 = (productKey)=>$985791042dd30882$export$89fdcff8d9dee79d[productKey] ?? productKey;
const $985791042dd30882$export$f64d9e2f6c8f5b6d = (productKey, resourceType)=>$985791042dd30882$export$7620cdb993bdcefe(resourceType) ?? $985791042dd30882$export$a8bdef839b443283(productKey);
module.exports["SOURCE_BY_RESOURCE_TYPE"] = $985791042dd30882$export$f3ac85cf46d74e63;
module.exports["sourceFromResourceType"] = $985791042dd30882$export$7620cdb993bdcefe;
module.exports["toChatSourceKey"] = $985791042dd30882$export$a8bdef839b443283;
module.exports["resolveChatSource"] = $985791042dd30882$export$f64d9e2f6c8f5b6d;

});

parcelRegister("esPYZ", function(module, exports) {
const $44b64fbb9c093e8d$export$fc392cb6f9de2d01 = (entries)=>{
    const sorted = [
        ...entries
    ].sort((a, b)=>a.friendlyName.localeCompare(b.friendlyName, undefined, {
            sensitivity: 'base'
        }) || (a.source < b.source ? -1 : a.source > b.source ? 1 : 0));
    const connectors = {};
    for (const entry of sorted)connectors[entry.source] = entry;
    return connectors;
};
module.exports["sortConnectorsByFriendlyName"] = $44b64fbb9c093e8d$export$fc392cb6f9de2d01;

});

parcelRegister("hCtla", function(module, exports) {
/**
 * RAOC-22 — Canonical `useRovoConfig` hook, ported from
 * `@atlassian/search-page/src/controllers/config/index.tsx` (the search-page
 * `useFetchConfig`).
 *
 * This hook is intended to become the canonical way to fetch the combined
 * Rovo search bootstrap config (1P + 3P + nouns + site metadata + linked
 * sites). It is currently being rolled out behind the
 * `rovo_fps_use_rovo_config` feature gate and is **not yet** the supported
 * replacement for the legacy `useFetchConfig` (also exported from this
 * package) — that hook will only be marked `@deprecated` after rollout
 * completes. See RAOC-22.
 *
 * Also being rolled out behind the `rovo_cas_use_rovo_config` as part of RAOC-23
 * used by downstreams of conversation-assistant-store (Chat, etc)
 *
 * Differences from search-page's `useFetchConfig` body (clean up when removing rovo_fps_use_rovo_config):
 *   - `primaryProduct` is **not** a prop. Primary-product patching moves
 *     out of the hook and into search-page as a post-hook transform
 *     applied at the call site (PR-3). Per plan decision #21.
 *   - Analytics are fully internalised: the hook builds its own
 *     `fireAnalyticsEvent` via `useAnalyticsEvents()` from
 *     `@atlaskit/analytics-next` and its own `logException`. No `analytics`
 *     prop is required.
 *   - Combined-config UX VitalStats are opt-in for the two experiences that
 *     own the measurement: Search page emits `search-page/combined-config-ux`
 *     and Quick Find emits `quick-find/combined-config-ux`. Other consumers
 *     still emit the shared network reliability lifecycle, but no UX lifecycle.
 *   - Optional `shouldBypassPreloadProvider(preloaded)` callback lets the
 *     caller skip the preload provider for specific sources (search-page
 *     passes `isQuickFindAsyncPreloadEnabled() && preloaded?.source ===
 *     'quick-find'`). Per plan decision #5.
 *   - `preloadDataProvider` is typed as the narrow
 *     `RovoConfigPreloadProvider` (see `./combined-config/preload-types.ts`).
 *     Search-page's wider `SearchPreloadDataProvider` satisfies the narrow
 *     shape structurally.
 *   - The combined-config `parseCombinedConfig` post-processing is removed
 *     from this hook: callers that want it should call `parseCombinedConfig`
 *     directly on the returned `combinedConfigResponse`. This keeps the
 *     hook's return shape stable across the `search_async_ssr` cleanup
 *     boundary (post-cleanup shape per plan decision #7).
 *   - `isNounsAvailable` is **not** returned — per plan decision #8.
 *
 * thirdPartyConfigs{}.userNeedsOAuth is overridded by a global in-tab store
 * that tracks which products/datasources have been OAuth-connected. This is
 * to ensure that all instances of useRovoConfig reflect the same OAuth state.
 * Any usages of onOAuthSuccess will propagate the updated userNeedsOAuth value
 * to all useRovoConfig hook instances. Now when a user oauths successfully from
 * from any downstream of useRovoConfig, all experiences get the connected state (search<>chat etc)
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $kQgL7 = parcelRequire("kQgL7");


var $dv1ov = parcelRequire("dv1ov");


var $9XgN6 = parcelRequire("9XgN6");


var $8dVj6 = parcelRequire("8dVj6");


var $l2Koi = parcelRequire("l2Koi");


var $kpT28 = parcelRequire("kpT28");


var $6RVrq = parcelRequire("6RVrq");


var $giMYc = parcelRequire("giMYc");


var $gu6Gy = parcelRequire("gu6Gy");


var $c4BXr = parcelRequire("c4BXr");


var $j1VvP = parcelRequire("j1VvP");


var $ioLQc = parcelRequire("ioLQc");


var $dfngu = parcelRequire("dfngu");


var $2rf9w = parcelRequire("2rf9w");

const $1d42590b353a470b$export$645730e6fdb2112b = (state)=>state.hit ? state.refreshTriggered ? 'stale' : 'warm' : 'cold';
const $1d42590b353a470b$var$EMPTY_RESPONSE = [];
/**
 * VitalStats task names emitted by this hook. Owned by `useRovoConfig`
 * (not caller-supplied) — see RAOC-22 open question Q1.
 *
 * TODO RAOC-22 migrate analytics off search-specific naming
 */ const $1d42590b353a470b$var$TASK_NAME_UX_BY_CONSUMER = {
    'search-page': 'search-page/combined-config-ux',
    'quick-find': 'quick-find/combined-config-ux'
};
const $1d42590b353a470b$var$TASK_NAME_NETWORK = 'search-page/combined-config-network';
// TODO RAOC-22 migrate analytics off search-specific naming
const $1d42590b353a470b$var$source = 'advancedSearchScreen';
const $1d42590b353a470b$export$9d26acf0ac0b34e7 = ({ cloudId: cloudIdProp, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, analyticsConsumer: analyticsConsumer, preloadDataProvider: preloadDataProvider, shouldBypassPreloadProvider: shouldBypassPreloadProvider, onForgeConnectorTypeMapping: onForgeConnectorTypeMapping, onConfigCacheState: onConfigCacheState })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || $1d42590b353a470b$var$source,
            attributes: {
                ...payload.attributes?.commonAttributes,
                ...payload.attributes?.additionalAttributes
            }
        }).fire('fabric-elements');
    }, [
        createAnalyticsEvent
    ]);
    const shouldUseConsumerAnalytics = (0, $iDrrr.fg)('rovo_fps_dedupe_combined_config_ux');
    const effectiveAnalyticsConsumer = shouldUseConsumerAnalytics ? analyticsConsumer : 'search-page';
    const taskNameUx = effectiveAnalyticsConsumer ? $1d42590b353a470b$var$TASK_NAME_UX_BY_CONSUMER[effectiveAnalyticsConsumer] : undefined;
    const taskNameNetwork = $1d42590b353a470b$var$TASK_NAME_NETWORK;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $cozmU.useState)({});
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $cozmU.useState)();
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    // Keep a live ref to the latest thirdPartyConfigs so the stable
    // `onOAuthSuccess` callback (created once with no React-state deps)
    // can read the current value without going stale across renders.
    const thirdPartyConfigsRef = (0, $cozmU.useRef)(accessibleProductsConfig.thirdPartyConfigs);
    thirdPartyConfigsRef.current = accessibleProductsConfig.thirdPartyConfigs;
    const onOAuthSuccess = (0, $cozmU.useCallback)(({ product: product, datasourceId: datasourceId })=>{
        const currentConfigs = thirdPartyConfigsRef.current;
        const productConfig = currentConfigs?.[product];
        if (!productConfig) return;
        if (datasourceId !== undefined && !productConfig.datasources?.some((ds)=>ds.datasourceId === datasourceId)) return;
        let nextConfigs = currentConfigs;
        if (datasourceId === undefined) {
            if (productConfig.userNeedsOAuth !== false) nextConfigs = {
                ...currentConfigs,
                [product]: {
                    ...productConfig,
                    userNeedsOAuth: false
                }
            };
        } else {
            const datasources = productConfig.datasources ?? [];
            const targetIdx = datasources.findIndex((ds)=>ds.datasourceId === datasourceId);
            if (targetIdx >= 0 && datasources[targetIdx].userNeedsOAuth !== false) {
                const nextDatasources = datasources.map((ds, i)=>i === targetIdx ? {
                        ...ds,
                        userNeedsOAuth: false
                    } : ds);
                nextConfigs = {
                    ...currentConfigs,
                    [product]: {
                        ...productConfig,
                        datasources: nextDatasources
                    }
                };
            }
        }
        thirdPartyConfigsRef.current = nextConfigs;
        setAccessibleProductsConfig((prev)=>({
                ...prev,
                thirdPartyConfigs: nextConfigs
            }));
        // Record the connection in the shared, in-tab OAuth-override store so
        // that EVERY other `useRovoConfig` instance for this cloudId (not just
        // this one) reactively re-renders and overlays `userNeedsOAuth: false`.
        // This is what gives `useRovoConfig` its singleton-like OAuth behaviour
        // across independent component subtrees. Keyed on the same cloudId used
        // for the persisted cache below.
        if (cloudIdProp) (0, $2rf9w.markOAuthConnected)(cloudIdProp, product, datasourceId);
        if (cloudIdProp) {
            const thirdPartyTypes = (0, $l2Koi.getThirdPartyTypes)();
            (0, $kQgL7.updateBaseCombinedConfigCacheEntry)(cloudIdProp, (config)=>({
                    ...config,
                    thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                        if (datasourceId) {
                            if (entry.datasourceId === datasourceId) return {
                                ...entry,
                                isUserOAuthed: true,
                                hasAuthUpgrade: false
                            };
                        } else if (thirdPartyTypes[entry.name] === product) return {
                            ...entry,
                            isUserOAuthed: true,
                            hasAuthUpgrade: false
                        };
                        return entry;
                    })
                }));
        }
    }, [
        cloudIdProp
    ]);
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $9XgN6.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        // `isCancelled` guards against a stale `searchLinkedSitesQuery` promise
        // resolving after the effect has been re-run (e.g. when `cloudIdProp` or
        // `firstCloudId` changes). Without this, a slower in-flight request could
        // overwrite a newer, correct linkedCloudARIs value. Set in the cleanup
        // function returned below and checked before every state update inside
        // `.then()` / `.catch()`.
        let isCancelled = false;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        })// The shape returned by `searchLinkedSitesQuery` is not exported by
        // `@atlassian/search-client/search-page`, so we narrow it locally:
        // it's a GraphQL response keyed by the operation name with an
        // `edges`/`node`/`id` chain. Use `unknown` + a structural cast at the
        // access site instead of `any` so subsequent property access stays
        // type-checked. Long-term fix is to export a type from search-client
        // — tracked alongside the other search-client type-promotion follow-ups
        // in the RAOC-22 work doc.
        .then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            if (isCancelled) return;
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            if (isCancelled) return;
            (0, $gu6Gy.logException)(error);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        aggAbsoluteUrl
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = taskNameUx ? {
                    taskId: uxTaskId,
                    task: taskNameUx
                } : undefined;
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $6RVrq.onDegradedDependency)({
                        dependency: 'search-combined-config',
                        reason: reason,
                        source: $1d42590b353a470b$var$source
                    }));
                };
                // NOTE: `CacheAnalyticsCallback` is strictly typed as
                // `(state) => Promise<void>` in `@atlassian/search-client/persist-refresh`,
                // so the `async` keyword is structurally required even though the body
                // is synchronous. (Earlier review feedback suggested dropping `async`
                // — that turns out to be incorrect against the current type.) The
                // long-term fix is to widen `CacheAnalyticsCallback` to also accept
                // `void`, tracked as a search-client-tightening follow-up alongside
                // the other type-promotion items in the RAOC-22 work doc.
                const cacheAnalyticsCallback = async (state)=>{
                    onConfigCacheState?.($1d42590b353a470b$export$645730e6fdb2112b(state));
                    fireAnalyticsEvent((0, $c4BXr.onRequestCacheAccess)({
                        requestName: 'search-combined-config',
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: $1d42590b353a470b$var$source
                    }));
                };
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $j1VvP.createVitalStatsNetworkCallbacks)(configNetworkTaskId, taskNameNetwork, // `createVitalStatsNetworkCallbacks` types its sink as
                // `(event: unknown) => void` to match the factory return
                // shape; our caller sink is typed `(event: FireAnalyticsEvent) => void`.
                // Adapt at the call site — narrow cast is safe because the
                // values come from `onTaskStart` / `onTaskSuccess` / `onTaskFail`
                // in `../network/network-task-tracker`, owned by this package.
                (event)=>fireAnalyticsEvent(event), taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                if (baseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskStart)(baseUXVitalStatsParams));
                (0, $kQgL7.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    // RAOC: fill the AAID-scoped SSR cache key so the next
                    // server-side render can hydrate `window.__PRELOADED_SEARCH__`.
                    // The hook no longer receives a `userId` prop, so the account
                    // id is resolved asynchronously via `/gateway/api/me` (owned by
                    // this package) and passed to `fillSsrCombinedConfigCache`.
                    if (cloudIdProp) (0, $kpT28.fetchCurrentUserAccountId)().then((accountId)=>(0, $kQgL7.fillSsrCombinedConfigCache)({
                            accountId: accountId,
                            cloudId: cloudIdProp,
                            config: configuration,
                            expiration: combinedConfigTTL
                        })).catch((fillError)=>{
                        (0, $gu6Gy.logException)(fillError);
                    });
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $8dVj6.adaptCombinedConfigToLegacy)(configuration, cloudIdProp);
                    const mappedThirdPartyResponse = (0, $l2Koi.map3pResourcesToProductKeys)(thirdPartyConfig, onForgeConnectorTypeMapping);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse(mappedThirdPartyResponse);
                    // Derive and publish the accessible products synchronously here, in the
                    // same commit that sets the config responses, rather than deferring to
                    // the products effect below. Everything the derivation needs is already
                    // available, so this removes an extra render → commit round-trip before
                    // the results list can mount. The products effect remains as the
                    // preload/SSR-path authority and an idempotent safety net.
                    setAccessibleProductsConfig((0, $dfngu.deriveAccessibleProductsConfig)(firstPartyConfig, mappedThirdPartyResponse, cloudIdProp));
                    setIsConfigLoaded(true);
                    if (baseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskSuccess)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    (0, $gu6Gy.logException)(error);
                    fireAnalyticsEvent((0, $giMYc.onFailedDependency)({
                        dependency: 'search-combined-config',
                        source: $1d42590b353a470b$var$source
                    }));
                    if (baseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskFail)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $1d42590b353a470b$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // Read the preload provider at most once per effect run. A stateful
            // provider (e.g. one that clears the entry on first access) would
            // otherwise return null on the second read. Per plan decision #5,
            // `shouldBypassPreloadProvider` receives the cached value below.
            let cachedPreloadedSearch = null;
            let hasReadPreload = false;
            const readPreloadedSearch = ()=>{
                if (!hasReadPreload) {
                    hasReadPreload = true;
                    try {
                        cachedPreloadedSearch = preloadDataProvider?.getPreloadedSearch({
                            cloudId: cloudIdProp
                        }) ?? null;
                    } catch  {
                        // Reading the preload provider must never throw — be defensive.
                        cachedPreloadedSearch = null;
                    }
                }
                return cachedPreloadedSearch;
            };
            // Optional bypass — see plan decision #5
            let shouldBypass = false;
            if (shouldBypassPreloadProvider) shouldBypass = shouldBypassPreloadProvider(readPreloadedSearch());
            if (preloadDataProvider && !shouldBypass) {
                try {
                    const preloadedSearch = readPreloadedSearch();
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = taskNameUx ? {
                            taskId: preloadUxTaskId,
                            task: taskNameUx,
                            moreContext: preloadMoreContext
                        } : undefined;
                        if (preloadBaseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskStart)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $8dVj6.adaptCombinedConfigToLegacy)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $l2Koi.map3pResourcesToProductKeys)(thirdPartyConfig, onForgeConnectorTypeMapping));
                            const preloadedConfig = preloadedSearch.config;
                            if (!preloadedSearch.isConfigFromCache && preloadedConfig && cloudIdProp) {
                                (0, $kQgL7.seedBaseCombinedConfigCacheEntry)({
                                    cloudId: cloudIdProp,
                                    config: preloadedConfig,
                                    expiration: combinedConfigTTL
                                }).catch((seedError)=>{
                                    (0, $gu6Gy.logException)(seedError);
                                });
                                (0, $kpT28.fetchCurrentUserAccountId)().then((accountId)=>(0, $kQgL7.fillSsrCombinedConfigCache)({
                                        accountId: accountId,
                                        cloudId: cloudIdProp,
                                        config: preloadedConfig,
                                        expiration: combinedConfigTTL
                                    })).catch((fillError)=>{
                                    (0, $gu6Gy.logException)(fillError);
                                });
                            }
                            if (preloadBaseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskSuccess)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            if (preloadedSearch.isConfigFromCache) // Preload gives immediate UI data, but we still run the normal combined-config
                            // path so cache TTL rules can trigger a network refresh when the entry is expired.
                            fetchCombinedConfig();
                            return;
                        } catch (error) {
                            (0, $gu6Gy.logException)(error);
                            if (preloadBaseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskFail)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return;
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $giMYc.onFailedDependency)({
                        dependency: 'search-config-ssr',
                        source: $1d42590b353a470b$var$source,
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    (0, $gu6Gy.logException)(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        aggAbsoluteUrl,
        fireAnalyticsEvent,
        preloadDataProvider,
        shouldBypassPreloadProvider,
        taskNameUx,
        taskNameNetwork,
        onForgeConnectorTypeMapping,
        onConfigCacheState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (combinedThirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            // On the client fetch path the accessible products are now derived and
            // published synchronously in the config-resolve handler above, so the
            // `!accessibleProductsConfig.products` guard means this effect no longer
            // runs for that navigation. It is retained as the authority for the
            // preload/SSR path — which sets the responses without going through that
            // handler — and as an idempotent safety net, sharing the same pure
            // derivation helper so behaviour is identical on both paths.
            setAccessibleProductsConfig((0, $dfngu.deriveAccessibleProductsConfig)(firstPartyResponse, combinedThirdPartyResponse, cloudIdProp));
            setIsConfigLoaded(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `setAccessibleProductsConfig`
    // is a useState setter with a stable identity guaranteed by React; including it in the
    // dep array would be misleading. The fields that genuinely drive this effect are the
    // three values below.
    }, [
        combinedThirdPartyResponse,
        firstPartyResponse,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const isRovoEnabled = (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
    const isJiraIssueIndexed = (0, $9XgN6.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
    const productEdition = (0, $9XgN6.getProductEdition)(firstPartyResponse, cloudIdProp);
    const productDataRegions = (0, $9XgN6.getProductDataRegions)(firstPartyResponse, cloudIdProp);
    const rovoFeatures = (0, $9XgN6.getRovoFeatures)(firstPartyResponse, cloudIdProp);
    // Subscribe this instance to the shared in-tab OAuth-override store. Any
    // `onOAuthSuccess` (from THIS or ANY OTHER `useRovoConfig` instance) bumps
    // the version, re-rendering every subscriber so the overlay below recomputes.
    const oauthOverridesVersion = (0, $cozmU.useSyncExternalStore)((0, $2rf9w.subscribeToOAuthOverrides), (0, $2rf9w.getOAuthOverridesVersion), // Server snapshot: no overrides exist during SSR — return a constant 0
    // so the server-side contract is immune to any module-level state that
    // might be non-zero in a long-lived SSR process.
    ()=>0);
    // Overlay the shared OAuth overrides onto the derived configs so a connection
    // performed by any instance is reflected here as `userNeedsOAuth: false`.
    const thirdPartyConfigsWithOverrides = (0, $cozmU.useMemo)(()=>{
        const base = accessibleProductsConfig.thirdPartyConfigs;
        // SSR guard: hasAnyOAuthOverrideForCloud reads from module state, which is not guaranteed to be zero in a long-lived SSR process. If it is non-zero, the server-side contract is violated and the server-rendered markup will mismatch the client render. Return the base configs unmodified during SSR so the server-side contract is preserved.
        if (typeof window === 'undefined') return base;
        if (!(0, $iDrrr.fg)('rovo_slack_admin_auth_optional_user_oauth') && (!cloudIdProp || !(0, $2rf9w.hasAnyOAuthOverrideForCloud)(cloudIdProp))) return base;
        return (0, $ioLQc.applyOAuthOverrides)(base, (product, datasourceId)=>(0, $2rf9w.isOAuthConnected)(cloudIdProp ?? '', product, datasourceId), (0, $iDrrr.fg)('rovo_slack_admin_auth_optional_user_oauth'));
    // `oauthOverridesVersion` is the reactive trigger: it changes whenever the
    // shared store mutates, which is precisely when the overlay must recompute.
    // It acts here as a cache-busting key for the memoization
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accessibleProductsConfig.thirdPartyConfigs,
        cloudIdProp,
        oauthOverridesVersion
    ]);
    return (0, $cozmU.useMemo)(()=>{
        return {
            accessibleProducts: accessibleProducts,
            accessibleNouns: accessibleProductsConfig.nouns,
            thirdPartyConfigs: thirdPartyConfigsWithOverrides,
            firstCloudId: firstCloudId,
            intercomHmac: firstPartyResponse?.intercomHmac,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs,
            unitMetadata: combinedConfigResponse?.unitMetadata ?? undefined,
            combinedConfigResponse: // TODO RAOC-22 clean up when removing FG('rovo_fps_use_rovo_config') and the search-page `useFetchConfig` fallback logic that relies on this field being present in the return type as this will no longer be used
            combinedConfigResponse,
            onOAuthSuccess: onOAuthSuccess
        };
    }, [
        accessibleProducts,
        accessibleProductsConfig.nouns,
        thirdPartyConfigsWithOverrides,
        firstCloudId,
        firstPartyResponse?.intercomHmac,
        isRovoEnabled,
        isJiraIssueIndexed,
        productEdition,
        productDataRegions,
        rovoFeatures,
        isConfigLoaded,
        linkedCloudARIs,
        combinedConfigResponse,
        onOAuthSuccess
    ]);
};
module.exports["toConfigCacheState"] = $1d42590b353a470b$export$645730e6fdb2112b;
module.exports["useRovoConfig"] = $1d42590b353a470b$export$9d26acf0ac0b34e7;

});

parcelRegister("9XgN6", function(module, exports) {
/**
 * Internal regex used to extract a cloudId from a Resource ARI of the form:
 *   ari:cloud:<product>::<resourceType>/<cloudId>
 * Capture group 1 yields the cloudId.
 *
 * Public via `getFirstCloudId(...)` and is not exported directly.
 */ const $ee0362899d9e596b$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $ee0362899d9e596b$export$cd4718f771339207 = /ari:cloud:(.*)::/;
const $ee0362899d9e596b$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($ee0362899d9e596b$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $ee0362899d9e596b$export$e9de73272abc8489 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $ee0362899d9e596b$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $ee0362899d9e596b$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $ee0362899d9e596b$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $ee0362899d9e596b$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["EXTRACT_PRODUCT_FROM_ARI"] = $ee0362899d9e596b$export$cd4718f771339207;
module.exports["getFirstCloudId"] = $ee0362899d9e596b$export$c1871fdf674a03c4;
module.exports["isRovoEnabledForSite"] = $ee0362899d9e596b$export$e9de73272abc8489;
module.exports["getJiraIssueIndexedForTenant"] = $ee0362899d9e596b$export$37c9c6a3ae5f363c;
module.exports["getProductEdition"] = $ee0362899d9e596b$export$53e066a63a960439;
module.exports["getProductDataRegions"] = $ee0362899d9e596b$export$c635d3296555e2da;
module.exports["getRovoFeatures"] = $ee0362899d9e596b$export$2a1c0662041ee0a3;

});

parcelRegister("8dVj6", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied verbatim from
 * `@atlassian/search-page/src/controllers/config/combined-config-adapter.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Adapts the combined-config response shape to the legacy 1P/3P shape that
 * downstream consumers (third-party-products parser, site-metadata helpers)
 * still operate on. Long-term these consumers should be re-written to read
 * the combined-config shape directly (see TODO QS-9614 in search-page).
 */ const $e088b8fa7aa2d140$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $e088b8fa7aa2d140$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $e088b8fa7aa2d140$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            // field removed from aggregator; kept to satisfy TSiteMetadata type contract in search-client
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $e088b8fa7aa2d140$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $e088b8fa7aa2d140$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $e088b8fa7aa2d140$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $e088b8fa7aa2d140$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            hasAuthUpgrade: product.hasAuthUpgrade,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            authResolutionMode: product.authResolutionMode ?? undefined,
            // `product.integrationARI` arrives as `string | null` from the
            // aggregator; `T3pResource['integrationId']` is the branded
            // `PlatformIntegrationAri` nominal type. The value is already an
            // ARI string at this point (it originates server-side from the
            // platform integration registry), so this is structurally safe —
            // the cast only exists to satisfy the brand. Single-step casts
            // (`as PlatformIntegrationAri`) don't work because TS rejects
            // `string`-to-branded direct assignment; the `unknown` hop is the
            // idiomatic workaround. Same pattern is used in
            // `third-party-products.ts`. RAOC-22 follow-up: tighten in
            // search-client by exposing a constructor for branded ARIs.
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            connectedAt: product.connectedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $e088b8fa7aa2d140$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $e088b8fa7aa2d140$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            intercomHmac: configuration.intercomHmac || '',
            siteMetadata: $e088b8fa7aa2d140$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $e088b8fa7aa2d140$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};
module.exports["adaptCombinedConfigToLegacy"] = $e088b8fa7aa2d140$export$160fbca21b53d78a;

});

parcelRegister("l2Koi", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/controllers/config/utils/third-party-products.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Uses the following feature gates (all registered in this package's
 * `platform-feature-flags` map; cleanup tracked in their respective FFCLEANUP
 * tickets — see RAOC-22 plan FG inventory):
 *   - `ai_3p_slack_connector_status_transition_enabled` (no FFCLEANUP yet)
 *   - `ai3p_webcrawler_multi_domain_support` (FFCLEANUP-96797)
 */ 
var $iDrrr = parcelRequire("iDrrr");


var $aoy1P = parcelRequire("aoy1P");


var $fd0l2 = parcelRequire("fd0l2");


var $8Oyja = parcelRequire("8Oyja");


var $hGRCq = parcelRequire("hGRCq");


var $eSwze = parcelRequire("eSwze");

const $dc4d5222d6ee07ae$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
const $dc4d5222d6ee07ae$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $dc4d5222d6ee07ae$export$4cb8ef4a677c563c = (resources, onForgeConnectorTypeMapping)=>{
    const THIRD_PARTY_TYPES = $dc4d5222d6ee07ae$export$6750011b01164bda();
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(resource.type)) {
            const config = (0, $eSwze.mapForgeConnectorToThirdPartyConfig)(resource, onForgeConnectorTypeMapping);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        // NOTE: `productKey` is pushed unconditionally, BEFORE the `if (staticConfig)` guard
        // below. This means a connector type present in `THIRD_PARTY_TYPES` but absent from
        // `ThirdPartyConfigsSync` will appear in the returned `productKeys` without a
        // corresponding entry in `thirdPartyConfigs`. Downstream consumers must therefore
        // treat `thirdPartyConfigs[productKey]` as possibly-undefined for keys that exist in
        // `productKeys`. This is the verbatim search-page behaviour — changing the ordering
        // here would alter the analytics/contract surface and break the search-page
        // equivalence test. RAOC-22 follow-up: reconcile in a behaviour-fix PR after PR-4.
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = productKey === 'slack' && (0, $iDrrr.fg)('ai_3p_slack_connector_status_transition_enabled');
            const isFederatedNoOAuthConnector = $dc4d5222d6ee07ae$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $aoy1P.LITE_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE) : (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            // The static config's `resourceType` is the *full-connector* key
            // (e.g. `box-connector`), which is correct for full/federated/lite
            // connections. But a SmartLinks connection arrives with a distinct
            // `resource.type` (e.g. `smartlinks-connector-box`) that the chat
            // layer must be able to disambiguate so it can remap to the
            // SmartLinks-specific source (e.g. `box_sl`). Inheriting only the
            // static key collapses both variants onto the full-connector source,
            // so for a *pure* SmartLinks connection we preserve the real
            // `resource.type`. See `resolveChatSource` / `SOURCE_BY_RESOURCE_TYPE`.
            //
            // Full always wins: a single product key holds one merged config, so
            // when a full connector also exists for this product we must keep the
            // full-connector `resourceType` (→ chat source `box`, not `box_sl`),
            // regardless of the order the endpoint returns the two variants in.
            // `isExistingConfigFullConnectorSource` covers "full processed first";
            // a non-SmartLinks current resource already yields the static key, so
            // the only way to reach the SmartLinks key is a SmartLinks resource
            // with no full sibling already recorded.
            //
            // We key the decision off the already-computed `sourceType` so that the
            // SmartLinks detection here cannot drift from the `sourceType`
            // classification above (both use `SMARTLINKS_CONNECTOR_SOURCE`).
            //
            // Gated behind `rovo_cas_use_rovo_config`: `map3pResourcesToProductKeys`
            // also feeds the (currently un-gated) `getThirdPartyConfigs` /
            // `parseCombinedConfig` path, so we only change the emitted
            // `resourceType` when the chat-side (CAS) consumer is enabled. When the
            // gate is off we keep the legacy static full-connector key.
            const resourceType = sourceType === (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE) && !isExistingConfigFullConnectorSource && (0, $8Oyja.isUsingRovoConfigStoreExperiment)() ? resource.type : staticConfig.resourceType;
            config = {
                ...staticConfig,
                resourceType: resourceType,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                authResolutionMode: resource.authResolutionMode,
                connectorCreatedAt: resource.connectorCreatedAt ?? undefined,
                connectedAt: resource.connectedAt ?? undefined
            };
            const datasourceList = [];
            const { datasources: _datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// Renamed to avoid shadowing the outer `_datasources` / `configWithoutDatasources`
            // destructuring above (introduced when removing the eslint-disable in the same
            // review round).
            ({ datasources: _d, ...cleanedEntry })=>cleanedEntry);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey)) return true;
        return (0, $hGRCq.allProductKeys).includes(productKey);
    });
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
module.exports["getThirdPartyTypes"] = $dc4d5222d6ee07ae$export$6750011b01164bda;
module.exports["map3pResourcesToProductKeys"] = $dc4d5222d6ee07ae$export$4cb8ef4a677c563c;

});

parcelRegister("8Oyja", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $c2bdff781059a6b6$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
const $c2bdff781059a6b6$export$752769d90d201b0a = ()=>{
    return (0, $cXtTj.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $c2bdff781059a6b6$export$aa9f97d4dfccb6ff;

});

parcelRegister("hGRCq", function(module, exports) {

var $aqAfG = parcelRequire("aqAfG");


var $fR63l = parcelRequire("fR63l");

const $fc005fb0f05fc434$export$73be91b73ebbdb05 = [
    ...Object.values((0, $aqAfG.ProductKeys1P)),
    ...Object.values((0, $fR63l.ProductKeys3P))
];
module.exports["allProductKeys"] = $fc005fb0f05fc434$export$73be91b73ebbdb05;

});

parcelRegister("kpT28", function(module, exports) {

var $fExfj = parcelRequire("fExfj");

/**
 * RAOC: account-id resolution for the combined-config SSR cache fill.
 *
 * `useRovoConfig` no longer receives a `userId` prop. The only remaining need
 * for the Atlassian Account ID (AAID) is to write the SSR localStorage cache
 * entry under the AAID-based inner hash that the Confluence SSR preloader
 * (`@confluence/search-route-preloader` → `preloadSearch.ts`) reads back.
 *
 * This module resolves the current user's AAID via a local lookup of
 * `/gateway/api/me`, mirroring the existing pattern in
 * `@confluence/error-app` (`fetchGet('/gateway/api/me') → account_id`).
 *
 * It lives in `rovo-connectors-config` (the orchestrator of the SSR-fill)
 * rather than `search-client`, so the network call is owned by the package
 * that decides when to fill the cache; `search-client` only owns the cache
 * key shape.
 *
 * The result is memoised for the lifetime of the page: the AAID does not
 * change within a session, and the SSR-fill may run on multiple config
 * resolutions, so we fetch at most once.
 */ const $dfcac43b6a59aecf$var$RELATIVE_URL_ME = '/gateway/api/me';
/**
 * In-memory, page-lifetime memo of the in-flight (or resolved) `/me` request.
 * Reset only by a full page load. Stores the promise (not just the value) so
 * concurrent callers share a single network request.
 */ let $dfcac43b6a59aecf$var$currentUserAccountIdPromise;
const $dfcac43b6a59aecf$var$requestCurrentUserAccountId = async ()=>{
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    try {
        const response = await (0, $fExfj.utils).requestService({
            url: $dfcac43b6a59aecf$var$RELATIVE_URL_ME
        }, options);
        return response?.account_id ?? null;
    } catch  {
        // Best-effort: a failed /me lookup only degrades the SSR warm path
        // (the next SSR falls back to a network preload). Never throw.
        return null;
    }
};
const $dfcac43b6a59aecf$export$35d4e28a86099a2d = async ()=>{
    // SSR guard — the fill only ever runs in the browser.
    if (typeof window === 'undefined') return null;
    if (!$dfcac43b6a59aecf$var$currentUserAccountIdPromise) $dfcac43b6a59aecf$var$currentUserAccountIdPromise = $dfcac43b6a59aecf$var$requestCurrentUserAccountId().then((accountId)=>{
        // Do not memoise a null result: allow a later retry to succeed
        // (e.g. transient /me failure during early page load).
        if (accountId == null) $dfcac43b6a59aecf$var$currentUserAccountIdPromise = undefined;
        return accountId;
    });
    return $dfcac43b6a59aecf$var$currentUserAccountIdPromise;
};
const $dfcac43b6a59aecf$export$a4689f8cac12fef8 = ()=>{
    $dfcac43b6a59aecf$var$currentUserAccountIdPromise = undefined;
};
module.exports["fetchCurrentUserAccountId"] = $dfcac43b6a59aecf$export$35d4e28a86099a2d;

});

parcelRegister("6RVrq", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 *
 * Not exported via a package subpath — consumers should not import this
 * directly; the canonical way to fire a degraded-dependency event is by
 * passing analytics callbacks into the hook.
 *
 * NOTE: `FireAnalyticsEvent` is intentionally not imported from search-page
 * to avoid a cross-package cycle. We type the return value structurally to
 * match the search-page shape — search-page's `FireAnalyticsEvent` and ours
 * are compatible at the structural level (both extend `GasPayload &
 * AnalyticsAttributes`).
 */ const $dd25054093a45ece$export$e98932ab9e22c265 = ({ dependency: dependency, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason
            }
        }
    };
};
module.exports["onDegradedDependency"] = $dd25054093a45ece$export$e98932ab9e22c265;

});

parcelRegister("giMYc", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $da74afbce11dfb8c$export$7199f2d13e6ae9f7 = ({ dependency: dependency, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                ...moreContext || {}
            }
        }
    };
};
module.exports["onFailedDependency"] = $da74afbce11dfb8c$export$7199f2d13e6ae9f7;

});

parcelRegister("gu6Gy", function(module, exports) {

var $3X0xX = parcelRequire("3X0xX");


var $cFPRS = parcelRequire("cFPRS");

const $fbae18216f314d2d$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await (0, $cFPRS.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $3X0xX.COMMON_TAGS)))scope.setTag(key, value);
            SentryClient.captureException(error, scope);
        });
    } catch (sentryError) {
        // When there was an error with Sentry, just output to console.
        // eslint-disable-next-line no-console
        console.error(sentryError);
    }
};
module.exports["logException"] = $fbae18216f314d2d$export$f86b2a1a2ce291b3;

});

parcelRegister("3X0xX", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $93a257f313f96bb6$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $93a257f313f96bb6$export$ea77880e3935182d = 'unknown';
const $93a257f313f96bb6$export$d60e93659f587f71 = {
    search: true // Used to filter out errors that are not from search projects
};
module.exports["SENTRY_DSN"] = $93a257f313f96bb6$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $93a257f313f96bb6$export$ea77880e3935182d;
module.exports["COMMON_TAGS"] = $93a257f313f96bb6$export$d60e93659f587f71;

});

parcelRegister("cFPRS", function(module, exports) {

var $baU6C = parcelRequire("baU6C");


var $22XrW = parcelRequire("22XrW");


var $3X0xX = parcelRequire("3X0xX");

let $0370a31091c42c7d$var$Sentry;
const $0370a31091c42c7d$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from search projects
    if (!event.tags?.search) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $0370a31091c42c7d$export$f553e8b08ef59d31 = async ()=>{
    if (!$0370a31091c42c7d$var$Sentry) {
        if ((0, $22XrW.getEnvironment)() === 'development') return;
        $0370a31091c42c7d$var$Sentry = (parcelRequire("55apF")).then((SentryModule)=>{
            SentryModule.init({
                dsn: (0, $3X0xX.SENTRY_DSN),
                attachStacktrace: true,
                release: (0, $baU6C.PRODUCT_BUILD) || (0, $3X0xX.UNKNOWN_TAG),
                environment: (0, $22XrW.getEnvironment)(),
                beforeSend: $0370a31091c42c7d$var$beforeSend
            });
            return SentryModule;
        }).catch(()=>{
        // TODO: Retry mechanism for chunk loading failures?
        });
    }
    return $0370a31091c42c7d$var$Sentry;
};
module.exports["getSentryClient"] = $0370a31091c42c7d$export$f553e8b08ef59d31;

});

parcelRegister("baU6C", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ // @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $60ba9b041b400cde$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;
module.exports["PRODUCT_BUILD"] = $60ba9b041b400cde$export$668f31ea3127f48f;

});

parcelRegister("22XrW", function(module, exports) {
const $f363035d3386b96d$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $f363035d3386b96d$export$57570b1603cf6adb;

});

parcelRegister("55apF", function(module, exports) {

let $3b357f295bbe6b1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b357f295bbe6b1c$var$load("kT6dz"),
    $3b357f295bbe6b1c$var$load("aAWLw")
]).then(()=>parcelRequire('eieXD'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("c4BXr", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $6d93faa27bc9189b$export$786813d6840571a0 = ({ requestName: requestName, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered
            }
        }
    };
};
module.exports["onRequestCacheAccess"] = $6d93faa27bc9189b$export$786813d6840571a0;

});

parcelRegister("j1VvP", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/common/utils/network-task-tracker.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * The `task-names`/`vital-stats-events` modules referenced by the search-page
 * version live in search-page. To keep this helper self-contained inside
 * rovo-connectors-config (and free of cross-package cycles), we type the
 * task name as a plain `string` and accept the vital-stats event factories
 * (`onTaskStart` / `onTaskSuccess` / `onTaskFail`) implicitly via the
 * provided `fireAnalyticsEvent` callback — the caller in search-page builds
 * the events at the call site.
 */ 
var $8N8EQ = parcelRequire("8N8EQ");

/**
 * VitalStats event factories owned by this module. The vital-stats event wire
 * shape is part of the `useRovoConfig` contract with the VitalStats taxonomy,
 * not something each caller redefines — owning them here keeps every consumer
 * emitting the same shape and prevents drift between dashboards. Behaviour is
 * identical to search-page's `onTaskStart` / `onTaskSuccess` / `onTaskFail`
 * from `common/utils/events/vital-stats-events.ts`.
 */ const $58ebc13b05b74641$var$buildVitalStatsEvent = (action, { taskId: taskId, task: task, moreContext: moreContext })=>({
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                ...moreContext
            }
        }
    });
const $58ebc13b05b74641$export$656fa717a09eb821 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskStart', args);
const $58ebc13b05b74641$export$3e9761d670712e50 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskSuccess', args);
const $58ebc13b05b74641$export$2e311f5a2c70a936 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskFail', args);
const $58ebc13b05b74641$export$b551db3ea2671aa7 = (taskId, taskName, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent($58ebc13b05b74641$export$656fa717a09eb821({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent($58ebc13b05b74641$export$3e9761d670712e50({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent($58ebc13b05b74641$export$2e311f5a2c70a936({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};
module.exports["onTaskStart"] = $58ebc13b05b74641$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $58ebc13b05b74641$export$3e9761d670712e50;
module.exports["onTaskFail"] = $58ebc13b05b74641$export$2e311f5a2c70a936;
module.exports["createVitalStatsNetworkCallbacks"] = $58ebc13b05b74641$export$b551db3ea2671aa7;

});

parcelRegister("ioLQc", function(module, exports) {
/**
 * @file
 * RAOC-23: pure overlay that forces `userNeedsOAuth: false` onto the
 * `thirdPartyConfigs` by useRovoConfig. Designed to be supported by a
 * singleton store to track which products/datasources have been OAuth-connected.
 *
 * Extracted as a pure function (no React, no store) so it can be unit-tested in
 * isolation and shared by whichever shared-store implementation drives it. The
 * `isConnected` predicate is injected so the overlay does not couple to the
 * store mechanism (module singleton, react-sweet-state, etc.).
 */ const $c65a9fcd52aa8158$export$d10296f0916f2406 = (configs, isConnected, slackAdminAuthEnabled = false)=>{
    if (!configs) return configs;
    let next;
    for (const [productKey, config] of Object.entries(configs)){
        if (!config) continue;
        // Connectors with admin-level auth can surface results (e.g. public Slack
        // channels) without individual user OAuth – never gate them behind the
        // userNeedsOAuth banner.
        const isAdminAuthConnector = productKey === 'slack' && slackAdminAuthEnabled;
        if (isAdminAuthConnector && config.userNeedsOAuth !== false) {
            next = next ?? {
                ...configs
            };
            next[productKey] = {
                ...config,
                userNeedsOAuth: false,
                adminAuthOverrideApplied: true
            };
            continue;
        }
        const productConnected = isConnected(productKey);
        // Compute any datasource-level overrides first.
        let nextDatasources;
        if (config.datasources?.length) {
            let datasourcesChanged = false;
            const mapped = config.datasources.map((ds)=>{
                if (ds.userNeedsOAuth !== false && ds.datasourceId != null && isConnected(productKey, ds.datasourceId)) {
                    datasourcesChanged = true;
                    return {
                        ...ds,
                        userNeedsOAuth: false
                    };
                }
                return ds;
            });
            if (datasourcesChanged) nextDatasources = mapped;
        }
        const needsProductFlip = productConnected && config.userNeedsOAuth !== false;
        if (!needsProductFlip && !nextDatasources) continue;
        const nextConfig = {
            ...config,
            ...needsProductFlip ? {
                userNeedsOAuth: false
            } : {},
            ...nextDatasources ? {
                datasources: nextDatasources
            } : {}
        };
        next = next ?? {
            ...configs
        };
        next[productKey] = nextConfig;
    }
    return next ?? configs;
};
module.exports["applyOAuthOverrides"] = $c65a9fcd52aa8158$export$d10296f0916f2406;

});

parcelRegister("dfngu", function(module, exports) {
/**
 * @file
 * RAOC-22: pure derivation of the accessible product/noun list (plus the
 * third-party configs) from the resolved combined-config responses.
 *
 * Extracted as a pure function (no React, no store) so it can be:
 * - invoked SYNCHRONOUSLY the moment the config resolves — publishing the
 *   products in the same commit that sets the config responses, instead of
 *   waiting for a second effect → render → commit round-trip; and
 * - unit-tested in isolation.
 *
 * The `> 0` townsquare noun threshold and the Rovo-enabled third-party branch
 * are intentionally preserved so behaviour is identical to the previous
 * (effect-based) derivation.
 */ 
var $9XgN6 = parcelRequire("9XgN6");

const $eadc8c31d60ff198$export$c3e3f58dafc92679 = (firstPartyResponse, combinedThirdPartyResponse, cloudIdProp)=>{
    const allAccessibleProducts = [];
    const firstPartyProducts = [
        ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
            const { id: id } = resource;
            const match = id.match((0, $9XgN6.EXTRACT_PRODUCT_FROM_ARI));
            if (match && match.length >= 2 && match[1]) return [
                match[1]
            ];
            return [];
        }))
    ];
    allAccessibleProducts.push(...firstPartyProducts);
    const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
        const { id: id } = resource;
        const match = id.match((0, $9XgN6.EXTRACT_PRODUCT_FROM_ARI));
        if (match && match.length >= 2 && (match[1] === 'project' || match[1] === 'goal')) return [
            match[1]
        ];
        return [];
    });
    // If nouns are available we also add Townsquare to the list of accessible products.
    if (accessibleNouns.length > 0) allAccessibleProducts.push('townsquare');
    const doesUserHaveRovo = (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
    if (doesUserHaveRovo) {
        const thirdPartyProductKeys = combinedThirdPartyResponse.productKeys || [];
        allAccessibleProducts.push(...thirdPartyProductKeys);
        return {
            products: allAccessibleProducts,
            nouns: accessibleNouns,
            thirdPartyConfigs: combinedThirdPartyResponse.thirdPartyConfigs
        };
    }
    return {
        products: allAccessibleProducts,
        nouns: accessibleNouns,
        thirdPartyConfigs: {}
    };
};
module.exports["deriveAccessibleProductsConfig"] = $eadc8c31d60ff198$export$c3e3f58dafc92679;

});

parcelRegister("2rf9w", function(module, exports) {
/**
 * @file
 * RAOC-23: shared, in-tab OAuth-override store backing the "singleton" semantics
 * of {@link useRovoConfig}.
 *
 * ## Why this exists
 *
 * Multiple independent components may each call `useRovoConfig` (it is widely
 * shared and intentionally cheap to re-call). Each call is its own React hook
 * instance with its own `accessibleProductsConfig` state. When one instance's
 * `onOAuthSuccess` fires, it would only update *that* instance — so a connector
 * list rendered by a *different* instance would never reflect the new
 * `userNeedsOAuth: false` and would keep showing the connector as not connected.
 *
 * This module is a tiny global store of "products (optionally
 * datasources) that the user has just OAuth-connected, per cloudId". It is
 * written by `onOAuthSuccess` and **subscribed to by every `useRovoConfig`
 * instance** (via `useSyncExternalStore`). Instances overlay it onto their
 * derived `thirdPartyConfigs`, so a single OAuth success becomes reactively
 * visible across **all** instances — i.e. `useRovoConfig` behaves as a singleton
 * with respect to OAuth success actions.
 *
 * It is an **additive overlay**: it only ever forces `userNeedsOAuth` to
 * `false`. It never removes a connection and never fabricates a connector. On a
 * full reload the in-memory set is empty, but the persisted runtime cache
 * (`updateBaseCombinedConfigCacheEntry`) already re-derives the connected state,
 * so reload remains correct without this store. Or rather, persisting across reloads
 * is not the role of this store, we lean on the config/BE caching for that.
 *
 * Later improvements could layer a LS key set/subscribe here to persist into other tabs.
 */ const $78251dd6557baa84$var$SENTINEL_VALUE = '\u0000product'; // \u0000 is unicode <NUL>
/**
 * Generate a unique key for a product (optionally a specific datasource) in a
 * given cloud. The sentinel is used for whole-product entries (no datasource).
 *
 * e.g.
 * - without datasource: 	abc-cloud<NUL>amplitude<NUL><NUL>product
 * - with datasource: 		abc-cloud<NUL>amplitude<NUL>cf41ec6c-d2a1-30fd-be10-3eb26e28d71c
 */ const $78251dd6557baa84$var$makeKey = (cloudId, product, datasourceId)=>`${cloudId}\u0000${product}\u0000${datasourceId ?? $78251dd6557baa84$var$SENTINEL_VALUE}`;
/** Set of `${cloudId}\0${product}\0${datasourceId|sentinel}` entries. */ const $78251dd6557baa84$var$connected = new Set();
/** Subscribers (one per mounted `useRovoConfig` instance). */ const $78251dd6557baa84$var$listeners = new Set();
/**
 * Monotonic version counter used as the `useSyncExternalStore` snapshot. A new
 * value is returned whenever the set changes, which is what triggers subscribed
 * components to re-render. (We expose a primitive version rather than the Set
 * itself so the snapshot is referentially stable between unrelated renders.)
 */ let $78251dd6557baa84$var$version = 0;
const $78251dd6557baa84$export$dbe98d1c08f0f87d = (onStoreChange)=>{
    $78251dd6557baa84$var$listeners.add(onStoreChange);
    return ()=>{
        $78251dd6557baa84$var$listeners.delete(onStoreChange);
    };
};
const $78251dd6557baa84$export$6a79912ef915aaf2 = ()=>$78251dd6557baa84$var$version;
const $78251dd6557baa84$export$deca34c5919575a8 = (cloudId, product, datasourceId)=>{
    const key = $78251dd6557baa84$var$makeKey(cloudId, product, datasourceId);
    if ($78251dd6557baa84$var$connected.has(key)) return;
    $78251dd6557baa84$var$connected.add(key);
    $78251dd6557baa84$var$version++;
    $78251dd6557baa84$var$listeners.forEach((listener)=>listener());
};
const $78251dd6557baa84$export$e22c9249ea1d8d39 = (cloudId, product, datasourceId)=>$78251dd6557baa84$var$connected.has($78251dd6557baa84$var$makeKey(cloudId, product, datasourceId));
const $78251dd6557baa84$export$d6e8588579be44ec = (cloudId)=>{
    if ($78251dd6557baa84$var$connected.size === 0) return false;
    const prefix = `${cloudId}\u0000`;
    for (const key of $78251dd6557baa84$var$connected){
        if (key.startsWith(prefix)) return true;
    }
    return false;
};
const $78251dd6557baa84$export$9d21dc5f8e25d00f = ()=>{
    $78251dd6557baa84$var$connected.clear();
    $78251dd6557baa84$var$listeners.clear();
    $78251dd6557baa84$var$version = 0;
};
module.exports["subscribeToOAuthOverrides"] = $78251dd6557baa84$export$dbe98d1c08f0f87d;
module.exports["getOAuthOverridesVersion"] = $78251dd6557baa84$export$6a79912ef915aaf2;
module.exports["markOAuthConnected"] = $78251dd6557baa84$export$deca34c5919575a8;
module.exports["isOAuthConnected"] = $78251dd6557baa84$export$e22c9249ea1d8d39;
module.exports["hasAnyOAuthOverrideForCloud"] = $78251dd6557baa84$export$d6e8588579be44ec;

});

parcelRegister("f4zze", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $955d6a3eafdfc84c$var$initialState = {
    siteId: undefined
};
const $955d6a3eafdfc84c$export$8bbd526186d37358 = (0, $8s9DV.createStore)({
    name: 'rovoConfigSiteIdStore',
    initialState: $955d6a3eafdfc84c$var$initialState,
    actions: {
        setSiteId: (siteId)=>({ getState: getState, setState: setState })=>{
                // Only re-render consumers when the tenant actually changes.
                if (getState().siteId === siteId) return;
                setState({
                    siteId: siteId
                });
            }
    }
});
const $955d6a3eafdfc84c$export$f6673eaeb9b549fc = (0, $kBr4q.createStateHook)($955d6a3eafdfc84c$export$8bbd526186d37358, {
    selector: (state)=>state.siteId
});
const $955d6a3eafdfc84c$var$useSiteIdActions = (0, $kBr4q.createActionsHook)($955d6a3eafdfc84c$export$8bbd526186d37358);
const $955d6a3eafdfc84c$export$8b2b764904b0a042 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { setSiteId: setSiteId } = $955d6a3eafdfc84c$var$useSiteIdActions();
    return setSiteId;
} : ()=>{
    const { setSiteId: setSiteId } = $955d6a3eafdfc84c$var$useSiteIdActions();
    return setSiteId;
};
module.exports["useRovoConfigSiteId"] = $955d6a3eafdfc84c$export$f6673eaeb9b549fc;
module.exports["useCaptureRovoConfigSiteId"] = $955d6a3eafdfc84c$export$8b2b764904b0a042;

});

parcelRegister("ekfm7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $lJ6db = parcelRequire("lJ6db");


var $7pCWA = parcelRequire("7pCWA");

const $a58bea70580ad845$export$fdb92ee0ff9f2fc7 = (0, $lJ6db.createHookWithAssistanceService)(({ agentCreatorType: agentCreatorType, enabled: enabled = true, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } })=>{
    const [{ hasFetchAttempted: hasFetchAttempted, isFetching: isFetching }] = (0, $7pCWA.useKnowledgeSourcesStore)();
    const { fetchIfEmpty: fetchIfEmpty } = (0, $7pCWA.useKnowledgeSourcesActions)();
    const fetcher = (0, $cozmU.useCallback)(async ()=>{
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE,
            name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE
        });
        try {
            const response = await assistanceService.getAgentKnowledgeConfiguration(agentCreatorType);
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE
            });
            return response;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    }, [
        agentCreatorType,
        assistanceService,
        experienceTracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && !hasFetchAttempted && !isFetching) fetchIfEmpty(fetcher, siteId);
    }, [
        enabled,
        hasFetchAttempted,
        isFetching,
        fetchIfEmpty,
        fetcher,
        siteId
    ]);
});
module.exports["useEnsureConnectorsLoaded"] = $a58bea70580ad845$export$fdb92ee0ff9f2fc7;

});


//# sourceMappingURL=provider.cda49d8f.js.map
